(() => {
  const root = document.querySelector('[data-green-badge-assistant]');
  if (!root) return;

  const GB_ASSISTANT_VERSION = 'V7.1.3 Beta';
  const RULES = window.GreenBadgeAssistantRules || {};
  const ZONES = window.GreenBadgeZones || { zones: [], dataVersion: '' };


  let deferredPwaInstallPrompt = null;
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    deferredPwaInstallPrompt = event;
  });
  window.addEventListener('appinstalled', () => {
    try { window.localStorage.setItem('gbaPwaInstalled', '1'); } catch (error) {}
    sendPwaTrackingEvent('installed_chromium');
    const card = root.querySelector('[data-pwa-install-card]');
    if (card) card.remove();
  });

  // V6.1.5: Kompakter Fallback-Ortsbestand direkt in gb.js.
  // Dadurch werden Entfernungen auch angezeigt, falls gb-places.js im Theme noch nicht geladen oder vergessen wurde.
  const GB_PLACE_FALLBACKS = [
  {
    "name": "Nürnberg",
    "state": "Bayern",
    "lat": 49.4521,
    "lng": 11.0767,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Nuernberg",
      "Nuremberg"
    ]
  },
  {
    "name": "Fürth",
    "state": "Bayern",
    "lat": 49.4771,
    "lng": 10.9887,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Fuerth"
    ]
  },
  {
    "name": "Erlangen",
    "state": "Bayern",
    "lat": 49.5897,
    "lng": 11.0119,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Bamberg",
    "state": "Bayern",
    "lat": 49.8917,
    "lng": 10.886,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Würzburg",
    "state": "Bayern",
    "lat": 49.7913,
    "lng": 9.9534,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Wuerzburg",
      "Wurzburg"
    ]
  },
  {
    "name": "Ingolstadt",
    "state": "Bayern",
    "lat": 48.7665,
    "lng": 11.4258,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Passau",
    "state": "Bayern",
    "lat": 48.5667,
    "lng": 13.4319,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Bayreuth",
    "state": "Bayern",
    "lat": 49.9456,
    "lng": 11.5713,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Landshut",
    "state": "Bayern",
    "lat": 48.5442,
    "lng": 12.1469,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Füssen",
    "state": "Bayern",
    "lat": 47.5696,
    "lng": 10.7004,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Fuessen",
      "Neuschwanstein"
    ]
  },
  {
    "name": "Garmisch-Partenkirchen",
    "state": "Bayern",
    "lat": 47.4921,
    "lng": 11.0958,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Garmisch"
    ]
  },
  {
    "name": "Berchtesgaden",
    "state": "Bayern",
    "lat": 47.6324,
    "lng": 13.0012,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Rothenburg ob der Tauber",
    "state": "Bayern",
    "lat": 49.3802,
    "lng": 10.1867,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Rothenburg"
    ]
  },
  {
    "name": "Hamburg",
    "state": "Hamburg",
    "lat": 53.5511,
    "lng": 9.9937,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Kiel",
    "state": "Schleswig-Holstein",
    "lat": 54.3233,
    "lng": 10.1228,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Lübeck",
    "state": "Schleswig-Holstein",
    "lat": 53.8655,
    "lng": 10.6866,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Luebeck",
      "Lubeck"
    ]
  },
  {
    "name": "Flensburg",
    "state": "Schleswig-Holstein",
    "lat": 54.7937,
    "lng": 9.4469,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Sylt",
    "state": "Schleswig-Holstein",
    "lat": 54.9079,
    "lng": 8.3036,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Westerland"
    ]
  },
  {
    "name": "Rostock",
    "state": "Mecklenburg-Vorpommern",
    "lat": 54.0924,
    "lng": 12.0991,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Schwerin",
    "state": "Mecklenburg-Vorpommern",
    "lat": 53.6355,
    "lng": 11.4012,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Stralsund",
    "state": "Mecklenburg-Vorpommern",
    "lat": 54.3091,
    "lng": 13.0818,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Rügen",
    "state": "Mecklenburg-Vorpommern",
    "lat": 54.4,
    "lng": 13.4,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Ruegen",
      "Binz"
    ]
  },
  {
    "name": "Hannover",
    "state": "Niedersachsen",
    "lat": 52.3759,
    "lng": 9.732,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Hanover"
    ]
  },
  {
    "name": "Braunschweig",
    "state": "Niedersachsen",
    "lat": 52.2689,
    "lng": 10.5268,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Oldenburg",
    "state": "Niedersachsen",
    "lat": 53.1435,
    "lng": 8.2146,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Göttingen",
    "state": "Niedersachsen",
    "lat": 51.5413,
    "lng": 9.9158,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Goettingen",
      "Gottingen"
    ]
  },
  {
    "name": "Hildesheim",
    "state": "Niedersachsen",
    "lat": 52.1548,
    "lng": 9.9579,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Cuxhaven",
    "state": "Niedersachsen",
    "lat": 53.8593,
    "lng": 8.6879,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Potsdam",
    "state": "Brandenburg",
    "lat": 52.3906,
    "lng": 13.0645,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Cottbus",
    "state": "Brandenburg",
    "lat": 51.7563,
    "lng": 14.3329,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Brandenburg an der Havel",
    "state": "Brandenburg",
    "lat": 52.4125,
    "lng": 12.5316,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Brandenburg"
    ]
  },
  {
    "name": "Frankfurt (Oder)",
    "state": "Brandenburg",
    "lat": 52.3472,
    "lng": 14.5506,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Frankfurt Oder",
      "Frankfurt/Oder"
    ]
  },
  {
    "name": "Dresden",
    "state": "Sachsen",
    "lat": 51.0504,
    "lng": 13.7373,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Chemnitz",
    "state": "Sachsen",
    "lat": 50.8278,
    "lng": 12.9214,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Zwickau",
    "state": "Sachsen",
    "lat": 50.7189,
    "lng": 12.4961,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Görlitz",
    "state": "Sachsen",
    "lat": 51.1523,
    "lng": 14.9872,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Goerlitz",
      "Gorlitz"
    ]
  },
  {
    "name": "Erfurt",
    "state": "Thüringen",
    "lat": 50.9848,
    "lng": 11.0299,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Jena",
    "state": "Thüringen",
    "lat": 50.9271,
    "lng": 11.5892,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Weimar",
    "state": "Thüringen",
    "lat": 50.9795,
    "lng": 11.3235,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Eisenach",
    "state": "Thüringen",
    "lat": 50.9807,
    "lng": 10.3152,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Wartburg"
    ]
  },
  {
    "name": "Mainz",
    "state": "Rheinland-Pfalz",
    "lat": 49.9929,
    "lng": 8.2473,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Koblenz",
    "state": "Rheinland-Pfalz",
    "lat": 50.3569,
    "lng": 7.589,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Trier",
    "state": "Rheinland-Pfalz",
    "lat": 49.7499,
    "lng": 6.6371,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Kaiserslautern",
    "state": "Rheinland-Pfalz",
    "lat": 49.4401,
    "lng": 7.7491,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Cochem",
    "state": "Rheinland-Pfalz",
    "lat": 50.145,
    "lng": 7.1664,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Rüdesheim am Rhein",
    "state": "Hessen",
    "lat": 49.9789,
    "lng": 7.9244,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Ruedesheim",
      "Rüdesheim",
      "Rudesheim"
    ]
  },
  {
    "name": "Mannheim",
    "state": "Baden-Württemberg",
    "lat": 49.4875,
    "lng": 8.466,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Karlsruhe",
    "state": "Baden-Württemberg",
    "lat": 49.0069,
    "lng": 8.4037,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Freiburg im Breisgau",
    "state": "Baden-Württemberg",
    "lat": 47.999,
    "lng": 7.8421,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Freiburg"
    ]
  },
  {
    "name": "Heidelberg",
    "state": "Baden-Württemberg",
    "lat": 49.3988,
    "lng": 8.6724,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Ulm",
    "state": "Baden-Württemberg",
    "lat": 48.4011,
    "lng": 9.9876,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Baden-Baden",
    "state": "Baden-Württemberg",
    "lat": 48.7606,
    "lng": 8.2398,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Baden Baden"
    ]
  },
  {
    "name": "Tübingen",
    "state": "Baden-Württemberg",
    "lat": 48.5216,
    "lng": 9.0576,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Tuebingen",
      "Tubingen"
    ]
  },
  {
    "name": "Konstanz",
    "state": "Baden-Württemberg",
    "lat": 47.6779,
    "lng": 9.1732,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Constance"
    ]
  },
  {
    "name": "Friedrichshafen",
    "state": "Baden-Württemberg",
    "lat": 47.65,
    "lng": 9.48,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Lindau",
    "state": "Bayern",
    "lat": 47.5442,
    "lng": 9.6839,
    "type": "tourism",
    "hasZone": false,
    "aliases": [
      "Lindau Bodensee"
    ]
  },
  {
    "name": "Meersburg",
    "state": "Baden-Württemberg",
    "lat": 47.6942,
    "lng": 9.2711,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Saarbrücken",
    "state": "Saarland",
    "lat": 49.2402,
    "lng": 6.9969,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Saarbruecken",
      "Saarbrucken"
    ]
  },
  {
    "name": "Kassel",
    "state": "Hessen",
    "lat": 51.3127,
    "lng": 9.4797,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Gießen",
    "state": "Hessen",
    "lat": 50.5841,
    "lng": 8.6784,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Giessen"
    ]
  },
  {
    "name": "Fulda",
    "state": "Hessen",
    "lat": 50.5558,
    "lng": 9.6808,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Rüsselsheim",
    "state": "Hessen",
    "lat": 49.9885,
    "lng": 8.4215,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Ruesselsheim",
      "Russelsheim"
    ]
  },
  {
    "name": "Wetzlar",
    "state": "Hessen",
    "lat": 50.5611,
    "lng": 8.5049,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Bielefeld",
    "state": "Nordrhein-Westfalen",
    "lat": 52.0302,
    "lng": 8.5325,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Paderborn",
    "state": "Nordrhein-Westfalen",
    "lat": 51.7189,
    "lng": 8.7575,
    "type": "city",
    "hasZone": false,
    "aliases": []
  },
  {
    "name": "Düren",
    "state": "Nordrhein-Westfalen",
    "lat": 50.8043,
    "lng": 6.492,
    "type": "city",
    "hasZone": false,
    "aliases": [
      "Dueren",
      "Duren"
    ]
  },
  {
    "name": "Winterberg",
    "state": "Nordrhein-Westfalen",
    "lat": 51.192,
    "lng": 8.5348,
    "type": "tourism",
    "hasZone": false,
    "aliases": []
  }
];

  const loadedPlaces = window.GreenBadgePlaces || {};
  const PLACES = {
    dataVersion: loadedPlaces.dataVersion || 'V6.1.5 Fallbackdaten 15.07.2026',
    source: loadedPlaces.source || 'Lokaler Fallback in gb.js',
    places: Array.isArray(loadedPlaces.places) && loadedPlaces.places.length ? loadedPlaces.places : GB_PLACE_FALLBACKS
  };
  const localeRaw = (window.GreenBadgeAssistantSettings?.locale || document.documentElement.lang || 'de').toLowerCase();
  const locale = localeRaw.slice(0, 2);

  const T = {
    de: {
      'trust.orders':'✓ Über 100.000 erfolgreich abgewickelte Bestellungen','trust.shipping':'▱ Versand innerhalb eines Werktages','trust.official':'◇ Umweltplaketten nach der 35. BImSchV',
      'hero.eyebrow':'Kostenlose Fahrzeugprüfung','hero.title':'Ihre Umweltplakette<br>für <span>Deutschland</span>','hero.subtitle':'Finden Sie in weniger als einer Minute heraus, welche Umweltplakette für Ihr Fahrzeug erteilt werden kann.',
      'steps.country':'Land','steps.vehicle':'Fahrzeug','steps.fuel':'Antrieb','steps.data':'Daten','steps.result':'Ergebnis','buttons.next':'Weiter','buttons.back':'Zurück','buttons.view_product':'Produkt ansehen','buttons.restart':'Neue Prüfung starten ↻',
      'q.country.title':'1. Bitte wählen Sie Ihr Land aus','q.country.sub':'Wo ist Ihr Fahrzeug zugelassen?','q.vehicle.title':'2. Welches Fahrzeug möchten Sie prüfen?','q.vehicle.sub':'Wählen Sie die Fahrzeugart so aus, wie Sie Ihr Fahrzeug kennen. Die Entscheidung erfolgt später nach den relevanten Fahrzeugdaten.','q.fuel.title':'3. Welchen Antrieb hat Ihr Fahrzeug?','q.fuel.sub':'Der Antrieb ist entscheidend für die Einstufung.','q.de.title':'4. Emissionsschlüsselnummer','q.de.sub':'Bitte geben Sie die vollständige Emissionsschlüsselnummer ein, zum Beispiel 0433, 0460, 04A0 oder 06ZA.','q.foreign.title':'4. Euroklasse oder Erstzulassung','q.foreign.sub':'Falls die Euroklasse nicht bekannt ist, reicht für eine erste Einschätzung die Erstzulassung.','q.pm.title':'4. Partikelfilter / PM-Stufe','q.pm.sub':'Ihr Diesel erreicht ohne Filter voraussichtlich keine grüne Plakette. Falls ein Partikelfilter nachgerüstet wurde, wählen Sie bitte die nachgewiesene PM-Stufe.',
      'field.euro':'Euroklasse','field.firstReg':'Erstzulassung','field.pm':'Nachgewiesene PM-Stufe','hint.de':'Bitte die vollständige Emissionsschlüsselnummer aus Feld 14.1 eingeben. Bei neueren Fahrzeugen können die letzten beiden Stellen auch Buchstaben enthalten, z. B. 04A0 oder 06ZA.','hint.foreign':'Wenn keine Euroklasse bekannt ist, wählen Sie „Nicht bekannt“ und geben Sie die Erstzulassung ein.','hint.pm':'Wenn Sie die PM-Stufe nicht kennen, empfehlen wir eine manuelle Prüfung mit Fahrzeugschein bzw. Nachweis.','notice.electric':'Ihr Fahrzeug wird direkt geprüft.','notice.electric.sub':'Für reine Elektro- oder Wasserstofffahrzeuge ist keine Emissionsschlüsselnummer und keine Euroklasse erforderlich.','summary.input':'Ihre Eingabe','summary.emission':'Emissionsschlüsselnummer','summary.base':'Vorläufiges Ergebnis ohne Filter',
      'error.emission':'Bitte geben Sie die vierstellige Emissionsschlüsselnummer ein. Buchstaben sind möglich, z. B. 04A0 oder 06ZA.','error.foreign':'Bitte wählen Sie eine Euroklasse oder geben Sie die Erstzulassung an.',
      'result.label':'Ihr Ergebnis','result.green.heading':'Ihr Fahrzeug benötigt diese <span>Umweltplakette:</span>','result.green.reason':'Diese Bewertung basiert auf Ihren Angaben und den hinterlegten Umweltplaketten-Regeln.','result.manual.heading':'Manuelle Prüfung empfohlen','result.manual.reason':'Die Angaben reichen für eine eindeutige automatische Entscheidung noch nicht aus. Bitte prüfen Sie den Fahrzeugschein bzw. einen Nachweis.','result.foreignDieselManual':'Für Diesel-Fahrzeuge unter Euro 4 bzw. vor dem maßgeblichen Erstzulassungsdatum empfehlen wir eine manuelle Prüfung. Eine Partikelfilternachrüstung ist im Ausland häufig nicht eindeutig eingetragen.','result.noGreen.heading':'Keine grüne Umweltplakette möglich','result.noGreen.reason':'Nach den angegebenen Daten ergibt sich {badge}. Daher wird kein Link zur grünen Plakette angezeigt.','result.noBadge.heading':'Keine Umweltplakette erforderlich','result.motorcycle':'Für Motorräder wird keine Umweltplakette ausgegeben.','result.oldtimer':'Historische Fahrzeuge mit H-Kennzeichen oder rotem 07-Kennzeichen benötigen keine Umweltplakette.',
      'products.green.title':'Grüne Umweltplakette','products.green.subtitle':'für Deutschland','products.blue.title':'Blaue Umweltplakette','products.blue.subtitle':'(E-Plakette)','products.tax':'inkl. MwSt.','products.green.b1':'Offiziell für Umweltzonen in Deutschland','products.green.b2':'Schnelle Bearbeitung und Versand innerhalb eines Werktages','products.green.b3':'Hochwertige Qualität – Made in Germany','products.blue.b1':'Für Fahrzeuge mit Elektroantrieb','products.blue.b2':'Offiziell für Umweltzonen in Deutschland','products.blue.b3':'Schnelle Bearbeitung und Versand innerhalb eines Werktages',
      'reviews.title.prefix':'Über','reviews.title.suffix':'Kunden vertrauen uns','reviews.heading':'Warum bereits über 100.000 Kunden uns vertrauen','reviews.subtitle':'Erfahrung, geprüfte Unterlagen und echte Kundenbewertungen geben Sicherheit bei der Bestellung.','reviews.google_title':'Google Kundenbewertungen','reviews.shopvote_title':'ShopVote Kundenbewertungen','reviews.facts_title':'Unsere Erfahrung','reviews.b1':'Über 100.000 erfolgreich bearbeitete Bestellungen','reviews.b2':'Schnelle Bearbeitung und Versand innerhalb eines Werktages','reviews.b3':'Umweltplaketten nach der 35. BImSchV','reviews.b4':'Made in Germany','reviews.b5':'Mehrsprachiger Fahrzeug-Assistent für Europa',
      'label.green':'grüne Plakette','label.yellow':'gelbe Plakette','label.red':'rote Plakette','label.none':'keine Plakette','label.manual':'manuelle Prüfung',
      'country.DE':'Deutschland','country.CH':'Schweiz','country.NL':'Niederlande','country.BE':'Belgien','country.FR':'Frankreich','country.IT':'Italien','country.PL':'Polen','country.CZ':'Tschechien','country.DK':'Dänemark','country.AT':'Österreich','country.LU':'Luxemburg','country.GB':'Großbritannien','country.OTHER':'Anderes Land',
      'vehicle.car':'Pkw','vehicle.camper':'Wohnmobil','vehicle.van':'Transporter','vehicle.truck':'Lkw','vehicle.bus':'Bus','vehicle.motorcycle':'Motorrad','vehicle.oldtimer':'Oldtimer',
      'fuel.petrol':'Benzin','fuel.diesel':'Diesel','fuel.electric':'Elektro','fuel.phev':'Plug-in Hybrid','fuel.hybrid':'Hybrid','fuel.gas':'Gas','fuel.hydrogen':'Wasserstoff','fuel.unknown':'Nicht sicher',
      'euro.e6':'Euro 6','euro.e5':'Euro 5','euro.e4':'Euro 4','euro.e3':'Euro 3','euro.e2':'Euro 2','euro.e1':'Euro 1','euro.unknown':'Nicht bekannt',
      'pm.unknown':'Nicht bekannt','pm.none':'Kein Partikelfilter','pm.pm01':'PM 01','pm.pm0':'PM 0','pm.pm1':'PM 1','pm.pm2':'PM 2','pm.pm3':'PM 3','pm.pm4':'PM 4','pm.pm5':'PM 5'
    },
    en: {
      'trust.orders':'✓ More than 100,000 successfully processed orders','trust.shipping':'▱ Dispatch within one working day','trust.official':'◇ Environmental stickers pursuant to Section 5 of the 35th BImSchV',
      'hero.eyebrow':'Free vehicle check','hero.title':'Your environmental sticker<br>for <span>Germany</span>','hero.subtitle':'Find out in less than one minute which German environmental sticker your vehicle needs.',
      'steps.country':'Country','steps.vehicle':'Vehicle','steps.fuel':'Drive','steps.data':'Data','steps.result':'Result','buttons.next':'Continue','buttons.back':'Back','buttons.view_product':'View product','buttons.restart':'Start new check ↻',
      'q.country.title':'1. Please select your country','q.country.sub':'Where is your vehicle registered?','q.vehicle.title':'2. Which vehicle would you like to check?','q.vehicle.sub':'Choose the vehicle type as you know it. The decision is based on the relevant vehicle data.','q.fuel.title':'3. What drive type does your vehicle use?','q.fuel.sub':'The drive type is important for the classification.','q.de.title':'4. Emission key number','q.de.sub':'Please enter the complete emission key number, e.g. 0433, 0460, 04A0 or 06ZA.','q.foreign.title':'4. Euro class or first registration','q.foreign.sub':'If the Euro class is unknown, first registration is sufficient for an initial assessment.','q.pm.title':'4. Particulate filter / PM level','q.pm.sub':'Your diesel vehicle will probably not receive a green sticker without a filter. If a filter was retrofitted, select the proven PM level.',
      'field.euro':'Euro class','field.firstReg':'First registration','field.pm':'Proven PM level','hint.de':'Enter the complete emission key from field 14.1. For newer vehicles, the last two characters may also be letters, e.g. 04A0 or 06ZA.','hint.foreign':'If the Euro class is unknown, select “Unknown” and enter the first registration date.','hint.pm':'If you do not know the PM level, we recommend manual verification with registration document or proof.','notice.electric':'Your vehicle will be checked directly.','notice.electric.sub':'Pure electric or hydrogen vehicles do not require an emission key number or Euro class.','summary.input':'Your input','summary.emission':'Emission key number','summary.base':'Preliminary result without filter',
      'error.emission':'Please enter the four-character emission key number. Letters are possible, e.g. 04A0 or 06ZA.','error.foreign':'Please select a Euro class or enter the first registration date.',
      'result.label':'Your result','result.green.heading':'Your vehicle needs this <span>environmental sticker:</span>','result.green.reason':'This assessment is based on your information and the stored environmental sticker rules.','result.manual.heading':'Manual verification recommended','result.manual.reason':'The information is not sufficient for a clear automatic decision. Please check the registration document or proof.','result.foreignDieselManual':'For diesel vehicles below Euro 4 or before the relevant first-registration date, we recommend manual verification. Retrofitted particulate filters are often not clearly recorded abroad.','result.noGreen.heading':'No green environmental sticker possible','result.noGreen.reason':'Based on the data provided, the result is {badge}. Therefore no link to the green sticker is shown.','result.noBadge.heading':'No environmental sticker required','result.motorcycle':'No environmental sticker is issued for motorcycles.','result.oldtimer':'Historic vehicles with H registration or red 07 registration do not require an environmental sticker.',
      'products.green.title':'Green environmental sticker','products.green.subtitle':'for Germany','products.blue.title':'Blue E-sticker','products.blue.subtitle':'for electric vehicles','products.tax':'incl. VAT','products.green.b1':'Official for low-emission zones in Germany','products.green.b2':'Fast processing and dispatch within one working day','products.green.b3':'High quality – Made in Germany','products.blue.b1':'For vehicles with electric drive','products.blue.b2':'Official for low-emission zones in Germany','products.blue.b3':'Fast processing and dispatch within one working day',
      'reviews.title.prefix':'More than','reviews.title.suffix':'customers trust us','reviews.heading':'Why more than 100,000 customers trust us','reviews.subtitle':'Experience, checked documents and genuine customer reviews provide confidence when ordering.','reviews.google_title':'Google customer reviews','reviews.shopvote_title':'ShopVote customer reviews','reviews.facts_title':'Our experience','reviews.b1':'More than 100,000 successfully processed orders','reviews.b2':'Fast processing and dispatch within one working day','reviews.b3':'Environmental stickers pursuant to Section 5 of the 35th BImSchV','reviews.b4':'Made in Germany','reviews.b5':'Multilingual vehicle assistant for Europe',
      'label.green':'green sticker','label.yellow':'yellow sticker','label.red':'red sticker','label.none':'no sticker','label.manual':'manual verification',
      'country.DE':'Germany','country.CH':'Switzerland','country.NL':'Netherlands','country.BE':'Belgium','country.FR':'France','country.IT':'Italy','country.PL':'Poland','country.CZ':'Czechia','country.DK':'Denmark','country.AT':'Austria','country.LU':'Luxembourg','country.GB':'United Kingdom','country.OTHER':'Other country',
      'vehicle.car':'Car','vehicle.camper':'Motorhome','vehicle.van':'Van','vehicle.truck':'Truck','vehicle.bus':'Bus','vehicle.motorcycle':'Motorcycle','vehicle.oldtimer':'Classic car','fuel.petrol':'Petrol','fuel.diesel':'Diesel','fuel.electric':'Electric','fuel.phev':'Plug-in hybrid','fuel.hybrid':'Hybrid','fuel.gas':'Gas','fuel.hydrogen':'Hydrogen','fuel.unknown':'Not sure','euro.unknown':'Unknown','pm.unknown':'Unknown','pm.none':'No particulate filter'
    },
    nl: {
      'trust.orders':'✓ Meer dan 100.000 succesvol afgehandelde bestellingen','trust.shipping':'▱ Verzending binnen één werkdag','trust.official':'◇ Milieustickers volgens de 35e BImSchV',
      'hero.eyebrow':'Gratis voertuigcontrole','hero.title':'Uw milieusticker<br>voor <span>Duitsland</span>','hero.subtitle':'Ontdek in minder dan één minuut welke Duitse milieusticker uw voertuig nodig heeft.',
      'steps.country':'Land','steps.vehicle':'Voertuig','steps.fuel':'Aandrijving','steps.data':'Gegevens','steps.result':'Resultaat','buttons.next':'Verder','buttons.back':'Terug','buttons.view_product':'Product bekijken','buttons.restart':'Nieuwe controle starten ↻',
      'q.country.title':'1. Kies uw land','q.country.sub':'Waar is uw voertuig geregistreerd?','q.vehicle.title':'2. Welk voertuig wilt u controleren?','q.vehicle.sub':'Kies het voertuigtype zoals u het kent. De beslissing wordt gebaseerd op de relevante voertuiggegevens.','q.fuel.title':'3. Welke aandrijving heeft uw voertuig?','q.fuel.sub':'De aandrijving is belangrijk voor de indeling.','q.de.title':'4. Emissiesleutelnummer','q.de.sub':'Voer het volledige emissiesleutelnummer in, bijvoorbeeld 0433, 0460, 04A0 of 06ZA.','q.foreign.title':'4. Euroklasse of eerste toelating','q.foreign.sub':'Als de Euroklasse onbekend is, volstaat de eerste toelating voor een eerste inschatting.','q.pm.title':'4. Roetfilter / PM-niveau','q.pm.sub':'Uw diesel krijgt zonder filter waarschijnlijk geen groene sticker. Als er een filter is achteraf ingebouwd, kies dan het bewezen PM-niveau.',
      'field.euro':'Euroklasse','field.firstReg':'Eerste toelating','field.pm':'Bewezen PM-niveau','hint.de':'Voer de volledige emissiesleutel uit veld 14.1 in. Bij nieuwere voertuigen kunnen de laatste twee tekens ook letters zijn, bijv. 04A0 of 06ZA.','hint.foreign':'Als de Euroklasse onbekend is, kies “Onbekend” en voer de datum van eerste toelating in.','hint.pm':'Als u het PM-niveau niet kent, raden wij handmatige controle met kentekenbewijs of bewijs aan.','notice.electric':'Uw voertuig wordt direct gecontroleerd.','notice.electric.sub':'Voor volledig elektrische of waterstofvoertuigen is geen emissiesleutelnummer of Euroklasse nodig.','summary.input':'Uw invoer','summary.emission':'Emissiesleutelnummer','summary.base':'Voorlopig resultaat zonder filter',
      'error.emission':'Voer het viercijferige/letter emissiesleutelnummer in. Letters zijn mogelijk, bijv. 04A0 of 06ZA.','error.foreign':'Kies een Euroklasse of voer de eerste toelating in.',
      'result.label':'Uw resultaat','result.green.heading':'Uw voertuig heeft deze <span>milieusticker</span> nodig:','result.green.reason':'Deze beoordeling is gebaseerd op uw gegevens en de opgeslagen regels voor milieustickers.','result.manual.heading':'Handmatige controle aanbevolen','result.manual.reason':'De gegevens zijn niet voldoende voor een duidelijke automatische beslissing. Controleer het kentekenbewijs of bewijs.','result.foreignDieselManual':'Voor dieselvoertuigen onder Euro 4 of vóór de relevante eerste toelatingsdatum raden wij handmatige controle aan. Achteraf ingebouwde roetfilters zijn in het buitenland vaak niet duidelijk geregistreerd.','result.noGreen.heading':'Geen groene milieusticker mogelijk','result.noGreen.reason':'Volgens de opgegeven gegevens is het resultaat {badge}. Daarom wordt geen link naar de groene sticker getoond.','result.noBadge.heading':'Geen milieusticker nodig','result.motorcycle':'Voor motorfietsen wordt geen milieusticker afgegeven.','result.oldtimer':'Historische voertuigen met H-kenteken of rood 07-kenteken hebben geen milieusticker nodig.',
      'products.green.title':'Groene milieusticker','products.green.subtitle':'voor Duitsland','products.blue.title':'Blauwe E-sticker','products.blue.subtitle':'voor elektrische voertuigen','products.tax':'incl. btw','products.green.b1':'Officieel voor milieuzones in Duitsland','products.green.b2':'Snelle verwerking en verzending binnen één werkdag','products.green.b3':'Hoge kwaliteit – Made in Germany','products.blue.b1':'Voor voertuigen met elektrische aandrijving','products.blue.b2':'Officieel voor milieuzones in Duitsland','products.blue.b3':'Snelle verwerking en verzending binnen één werkdag',
      'reviews.title.prefix':'Meer dan','reviews.title.suffix':'klanten vertrouwen ons','reviews.heading':'Waarom al meer dan 100.000 klanten ons vertrouwen','reviews.subtitle':'Ervaring, gecontroleerde documenten en echte klantbeoordelingen geven zekerheid bij uw bestelling.','reviews.google_title':'Google klantbeoordelingen','reviews.shopvote_title':'ShopVote klantbeoordelingen','reviews.facts_title':'Onze ervaring','reviews.b1':'Meer dan 100.000 succesvol afgehandelde bestellingen','reviews.b2':'Snelle verwerking en verzending binnen één werkdag','reviews.b3':'Milieustickers volgens de 35e BImSchV','reviews.b4':'Made in Germany','reviews.b5':'Meertalige voertuigassistent voor Europa',
      'label.green':'groene sticker','label.yellow':'gele sticker','label.red':'rode sticker','label.none':'geen sticker','label.manual':'handmatige controle','country.DE':'Duitsland','country.CH':'Zwitserland','country.NL':'Nederland','country.BE':'België','country.FR':'Frankrijk','country.IT':'Italië','country.PL':'Polen','country.CZ':'Tsjechië','country.DK':'Denemarken','country.AT':'Oostenrijk','country.LU':'Luxemburg','country.GB':'Groot-Brittannië','country.OTHER':'Ander land','vehicle.car':'Auto','vehicle.camper':'Camper','vehicle.van':'Bestelwagen','vehicle.truck':'Vrachtwagen','vehicle.bus':'Bus','vehicle.motorcycle':'Motorfiets','vehicle.oldtimer':'Oldtimer','fuel.petrol':'Benzine','fuel.diesel':'Diesel','fuel.electric':'Elektrisch','fuel.phev':'Plug-in hybride','fuel.hybrid':'Hybride','fuel.gas':'Gas','fuel.hydrogen':'Waterstof','fuel.unknown':'Niet zeker','euro.unknown':'Onbekend','pm.unknown':'Onbekend','pm.none':'Geen roetfilter'
    },
    fr: {}, it: {}, pl: {}, cs: {}, da: {}
  };


  const FULL_TRANSLATIONS = {
    nl: {
      'trust.orders':'✓ Meer dan 100.000 succesvol verwerkte bestellingen','trust.shipping':'▱ Verzending binnen één werkdag','trust.official':'◇ Milieustickers volgens de 35e BImSchV',
      'hero.eyebrow':'Gratis voertuigcontrole','hero.title':'Uw milieusticker<br>voor <span>Duitsland</span>','hero.subtitle':'Ontdek in minder dan één minuut welke Duitse milieusticker uw voertuig nodig heeft.',
      'steps.country':'Land','steps.vehicle':'Voertuig','steps.fuel':'Aandrijving','steps.data':'Gegevens','steps.result':'Resultaat','buttons.next':'Verder','buttons.back':'Terug','buttons.view_product':'Product bekijken','buttons.restart':'Nieuwe controle starten ↻',
      'q.country.title':'1. Kies uw land','q.country.sub':'Waar is uw voertuig geregistreerd?','q.vehicle.title':'2. Welk voertuig wilt u controleren?','q.vehicle.sub':'Kies het voertuigtype zoals u het kent. De beslissing wordt later genomen op basis van de relevante voertuiggegevens.','q.fuel.title':'3. Welke aandrijving heeft uw voertuig?','q.fuel.sub':'De aandrijving is belangrijk voor de indeling.','q.de.title':'4. Emissiesleutelnummer','q.de.sub':'Voer het volledige emissiesleutelnummer in, bijvoorbeeld 0433, 0460, 04A0 of 06ZA.','q.foreign.title':'4. Euroklasse of eerste toelating','q.foreign.sub':'Als de Euroklasse onbekend is, is de datum van eerste toelating voldoende voor een eerste beoordeling.','q.pm.title':'4. Roetfilter / PM-klasse','q.pm.sub':'Uw diesel krijgt zonder filter waarschijnlijk geen groene sticker. Als een roetfilter is nageplaatst, kies dan de aangetoonde PM-klasse.',
      'field.euro':'Euroklasse','field.firstReg':'Eerste toelating','field.pm':'Aangetoonde PM-klasse','hint.de':'Voer het volledige emissiesleutelnummer uit veld 14.1 in. Bij nieuwere voertuigen kunnen de laatste twee tekens ook letters zijn, bijv. 04A0 of 06ZA.','hint.foreign':'Als de Euroklasse onbekend is, kies “Onbekend” en vul de datum van eerste toelating in.','hint.pm':'Als u de PM-klasse niet kent, adviseren wij handmatige controle met kentekenbewijs of bewijs.','notice.electric':'Uw voertuig wordt direct gecontroleerd.','notice.electric.sub':'Voor volledig elektrische of waterstofvoertuigen is geen emissiesleutelnummer en geen Euroklasse nodig.','summary.input':'Uw invoer','summary.emission':'Emissiesleutelnummer','summary.base':'Voorlopig resultaat zonder filter',
      'error.emission':'Voer het vierdelige emissiesleutelnummer in. Letters zijn mogelijk, bijv. 04A0 of 06ZA.','error.foreign':'Kies een Euroklasse of vul de eerste toelating in.',
      'result.label':'Uw resultaat','result.green.heading':'Uw voertuig heeft deze <span>milieusticker nodig:</span>','result.green.reason':'Deze beoordeling is gebaseerd op uw gegevens en de opgeslagen regels voor milieustickers.','result.manual.heading':'Handmatige controle aanbevolen','result.manual.reason':'De gegevens zijn nog niet voldoende voor een duidelijke automatische beslissing. Controleer het kentekenbewijs of een bewijsstuk.','result.foreignDieselManual':'Voor dieselvoertuigen onder Euro 4 of vóór de relevante eerste toelatingsdatum adviseren wij handmatige controle. Nageplaatste roetfilters zijn in het buitenland vaak niet duidelijk geregistreerd.','result.noGreen.heading':'Geen groene milieusticker mogelijk','result.noGreen.reason':'Op basis van de ingevoerde gegevens is het resultaat: {badge}. Daarom wordt geen link naar de groene sticker weergegeven.','result.noBadge.heading':'Geen milieusticker nodig','result.motorcycle':'Voor motorfietsen wordt geen milieusticker uitgegeven.','result.oldtimer':'Historische voertuigen met H-kenteken of rood 07-kenteken hebben geen milieusticker nodig.',
      'products.green.title':'Groene milieusticker','products.green.subtitle':'voor Duitsland','products.blue.title':'Blauwe E-sticker','products.blue.subtitle':'voor elektrische voertuigen','products.tax':'incl. btw','products.green.b1':'Officieel voor milieuzones in Duitsland','products.green.b2':'Snelle verwerking en verzending binnen één werkdag','products.green.b3':'Hoge kwaliteit – Made in Germany','products.blue.b1':'Voor voertuigen met elektrische aandrijving','products.blue.b2':'Officieel voor milieuzones in Duitsland','products.blue.b3':'Snelle verwerking en verzending binnen één werkdag',
      'reviews.title.prefix':'Meer dan','reviews.title.suffix':'klanten vertrouwen ons','reviews.heading':'Waarom al meer dan 100.000 klanten ons vertrouwen','reviews.subtitle':'Ervaring, gecontroleerde documenten en echte klantbeoordelingen geven zekerheid bij uw bestelling.','reviews.google_title':'Google klantbeoordelingen','reviews.shopvote_title':'ShopVote klantbeoordelingen','reviews.facts_title':'Onze ervaring','reviews.b1':'Meer dan 100.000 succesvol verwerkte bestellingen','reviews.b2':'Snelle verwerking en verzending binnen één werkdag','reviews.b3':'Milieustickers volgens de 35e BImSchV','reviews.b4':'Made in Germany','reviews.b5':'Meertalige voertuigassistent voor Europa',
      'label.green':'groene sticker','label.yellow':'gele sticker','label.red':'rode sticker','label.none':'geen sticker','label.manual':'handmatige controle',
      'country.DE':'Duitsland','country.CH':'Zwitserland','country.NL':'Nederland','country.BE':'België','country.FR':'Frankrijk','country.IT':'Italië','country.PL':'Polen','country.CZ':'Tsjechië','country.DK':'Denemarken','country.AT':'Oostenrijk','country.LU':'Luxemburg','country.GB':'Groot-Brittannië','country.OTHER':'Ander land',
      'vehicle.car':'Personenauto','vehicle.camper':'Camper','vehicle.van':'Bestelwagen','vehicle.truck':'Vrachtwagen','vehicle.bus':'Bus','vehicle.motorcycle':'Motorfiets','vehicle.oldtimer':'Oldtimer',
      'fuel.petrol':'Benzine','fuel.diesel':'Diesel','fuel.electric':'Elektrisch','fuel.phev':'Plug-in hybride','fuel.hybrid':'Hybride','fuel.gas':'Gas','fuel.hydrogen':'Waterstof','fuel.unknown':'Niet zeker',
      'euro.e6':'Euro 6','euro.e5':'Euro 5','euro.e4':'Euro 4','euro.e3':'Euro 3','euro.e2':'Euro 2','euro.e1':'Euro 1','euro.unknown':'Onbekend',
      'pm.unknown':'Onbekend','pm.none':'Geen roetfilter','pm.pm01':'PM 01','pm.pm0':'PM 0','pm.pm1':'PM 1','pm.pm2':'PM 2','pm.pm3':'PM 3','pm.pm4':'PM 4','pm.pm5':'PM 5'
    },
    fr: {
      'trust.orders':'✓ Plus de 100 000 commandes traitées avec succès','trust.shipping':'▱ Expédition sous un jour ouvré','trust.official':'◇ Vignettes environnementales conformément à la 35e BImSchV',
      'hero.eyebrow':'Contrôle gratuit du véhicule','hero.title':'Votre vignette écologique<br>pour <span>l’Allemagne</span>','hero.subtitle':'Découvrez en moins d’une minute quelle vignette écologique allemande votre véhicule nécessite.',
      'steps.country':'Pays','steps.vehicle':'Véhicule','steps.fuel':'Motorisation','steps.data':'Données','steps.result':'Résultat','buttons.next':'Continuer','buttons.back':'Retour','buttons.view_product':'Voir le produit','buttons.restart':'Nouvelle vérification ↻',
      'q.country.title':'1. Veuillez sélectionner votre pays','q.country.sub':'Dans quel pays votre véhicule est-il immatriculé ?','q.vehicle.title':'2. Quel véhicule souhaitez-vous vérifier ?','q.vehicle.sub':'Choisissez le type de véhicule tel que vous le connaissez. La décision sera basée sur les données pertinentes du véhicule.','q.fuel.title':'3. Quelle motorisation utilise votre véhicule ?','q.fuel.sub':'La motorisation est importante pour le classement.','q.de.title':'4. Numéro de clé d’émission','q.de.sub':'Veuillez saisir le numéro complet, par exemple 0433, 0460, 04A0 ou 06ZA.','q.foreign.title':'4. Classe Euro ou première immatriculation','q.foreign.sub':'Si la classe Euro est inconnue, la date de première immatriculation suffit pour une première estimation.','q.pm.title':'4. Filtre à particules / niveau PM','q.pm.sub':'Votre diesel ne recevra probablement pas de vignette verte sans filtre. Si un filtre a été installé, sélectionnez le niveau PM prouvé.',
      'field.euro':'Classe Euro','field.firstReg':'Première immatriculation','field.pm':'Niveau PM prouvé','hint.de':'Saisissez le numéro complet du champ 14.1. Pour les véhicules récents, les deux derniers caractères peuvent aussi être des lettres, p. ex. 04A0 ou 06ZA.','hint.foreign':'Si la classe Euro est inconnue, choisissez « Inconnue » et saisissez la première immatriculation.','hint.pm':'Si vous ne connaissez pas le niveau PM, nous recommandons une vérification manuelle avec le certificat d’immatriculation ou une preuve.','notice.electric':'Votre véhicule sera vérifié directement.','notice.electric.sub':'Les véhicules purement électriques ou à hydrogène n’ont pas besoin de numéro de clé d’émission ni de classe Euro.','summary.input':'Votre saisie','summary.emission':'Numéro de clé d’émission','summary.base':'Résultat provisoire sans filtre',
      'error.emission':'Veuillez saisir le numéro à quatre caractères. Des lettres sont possibles, p. ex. 04A0 ou 06ZA.','error.foreign':'Veuillez choisir une classe Euro ou saisir la première immatriculation.',
      'result.label':'Votre résultat','result.green.heading':'Votre véhicule a besoin de cette <span>vignette écologique :</span>','result.green.reason':'Cette évaluation est basée sur vos informations et les règles enregistrées pour les vignettes.','result.manual.heading':'Vérification manuelle recommandée','result.manual.reason':'Les informations ne suffisent pas pour une décision automatique claire. Veuillez vérifier le certificat d’immatriculation ou une preuve.','result.foreignDieselManual':'Pour les véhicules diesel inférieurs à Euro 4 ou avant la date de première immatriculation pertinente, nous recommandons une vérification manuelle. Les filtres à particules installés ultérieurement sont souvent mal indiqués à l’étranger.','result.noGreen.heading':'Aucune vignette verte possible','result.noGreen.reason':'Selon les données fournies, le résultat est : {badge}. Aucun lien vers la vignette verte n’est donc affiché.','result.noBadge.heading':'Aucune vignette écologique nécessaire','result.motorcycle':'Aucune vignette écologique n’est délivrée pour les motos.','result.oldtimer':'Les véhicules historiques avec plaque H ou plaque rouge 07 n’ont pas besoin de vignette écologique.',
      'products.green.title':'Vignette écologique verte','products.green.subtitle':'pour l’Allemagne','products.blue.title':'Vignette E bleue','products.blue.subtitle':'pour véhicules électriques','products.tax':'TVA incluse','products.green.b1':'Officielle pour les zones environnementales en Allemagne','products.green.b2':'Traitement rapide et expédition sous un jour ouvré','products.green.b3':'Haute qualité – Made in Germany','products.blue.b1':'Pour les véhicules électriques','products.blue.b2':'Officielle pour les zones environnementales en Allemagne','products.blue.b3':'Traitement rapide et expédition sous un jour ouvré',
      'reviews.title.prefix':'Plus de','reviews.title.suffix':'clients nous font confiance','reviews.heading':'Pourquoi plus de 100 000 clients nous font confiance','reviews.subtitle':'Notre expérience, la vérification des documents et les avis clients réels renforcent la sécurité de votre commande.','reviews.google_title':'Avis clients Google','reviews.shopvote_title':'Avis clients ShopVote','reviews.facts_title':'Notre expérience','reviews.b1':'Plus de 100 000 commandes traitées avec succès','reviews.b2':'Traitement rapide et expédition sous un jour ouvré','reviews.b3':'Vignettes environnementales conformément à la 35e BImSchV','reviews.b4':'Made in Germany','reviews.b5':'Assistant véhicule multilingue pour l’Europe',
      'label.green':'vignette verte','label.yellow':'vignette jaune','label.red':'vignette rouge','label.none':'aucune vignette','label.manual':'vérification manuelle',
      'country.DE':'Allemagne','country.CH':'Suisse','country.NL':'Pays-Bas','country.BE':'Belgique','country.FR':'France','country.IT':'Italie','country.PL':'Pologne','country.CZ':'Tchéquie','country.DK':'Danemark','country.AT':'Autriche','country.LU':'Luxembourg','country.GB':'Royaume-Uni','country.OTHER':'Autre pays',
      'vehicle.car':'Voiture','vehicle.camper':'Camping-car','vehicle.van':'Utilitaire','vehicle.truck':'Camion','vehicle.bus':'Bus','vehicle.motorcycle':'Moto','vehicle.oldtimer':'Véhicule ancien',
      'fuel.petrol':'Essence','fuel.diesel':'Diesel','fuel.electric':'Électrique','fuel.phev':'Hybride rechargeable','fuel.hybrid':'Hybride','fuel.gas':'Gaz','fuel.hydrogen':'Hydrogène','fuel.unknown':'Je ne sais pas',
      'euro.e6':'Euro 6','euro.e5':'Euro 5','euro.e4':'Euro 4','euro.e3':'Euro 3','euro.e2':'Euro 2','euro.e1':'Euro 1','euro.unknown':'Inconnue',
      'pm.unknown':'Inconnu','pm.none':'Aucun filtre à particules','pm.pm01':'PM 01','pm.pm0':'PM 0','pm.pm1':'PM 1','pm.pm2':'PM 2','pm.pm3':'PM 3','pm.pm4':'PM 4','pm.pm5':'PM 5'
    },
    it: {
      'trust.orders':'✓ Oltre 100.000 ordini elaborati con successo','trust.shipping':'▱ Spedizione entro un giorno lavorativo','trust.official':'◇ Bollini ambientali ai sensi della 35ª BImSchV',
      'hero.eyebrow':'Controllo veicolo gratuito','hero.title':'Il tuo bollino ambientale<br>per la <span>Germania</span>','hero.subtitle':'Scopri in meno di un minuto quale bollino ambientale tedesco serve al tuo veicolo.',
      'steps.country':'Paese','steps.vehicle':'Veicolo','steps.fuel':'Alimentazione','steps.data':'Dati','steps.result':'Risultato','buttons.next':'Avanti','buttons.back':'Indietro','buttons.view_product':'Vedi prodotto','buttons.restart':'Nuovo controllo ↻',
      'q.country.title':'1. Seleziona il tuo paese','q.country.sub':'Dove è immatricolato il tuo veicolo?','q.vehicle.title':'2. Quale veicolo vuoi controllare?','q.vehicle.sub':'Scegli il tipo di veicolo come lo conosci. La decisione si basa sui dati rilevanti del veicolo.','q.fuel.title':'3. Che alimentazione ha il tuo veicolo?','q.fuel.sub':'L’alimentazione è importante per la classificazione.','q.de.title':'4. Numero chiave emissioni','q.de.sub':'Inserisci il numero completo, ad esempio 0433, 0460, 04A0 o 06ZA.','q.foreign.title':'4. Classe Euro o prima immatricolazione','q.foreign.sub':'Se la classe Euro non è nota, la prima immatricolazione è sufficiente per una prima valutazione.','q.pm.title':'4. Filtro antiparticolato / livello PM','q.pm.sub':'Il tuo diesel probabilmente non riceverà il bollino verde senza filtro. Se è stato montato un filtro, seleziona il livello PM comprovato.',
      'field.euro':'Classe Euro','field.firstReg':'Prima immatricolazione','field.pm':'Livello PM comprovato','hint.de':'Inserisci il numero completo dal campo 14.1. Nei veicoli più recenti gli ultimi due caratteri possono essere lettere, ad es. 04A0 o 06ZA.','hint.foreign':'Se la classe Euro non è nota, scegli “Non nota” e inserisci la prima immatricolazione.','hint.pm':'Se non conosci il livello PM, consigliamo una verifica manuale con libretto o prova.','notice.electric':'Il tuo veicolo viene controllato direttamente.','notice.electric.sub':'I veicoli elettrici puri o a idrogeno non richiedono numero emissioni né classe Euro.','summary.input':'I tuoi dati','summary.emission':'Numero chiave emissioni','summary.base':'Risultato preliminare senza filtro',
      'error.emission':'Inserisci il numero a quattro caratteri. Sono possibili lettere, ad es. 04A0 o 06ZA.','error.foreign':'Seleziona una classe Euro o inserisci la prima immatricolazione.',
      'result.label':'Risultato','result.green.heading':'Il tuo veicolo necessita di questo <span>bollino ambientale:</span>','result.green.reason':'Questa valutazione si basa sui tuoi dati e sulle regole memorizzate.','result.manual.heading':'Verifica manuale consigliata','result.manual.reason':'I dati non sono sufficienti per una decisione automatica chiara. Controlla il libretto o una prova.','result.foreignDieselManual':'Per veicoli diesel sotto Euro 4 o prima della data rilevante consigliamo una verifica manuale. I filtri antiparticolato retrofit spesso non sono indicati chiaramente all’estero.','result.noGreen.heading':'Bollino verde non possibile','result.noGreen.reason':'In base ai dati inseriti, il risultato è: {badge}. Per questo non viene mostrato alcun link al bollino verde.','result.noBadge.heading':'Nessun bollino ambientale necessario','result.motorcycle':'Per le moto non viene rilasciato alcun bollino ambientale.','result.oldtimer':'I veicoli storici con targa H o targa rossa 07 non necessitano del bollino.',
      'products.green.title':'Bollino ambientale verde','products.green.subtitle':'per la Germania','products.blue.title':'Bollino E blu','products.blue.subtitle':'per veicoli elettrici','products.tax':'IVA inclusa','products.green.b1':'Ufficiale per le zone ambientali in Germania','products.green.b2':'Elaborazione rapida e spedizione entro un giorno lavorativo','products.green.b3':'Alta qualità – Made in Germany','products.blue.b1':'Per veicoli con trazione elettrica','products.blue.b2':'Ufficiale per le zone ambientali in Germania','products.blue.b3':'Elaborazione rapida e spedizione entro un giorno lavorativo',
      'reviews.title.prefix':'Oltre','reviews.title.suffix':'clienti si fidano di noi','reviews.heading':'Perché oltre 100.000 clienti si fidano di noi','reviews.subtitle':'Esperienza, documenti controllati e recensioni autentiche danno sicurezza nell’ordine.','reviews.google_title':'Recensioni clienti Google','reviews.shopvote_title':'Recensioni clienti ShopVote','reviews.facts_title':'La nostra esperienza','reviews.b1':'Oltre 100.000 ordini elaborati con successo','reviews.b2':'Elaborazione rapida e spedizione entro un giorno lavorativo','reviews.b3':'Bollini ambientali ai sensi della 35ª BImSchV','reviews.b4':'Made in Germany','reviews.b5':'Assistente veicoli multilingue per l’Europa',
      'label.green':'bollino verde','label.yellow':'bollino giallo','label.red':'bollino rosso','label.none':'nessun bollino','label.manual':'verifica manuale',
      'country.DE':'Germania','country.CH':'Svizzera','country.NL':'Paesi Bassi','country.BE':'Belgio','country.FR':'Francia','country.IT':'Italia','country.PL':'Polonia','country.CZ':'Cechia','country.DK':'Danimarca','country.AT':'Austria','country.LU':'Lussemburgo','country.GB':'Regno Unito','country.OTHER':'Altro paese',
      'vehicle.car':'Auto','vehicle.camper':'Camper','vehicle.van':'Furgone','vehicle.truck':'Camion','vehicle.bus':'Bus','vehicle.motorcycle':'Moto','vehicle.oldtimer':'Veicolo storico',
      'fuel.petrol':'Benzina','fuel.diesel':'Diesel','fuel.electric':'Elettrico','fuel.phev':'Ibrido plug-in','fuel.hybrid':'Ibrido','fuel.gas':'Gas','fuel.hydrogen':'Idrogeno','fuel.unknown':'Non sicuro',
      'euro.e6':'Euro 6','euro.e5':'Euro 5','euro.e4':'Euro 4','euro.e3':'Euro 3','euro.e2':'Euro 2','euro.e1':'Euro 1','euro.unknown':'Non nota',
      'pm.unknown':'Non noto','pm.none':'Nessun filtro antiparticolato','pm.pm01':'PM 01','pm.pm0':'PM 0','pm.pm1':'PM 1','pm.pm2':'PM 2','pm.pm3':'PM 3','pm.pm4':'PM 4','pm.pm5':'PM 5'
    },
    pl: {
      'trust.orders':'✓ Ponad 100 000 pomyślnie zrealizowanych zamówień','trust.shipping':'▱ Wysyłka w ciągu jednego dnia roboczego','trust.official':'◇ Plakietki ekologiczne zgodnie z rozporządzeniem 35. BImSchV',
      'hero.eyebrow':'Bezpłatna kontrola pojazdu','hero.title':'Twoja plakietka ekologiczna<br>do <span>Niemiec</span>','hero.subtitle':'Sprawdź w mniej niż minutę, jakiej niemieckiej plakietki potrzebuje Twój pojazd.',
      'steps.country':'Kraj','steps.vehicle':'Pojazd','steps.fuel':'Napęd','steps.data':'Dane','steps.result':'Wynik','buttons.next':'Dalej','buttons.back':'Wstecz','buttons.view_product':'Zobacz produkt','buttons.restart':'Rozpocznij nową kontrolę ↻',
      'q.country.title':'1. Wybierz kraj','q.country.sub':'Gdzie zarejestrowany jest pojazd?','q.vehicle.title':'2. Jaki pojazd chcesz sprawdzić?','q.vehicle.sub':'Wybierz typ pojazdu zgodnie ze swoją wiedzą. Decyzja będzie oparta na istotnych danych pojazdu.','q.fuel.title':'3. Jaki napęd ma pojazd?','q.fuel.sub':'Rodzaj napędu jest ważny dla klasyfikacji.','q.de.title':'4. Numer klucza emisji','q.de.sub':'Wpisz pełny numer, np. 0433, 0460, 04A0 lub 06ZA.','q.foreign.title':'4. Klasa Euro lub pierwsza rejestracja','q.foreign.sub':'Jeśli klasa Euro nie jest znana, do wstępnej oceny wystarczy data pierwszej rejestracji.','q.pm.title':'4. Filtr cząstek stałych / poziom PM','q.pm.sub':'Twój diesel prawdopodobnie nie otrzyma zielonej plakietki bez filtra. Jeśli filtr został zamontowany, wybierz potwierdzony poziom PM.',
      'field.euro':'Klasa Euro','field.firstReg':'Pierwsza rejestracja','field.pm':'Potwierdzony poziom PM','hint.de':'Wpisz pełny numer z pola 14.1. W nowszych pojazdach dwa ostatnie znaki mogą być literami, np. 04A0 lub 06ZA.','hint.foreign':'Jeśli klasa Euro nie jest znana, wybierz „Nieznana” i wpisz datę pierwszej rejestracji.','hint.pm':'Jeśli nie znasz poziomu PM, zalecamy ręczną kontrolę z dowodem rejestracyjnym lub potwierdzeniem.','notice.electric':'Pojazd zostanie sprawdzony bezpośrednio.','notice.electric.sub':'Pojazdy w pełni elektryczne lub wodorowe nie wymagają numeru emisji ani klasy Euro.','summary.input':'Twoje dane','summary.emission':'Numer klucza emisji','summary.base':'Wynik wstępny bez filtra',
      'error.emission':'Wpisz czteroznakowy numer. Litery są możliwe, np. 04A0 lub 06ZA.','error.foreign':'Wybierz klasę Euro lub wpisz pierwszą rejestrację.',
      'result.label':'Wynik','result.green.heading':'Twój pojazd potrzebuje tej <span>plakietki ekologicznej:</span>','result.green.reason':'Ocena opiera się na podanych danych i zapisanych zasadach plakietek ekologicznych.','result.manual.heading':'Zalecana kontrola ręczna','result.manual.reason':'Dane nie wystarczają do jednoznacznej automatycznej decyzji. Sprawdź dowód rejestracyjny lub potwierdzenie.','result.foreignDieselManual':'Dla diesli poniżej Euro 4 lub przed właściwą datą pierwszej rejestracji zalecamy kontrolę ręczną. Dodatkowe filtry DPF często nie są jednoznacznie wpisane za granicą.','result.noGreen.heading':'Zielona plakietka nie jest możliwa','result.noGreen.reason':'Na podstawie danych wynik to: {badge}. Dlatego link do zielonej plakietki nie jest wyświetlany.','result.noBadge.heading':'Plakietka ekologiczna nie jest wymagana','result.motorcycle':'Dla motocykli nie wydaje się plakietek ekologicznych.','result.oldtimer':'Pojazdy zabytkowe z tablicą H lub czerwoną 07 nie wymagają plakietki.',
      'products.green.title':'Zielona plakietka ekologiczna','products.green.subtitle':'do Niemiec','products.blue.title':'Niebieska plakietka E','products.blue.subtitle':'dla pojazdów elektrycznych','products.tax':'z VAT','products.green.b1':'Oficjalna do stref ekologicznych w Niemczech','products.green.b2':'Szybka obsługa i wysyłka w ciągu jednego dnia roboczego','products.green.b3':'Wysoka jakość – Made in Germany','products.blue.b1':'Dla pojazdów elektrycznych','products.blue.b2':'Oficjalna do stref ekologicznych w Niemczech','products.blue.b3':'Szybka obsługa i wysyłka w ciągu jednego dnia roboczego',
      'reviews.title.prefix':'Ponad','reviews.title.suffix':'klientów nam ufa','reviews.heading':'Dlaczego ponad 100 000 klientów nam ufa','reviews.subtitle':'Doświadczenie, sprawdzane dokumenty i prawdziwe opinie klientów dają pewność przy zamówieniu.','reviews.google_title':'Opinie klientów Google','reviews.shopvote_title':'Opinie klientów ShopVote','reviews.facts_title':'Nasze doświadczenie','reviews.b1':'Ponad 100 000 pomyślnie zrealizowanych zamówień','reviews.b2':'Szybka obsługa i wysyłka w ciągu jednego dnia roboczego','reviews.b3':'Plakietki ekologiczne zgodnie z rozporządzeniem 35. BImSchV','reviews.b4':'Made in Germany','reviews.b5':'Wielojęzyczny asystent pojazdu dla Europy',
      'label.green':'zielona plakietka','label.yellow':'żółta plakietka','label.red':'czerwona plakietka','label.none':'brak plakietki','label.manual':'kontrola ręczna',
      'country.DE':'Niemcy','country.CH':'Szwajcaria','country.NL':'Holandia','country.BE':'Belgia','country.FR':'Francja','country.IT':'Włochy','country.PL':'Polska','country.CZ':'Czechy','country.DK':'Dania','country.AT':'Austria','country.LU':'Luksemburg','country.GB':'Wielka Brytania','country.OTHER':'Inny kraj',
      'vehicle.car':'Samochód osobowy','vehicle.camper':'Kamper','vehicle.van':'Van / dostawczy','vehicle.truck':'Ciężarówka','vehicle.bus':'Autobus','vehicle.motorcycle':'Motocykl','vehicle.oldtimer':'Pojazd zabytkowy',
      'fuel.petrol':'Benzyna','fuel.diesel':'Diesel','fuel.electric':'Elektryczny','fuel.phev':'Plug-in hybrid','fuel.hybrid':'Hybryda','fuel.gas':'Gaz','fuel.hydrogen':'Wodór','fuel.unknown':'Nie wiem',
      'euro.e6':'Euro 6','euro.e5':'Euro 5','euro.e4':'Euro 4','euro.e3':'Euro 3','euro.e2':'Euro 2','euro.e1':'Euro 1','euro.unknown':'Nieznana',
      'pm.unknown':'Nieznany','pm.none':'Brak filtra DPF','pm.pm01':'PM 01','pm.pm0':'PM 0','pm.pm1':'PM 1','pm.pm2':'PM 2','pm.pm3':'PM 3','pm.pm4':'PM 4','pm.pm5':'PM 5'
    },
    cs: {
      'trust.orders':'✓ Více než 100 000 úspěšně vyřízených objednávek','trust.shipping':'▱ Odeslání do jednoho pracovního dne','trust.official':'◇ Ekologické plakety podle nařízení 35. BImSchV',
      'hero.eyebrow':'Bezplatná kontrola vozidla','hero.title':'Vaše ekologická plaketa<br>pro <span>Německo</span>','hero.subtitle':'Zjistěte za méně než minutu, jakou německou ekologickou plaketu vaše vozidlo potřebuje.',
      'steps.country':'Země','steps.vehicle':'Vozidlo','steps.fuel':'Pohon','steps.data':'Údaje','steps.result':'Výsledek','buttons.next':'Pokračovat','buttons.back':'Zpět','buttons.view_product':'Zobrazit produkt','buttons.restart':'Spustit novou kontrolu ↻',
      'q.country.title':'1. Vyberte zemi','q.country.sub':'Kde je vozidlo registrováno?','q.vehicle.title':'2. Jaké vozidlo chcete zkontrolovat?','q.vehicle.sub':'Vyberte typ vozidla tak, jak ho znáte. Rozhodnutí vychází z relevantních údajů vozidla.','q.fuel.title':'3. Jaký pohon má vozidlo?','q.fuel.sub':'Druh pohonu je důležitý pro zařazení.','q.de.title':'4. Emisní klíč','q.de.sub':'Zadejte celý emisní klíč, například 0433, 0460, 04A0 nebo 06ZA.','q.foreign.title':'4. Norma Euro nebo první registrace','q.foreign.sub':'Pokud norma Euro není známa, postačí pro první odhad datum první registrace.','q.pm.title':'4. Filtr pevných částic / stupeň PM','q.pm.sub':'Vaše dieselové vozidlo pravděpodobně bez filtru nezíská zelenou plaketu. Pokud byl filtr dodatečně namontován, vyberte doložený stupeň PM.',
      'field.euro':'Norma Euro','field.firstReg':'První registrace','field.pm':'Doložený stupeň PM','hint.de':'Zadejte celý emisní klíč z pole 14.1. U novějších vozidel mohou být poslední dva znaky také písmena, např. 04A0 nebo 06ZA.','hint.foreign':'Pokud norma Euro není známa, vyberte „Neznámá“ a zadejte první registraci.','hint.pm':'Pokud stupeň PM neznáte, doporučujeme ruční ověření s technickým průkazem nebo dokladem.','notice.electric':'Vaše vozidlo bude zkontrolováno přímo.','notice.electric.sub':'Čistě elektrická nebo vodíková vozidla nepotřebují emisní klíč ani normu Euro.','summary.input':'Vaše údaje','summary.emission':'Emisní klíč','summary.base':'Předběžný výsledek bez filtru',
      'error.emission':'Zadejte čtyřmístný emisní klíč. Písmena jsou možná, např. 04A0 nebo 06ZA.','error.foreign':'Vyberte normu Euro nebo zadejte první registraci.',
      'result.label':'Výsledek','result.green.heading':'Vaše vozidlo potřebuje tuto <span>ekologickou plaketu:</span>','result.green.reason':'Toto posouzení vychází z vašich údajů a uložených pravidel pro ekologické plakety.','result.manual.heading':'Doporučeno ruční ověření','result.manual.reason':'Údaje nestačí pro jednoznačné automatické rozhodnutí. Zkontrolujte technický průkaz nebo doklad.','result.foreignDieselManual':'U dieselových vozidel pod Euro 4 nebo před rozhodným datem první registrace doporučujeme ruční ověření. Dodatečně namontované filtry jsou v zahraničí často nejasně zapsány.','result.noGreen.heading':'Zelená ekologická plaketa není možná','result.noGreen.reason':'Podle zadaných údajů je výsledek: {badge}. Odkaz na zelenou plaketu se proto nezobrazuje.','result.noBadge.heading':'Ekologická plaketa není nutná','result.motorcycle':'Pro motocykly se ekologická plaketa nevydává.','result.oldtimer':'Historická vozidla s označením H nebo červenou 07 plaketu nepotřebují.',
      'products.green.title':'Zelená ekologická plaketa','products.green.subtitle':'pro Německo','products.blue.title':'Modrá E-plaketa','products.blue.subtitle':'pro elektromobily','products.tax':'včetně DPH','products.green.b1':'Oficiální pro ekologické zóny v Německu','products.green.b2':'Rychlé zpracování a odeslání do jednoho pracovního dne','products.green.b3':'Vysoká kvalita – Made in Germany','products.blue.b1':'Pro vozidla s elektrickým pohonem','products.blue.b2':'Oficiální pro ekologické zóny v Německu','products.blue.b3':'Rychlé zpracování a odeslání do jednoho pracovního dne',
      'reviews.title.prefix':'Více než','reviews.title.suffix':'zákazníků nám důvěřuje','reviews.heading':'Proč nám důvěřuje více než 100 000 zákazníků','reviews.subtitle':'Zkušenosti, kontrolované doklady a skutečné recenze zákazníků dodávají jistotu při objednávce.','reviews.google_title':'Zákaznické recenze Google','reviews.shopvote_title':'Zákaznické recenze ShopVote','reviews.facts_title':'Naše zkušenosti','reviews.b1':'Více než 100 000 úspěšně vyřízených objednávek','reviews.b2':'Rychlé zpracování a odeslání do jednoho pracovního dne','reviews.b3':'Ekologické plakety podle nařízení 35. BImSchV','reviews.b4':'Made in Germany','reviews.b5':'Vícejazyčný asistent vozidla pro Evropu',
      'label.green':'zelená plaketa','label.yellow':'žlutá plaketa','label.red':'červená plaketa','label.none':'žádná plaketa','label.manual':'ruční ověření',
      'country.DE':'Německo','country.CH':'Švýcarsko','country.NL':'Nizozemsko','country.BE':'Belgie','country.FR':'Francie','country.IT':'Itálie','country.PL':'Polsko','country.CZ':'Česko','country.DK':'Dánsko','country.AT':'Rakousko','country.LU':'Lucembursko','country.GB':'Velká Británie','country.OTHER':'Jiná země',
      'vehicle.car':'Osobní auto','vehicle.camper':'Obytné auto','vehicle.van':'Dodávka','vehicle.truck':'Nákladní auto','vehicle.bus':'Autobus','vehicle.motorcycle':'Motocykl','vehicle.oldtimer':'Veterán',
      'fuel.petrol':'Benzín','fuel.diesel':'Nafta','fuel.electric':'Elektro','fuel.phev':'Plug-in hybrid','fuel.hybrid':'Hybrid','fuel.gas':'Plyn','fuel.hydrogen':'Vodík','fuel.unknown':'Nejsem si jistý/á',
      'euro.e6':'Euro 6','euro.e5':'Euro 5','euro.e4':'Euro 4','euro.e3':'Euro 3','euro.e2':'Euro 2','euro.e1':'Euro 1','euro.unknown':'Neznámá',
      'pm.unknown':'Neznámý','pm.none':'Žádný filtr pevných částic','pm.pm01':'PM 01','pm.pm0':'PM 0','pm.pm1':'PM 1','pm.pm2':'PM 2','pm.pm3':'PM 3','pm.pm4':'PM 4','pm.pm5':'PM 5'
    },
    da: {
      'trust.orders':'✓ Mere end 100.000 gennemførte ordrer','trust.shipping':'▱ Afsendelse inden for én arbejdsdag','trust.official':'◇ Miljømærkater i henhold til den 35. BImSchV',
      'hero.eyebrow':'Gratis køretøjstjek','hero.title':'Dit miljømærkat<br>til <span>Tyskland</span>','hero.subtitle':'Find på under ét minut ud af, hvilket tysk miljømærkat dit køretøj har brug for.',
      'steps.country':'Land','steps.vehicle':'Køretøj','steps.fuel':'Drivmiddel','steps.data':'Data','steps.result':'Resultat','buttons.next':'Fortsæt','buttons.back':'Tilbage','buttons.view_product':'Se produkt','buttons.restart':'Start ny kontrol ↻',
      'q.country.title':'1. Vælg dit land','q.country.sub':'Hvor er dit køretøj registreret?','q.vehicle.title':'2. Hvilket køretøj vil du kontrollere?','q.vehicle.sub':'Vælg køretøjstypen, som du kender den. Beslutningen baseres senere på de relevante køretøjsdata.','q.fuel.title':'3. Hvilken drivtype har dit køretøj?','q.fuel.sub':'Drivtypen er vigtig for klassificeringen.','q.de.title':'4. Emissionsnøgle','q.de.sub':'Indtast hele emissionsnøglen, f.eks. 0433, 0460, 04A0 eller 06ZA.','q.foreign.title':'4. Euroklasse eller første registrering','q.foreign.sub':'Hvis Euroklassen ikke kendes, er første registrering nok til en første vurdering.','q.pm.title':'4. Partikelfilter / PM-niveau','q.pm.sub':'Din diesel får sandsynligvis ikke et grønt mærkat uden filter. Hvis et filter er eftermonteret, vælg det dokumenterede PM-niveau.',
      'field.euro':'Euroklasse','field.firstReg':'Første registrering','field.pm':'Dokumenteret PM-niveau','hint.de':'Indtast hele emissionsnøglen fra felt 14.1. På nyere køretøjer kan de sidste to tegn også være bogstaver, f.eks. 04A0 eller 06ZA.','hint.foreign':'Hvis Euroklassen ikke kendes, vælg “Ukendt” og angiv første registrering.','hint.pm':'Hvis du ikke kender PM-niveauet, anbefaler vi manuel kontrol med registreringsattest eller dokumentation.','notice.electric':'Dit køretøj kontrolleres direkte.','notice.electric.sub':'Rene el- eller brintkøretøjer kræver ingen emissionsnøgle og ingen Euroklasse.','summary.input':'Dine oplysninger','summary.emission':'Emissionsnøgle','summary.base':'Foreløbigt resultat uden filter',
      'error.emission':'Indtast emissionsnøglen på fire tegn. Bogstaver er mulige, f.eks. 04A0 eller 06ZA.','error.foreign':'Vælg en Euroklasse eller angiv første registrering.',
      'result.label':'Dit resultat','result.green.heading':'Dit køretøj har brug for dette <span>miljømærkat:</span>','result.green.reason':'Denne vurdering er baseret på dine oplysninger og de gemte regler for miljømærkater.','result.manual.heading':'Manuel kontrol anbefales','result.manual.reason':'Oplysningerne er ikke tilstrækkelige til en klar automatisk afgørelse. Kontroller registreringsattesten eller dokumentation.','result.foreignDieselManual':'For dieselkøretøjer under Euro 4 eller før den relevante første registreringsdato anbefaler vi manuel kontrol. Eftermonterede partikelfiltre er ofte ikke tydeligt registreret i udlandet.','result.noGreen.heading':'Grønt miljømærkat ikke muligt','result.noGreen.reason':'Ud fra de angivne data er resultatet: {badge}. Derfor vises der ikke noget link til det grønne mærkat.','result.noBadge.heading':'Intet miljømærkat nødvendigt','result.motorcycle':'Der udstedes ikke miljømærkat til motorcykler.','result.oldtimer':'Historiske køretøjer med H-registrering eller rød 07-registrering behøver ikke miljømærkat.',
      'products.green.title':'Grønt miljømærkat','products.green.subtitle':'til Tyskland','products.blue.title':'Blåt E-mærkat','products.blue.subtitle':'til elbiler','products.tax':'inkl. moms','products.green.b1':'Officielt til miljøzoner i Tyskland','products.green.b2':'Hurtig behandling og afsendelse inden for én arbejdsdag','products.green.b3':'Høj kvalitet – Made in Germany','products.blue.b1':'Til køretøjer med eldrift','products.blue.b2':'Officielt til miljøzoner i Tyskland','products.blue.b3':'Hurtig behandling og afsendelse inden for én arbejdsdag',
      'reviews.title.prefix':'Mere end','reviews.title.suffix':'kunder stoler på os','reviews.heading':'Hvorfor mere end 100.000 kunder stoler på os','reviews.subtitle':'Erfaring, kontrollerede dokumenter og ægte kundeanmeldelser giver tryghed ved bestilling.','reviews.google_title':'Google kundeanmeldelser','reviews.shopvote_title':'ShopVote kundeanmeldelser','reviews.facts_title':'Vores erfaring','reviews.b1':'Mere end 100.000 gennemførte ordrer','reviews.b2':'Hurtig behandling og afsendelse inden for én arbejdsdag','reviews.b3':'Miljømærkater i henhold til den 35. BImSchV','reviews.b4':'Made in Germany','reviews.b5':'Flersproget køretøjsassistent for Europa',
      'label.green':'grønt mærkat','label.yellow':'gult mærkat','label.red':'rødt mærkat','label.none':'intet mærkat','label.manual':'manuel kontrol',
      'country.DE':'Tyskland','country.CH':'Schweiz','country.NL':'Holland','country.BE':'Belgien','country.FR':'Frankrig','country.IT':'Italien','country.PL':'Polen','country.CZ':'Tjekkiet','country.DK':'Danmark','country.AT':'Østrig','country.LU':'Luxembourg','country.GB':'Storbritannien','country.OTHER':'Andet land',
      'vehicle.car':'Personbil','vehicle.camper':'Autocamper','vehicle.van':'Varevogn','vehicle.truck':'Lastbil','vehicle.bus':'Bus','vehicle.motorcycle':'Motorcykel','vehicle.oldtimer':'Veteranbil',
      'fuel.petrol':'Benzin','fuel.diesel':'Diesel','fuel.electric':'El','fuel.phev':'Plug-in hybrid','fuel.hybrid':'Hybrid','fuel.gas':'Gas','fuel.hydrogen':'Brint','fuel.unknown':'Ikke sikker',
      'euro.e6':'Euro 6','euro.e5':'Euro 5','euro.e4':'Euro 4','euro.e3':'Euro 3','euro.e2':'Euro 2','euro.e1':'Euro 1','euro.unknown':'Ukendt',
      'pm.unknown':'Ukendt','pm.none':'Intet partikelfilter','pm.pm01':'PM 01','pm.pm0':'PM 0','pm.pm1':'PM 1','pm.pm2':'PM 2','pm.pm3':'PM 3','pm.pm4':'PM 4','pm.pm5':'PM 5'
    }
  };

  Object.keys(FULL_TRANSLATIONS).forEach(lang => {
    Object.assign(T[lang], T.en, FULL_TRANSLATIONS[lang]);
  });


  const EXTRA_TRANSLATIONS = {
    de: {
      'buttons.view_addon':'Add-on ansehen',
      'products.blue.addon':'Optionales Add-on',
      'products.blue.subtitle':'Optionales Extra für ausländische Elektrofahrzeuge',
      'reviews.open':'Bewertungen ansehen','reviews.count_label':'Bewertungen',
      'reviews.updated':'Bewertungen zuletzt gepflegt:',
      'reviews.link_missing':''
    },
    en: {
      'buttons.view_addon':'View add-on',
      'products.blue.addon':'Optional add-on',
      'products.blue.subtitle':'Optional extra for foreign electric vehicles',
      'reviews.open':'View reviews','reviews.count_label':'reviews',
      'reviews.updated':'Reviews last updated:',
      'reviews.link_missing':''
    },
    nl: {
      'buttons.view_addon':'Add-on bekijken',
      'products.blue.addon':'Optionele add-on',
      'products.blue.subtitle':'Optionele extra voor buitenlandse elektrische voertuigen',
      'reviews.open':'Reviews bekijken','reviews.count_label':'beoordelingen',
      'reviews.updated':'Reviews laatst bijgewerkt:',
      'reviews.link_missing':''
    },
    fr: {
      'buttons.view_addon':'Voir l’option',
      'products.blue.addon':'Option supplémentaire',
      'products.blue.subtitle':'Option pour véhicules électriques étrangers',
      'reviews.open':'Voir les avis','reviews.count_label':'avis',
      'reviews.updated':'Avis mis à jour le :',
      'reviews.link_missing':''
    },
    it: {
      'buttons.view_addon':'Vedi componente aggiuntivo',
      'products.blue.addon':'Extra opzionale',
      'products.blue.subtitle':'Extra opzionale per veicoli elettrici esteri',
      'reviews.open':'Vedi recensioni','reviews.count_label':'recensioni',
      'reviews.updated':'Recensioni aggiornate il:',
      'reviews.link_missing':''
    },
    pl: {
      'buttons.view_addon':'Zobacz dodatek',
      'products.blue.addon':'Opcjonalny dodatek',
      'products.blue.subtitle':'Opcjonalny dodatek dla zagranicznych pojazdów elektrycznych',
      'reviews.open':'Zobacz opinie','reviews.count_label':'opinii',
      'reviews.updated':'Opinie ostatnio aktualizowane:',
      'reviews.link_missing':''
    },
    cs: {
      'buttons.view_addon':'Zobrazit doplněk',
      'products.blue.addon':'Volitelný doplněk',
      'products.blue.subtitle':'Volitelný doplněk pro zahraniční elektromobily',
      'reviews.open':'Zobrazit recenze','reviews.count_label':'recenzí',
      'reviews.updated':'Recenze naposledy aktualizovány:',
      'reviews.link_missing':''
    },
    da: {
      'buttons.view_addon':'Se tilvalg',
      'products.blue.addon':'Valgfrit tilvalg',
      'products.blue.subtitle':'Valgfrit ekstra til udenlandske elbiler',
      'reviews.open':'Se anmeldelser','reviews.count_label':'anmeldelser',
      'reviews.updated':'Anmeldelser sidst opdateret:',
      'reviews.link_missing':''
    }
  };
  Object.keys(EXTRA_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], EXTRA_TRANSLATIONS[lang]);
  });

  const REQUIRED_TRANSLATIONS = {
    de:{'error.required':'Bitte treffen Sie zuerst eine Auswahl.','error.required.country':'Bitte wählen Sie zuerst das Zulassungsland aus.','error.required.vehicle':'Bitte wählen Sie zuerst die Fahrzeugart aus.','error.required.fuel':'Bitte wählen Sie zuerst die Kraftstoffart aus.'},
    en:{'error.required':'Please make a selection first.','error.required.country':'Please select the registration country first.','error.required.vehicle':'Please select the vehicle type first.','error.required.fuel':'Please select the fuel type first.'},
    nl:{'error.required':'Maak eerst een keuze.','error.required.country':'Selecteer eerst het land van registratie.','error.required.vehicle':'Selecteer eerst het voertuigtype.','error.required.fuel':'Selecteer eerst de brandstofsoort.'},
    fr:{'error.required':'Veuillez d’abord faire une sélection.','error.required.country':'Veuillez d’abord choisir le pays d’immatriculation.','error.required.vehicle':'Veuillez d’abord choisir le type de véhicule.','error.required.fuel':'Veuillez d’abord choisir la motorisation.'},
    it:{'error.required':'Effettui prima una selezione.','error.required.country':'Selezioni prima il paese di immatricolazione.','error.required.vehicle':'Selezioni prima il tipo di veicolo.','error.required.fuel':'Selezioni prima il carburante.'},
    pl:{'error.required':'Najpierw dokonaj wyboru.','error.required.country':'Najpierw wybierz kraj rejestracji.','error.required.vehicle':'Najpierw wybierz typ pojazdu.','error.required.fuel':'Najpierw wybierz rodzaj paliwa.'},
    cs:{'error.required':'Nejprve prosím proveďte výběr.','error.required.country':'Nejprve vyberte zemi registrace.','error.required.vehicle':'Nejprve vyberte typ vozidla.','error.required.fuel':'Nejprve vyberte druh paliva.'},
    da:{'error.required':'Vælg venligst først en mulighed.','error.required.country':'Vælg først registreringslandet.','error.required.vehicle':'Vælg først køretøjstype.','error.required.fuel':'Vælg først drivmiddel.'}
  };
  Object.keys(REQUIRED_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], REQUIRED_TRANSLATIONS[lang]);
  });



  const RESULT_PAGE_TRANSLATIONS = {
    de: {
      'result.recommendation.title':'Ihr Prüfergebnis',
      'result.recommendation.lead':'Auf Grundlage Ihrer Angaben kommen wir zu folgendem Ergebnis:',
      'result.facts.result':'Ergebnis',
      'result.green.status':'Ihr Fahrzeug erfüllt die gesetzlichen Voraussetzungen für die Erteilung einer grünen Umweltplakette.',
      'result.green.permission':'Wir dürfen Ihnen für dieses Fahrzeug eine grüne Umweltplakette ausstellen.',
      'result.noGreen.status':'Nach Ihren Angaben erfüllt Ihr Fahrzeug derzeit nicht die gesetzlichen Voraussetzungen für die Erteilung einer grünen Umweltplakette.',
      'result.manual.status':'Für Ihr Fahrzeug empfehlen wir eine manuelle Prüfung.',
      'result.notice.after_order':'Nach Ihrer Bestellung prüfen wir Ihre Unterlagen selbstverständlich vor der Ausstellung Ihrer Umweltplakette.',
      'result.notice.manual':'Bitte lassen Sie die Unterlagen prüfen, bevor Sie bestellen.',
      'result.notice.no_order':'Für dieses Ergebnis wird keine Bestellung einer grünen Umweltplakette empfohlen.',
      'buttons.order_now':'Jetzt bestellen',
      'buttons.more_info':'Mehr erfahren'
    },
    en: {
      'result.recommendation.title':'Your check result',
      'result.recommendation.lead':'Based on your details, we come to the following result:',
      'result.facts.result':'Result',
      'result.green.status':'Your vehicle meets the legal requirements for a green German environmental sticker.',
      'result.green.permission':'We may issue a green environmental sticker for this vehicle.',
      'result.noGreen.status':'Based on your details, your vehicle currently does not meet the requirements for a green environmental sticker.',
      'result.manual.status':'We recommend a manual check for your vehicle.',
      'result.notice.after_order':'After your order, we will of course check your documents before issuing the environmental sticker.',
      'result.notice.manual':'Please have the documents checked before ordering.',
      'result.notice.no_order':'For this result, ordering a green environmental sticker is not recommended.',
      'buttons.order_now':'Order now',
      'buttons.more_info':'Learn more'
    },
    nl: {
      'result.recommendation.title':'Uw controleresultaat',
      'result.recommendation.lead':'Op basis van uw gegevens komen wij tot het volgende resultaat:',
      'result.facts.result':'Resultaat',
      'result.green.status':'Uw voertuig voldoet aan de wettelijke voorwaarden voor een groene Duitse milieusticker.',
      'result.green.permission':'Wij mogen voor dit voertuig een groene milieusticker uitgeven.',
      'result.noGreen.status':'Volgens uw gegevens voldoet uw voertuig momenteel niet aan de voorwaarden voor een groene milieusticker.',
      'result.manual.status':'Wij adviseren een handmatige controle voor uw voertuig.',
      'result.notice.after_order':'Na uw bestelling controleren wij uiteraard uw documenten voordat wij de milieusticker uitgeven.',
      'result.notice.manual':'Laat de documenten controleren voordat u bestelt.',
      'result.notice.no_order':'Voor dit resultaat wordt het bestellen van een groene milieusticker niet aanbevolen.',
      'buttons.order_now':'Nu bestellen',
      'buttons.more_info':'Meer informatie'
    },
    fr: {
      'result.recommendation.title':'Votre résultat de contrôle',
      'result.recommendation.lead':'Sur la base de vos informations, nous arrivons au résultat suivant :',
      'result.facts.result':'Résultat',
      'result.green.status':'Votre véhicule remplit les conditions légales pour une vignette environnementale verte allemande.',
      'result.green.permission':'Nous pouvons délivrer une vignette environnementale verte pour ce véhicule.',
      'result.noGreen.status':'Selon vos informations, votre véhicule ne remplit actuellement pas les conditions pour une vignette verte.',
      'result.manual.status':'Nous recommandons une vérification manuelle de votre véhicule.',
      'result.notice.after_order':'Après votre commande, nous vérifierons bien entendu vos documents avant de délivrer la vignette.',
      'result.notice.manual':'Veuillez faire vérifier les documents avant de commander.',
      'result.notice.no_order':'Pour ce résultat, la commande d’une vignette verte n’est pas recommandée.',
      'buttons.order_now':'Commander',
      'buttons.more_info':'En savoir plus'
    },
    it: {
      'result.recommendation.title':'Il risultato della verifica',
      'result.recommendation.lead':'In base ai dati inseriti, arriviamo al seguente risultato:',
      'result.facts.result':'Risultato',
      'result.green.status':'Il veicolo soddisfa i requisiti legali per il rilascio di un bollino ambientale verde tedesco.',
      'result.green.permission':'Possiamo rilasciare un bollino ambientale verde per questo veicolo.',
      'result.noGreen.status':'In base ai dati inseriti, il veicolo attualmente non soddisfa i requisiti per il bollino verde.',
      'result.manual.status':'Consigliamo una verifica manuale del veicolo.',
      'result.notice.after_order':'Dopo l’ordine controlleremo naturalmente i documenti prima di emettere il bollino ambientale.',
      'result.notice.manual':'Si prega di far controllare i documenti prima dell’ordine.',
      'result.notice.no_order':'Per questo risultato non consigliamo l’ordine del bollino verde.',
      'buttons.order_now':'Ordina ora',
      'buttons.more_info':'Maggiori informazioni'
    },
    pl: {
      'result.recommendation.title':'Wynik kontroli',
      'result.recommendation.lead':'Na podstawie podanych danych otrzymujemy następujący wynik:',
      'result.facts.result':'Wynik',
      'result.green.status':'Pojazd spełnia wymogi prawne do wydania zielonej niemieckiej plakietki ekologicznej.',
      'result.green.permission':'Możemy wydać zieloną plakietkę ekologiczną dla tego pojazdu.',
      'result.noGreen.status':'Na podstawie podanych danych pojazd obecnie nie spełnia wymogów dla zielonej plakietki.',
      'result.manual.status':'Zalecamy ręczną kontrolę pojazdu.',
      'result.notice.after_order':'Po złożeniu zamówienia oczywiście sprawdzimy dokumenty przed wydaniem plakietki.',
      'result.notice.manual':'Przed zamówieniem prosimy o sprawdzenie dokumentów.',
      'result.notice.no_order':'Dla tego wyniku nie zalecamy zamawiania zielonej plakietki.',
      'buttons.order_now':'Zamów teraz',
      'buttons.more_info':'Więcej informacji'
    },
    cs: {
      'result.recommendation.title':'Výsledek kontroly',
      'result.recommendation.lead':'Na základě vašich údajů docházíme k následujícímu výsledku:',
      'result.facts.result':'Výsledek',
      'result.green.status':'Vaše vozidlo splňuje zákonné požadavky pro vydání zelené německé ekologické plakety.',
      'result.green.permission':'Pro toto vozidlo můžeme vydat zelenou ekologickou plaketu.',
      'result.noGreen.status':'Podle vašich údajů vozidlo aktuálně nesplňuje podmínky pro zelenou plaketu.',
      'result.manual.status':'Doporučujeme ruční kontrolu vozidla.',
      'result.notice.after_order':'Po objednávce samozřejmě zkontrolujeme vaše doklady před vydáním ekologické plakety.',
      'result.notice.manual':'Před objednáním si prosím nechte zkontrolovat doklady.',
      'result.notice.no_order':'Pro tento výsledek nedoporučujeme objednávat zelenou plaketu.',
      'buttons.order_now':'Objednat nyní',
      'buttons.more_info':'Více informací'
    },
    da: {
      'result.recommendation.title':'Dit kontrolresultat',
      'result.recommendation.lead':'På baggrund af dine oplysninger kommer vi frem til følgende resultat:',
      'result.facts.result':'Resultat',
      'result.green.status':'Dit køretøj opfylder de lovmæssige krav til et grønt tysk miljømærkat.',
      'result.green.permission':'Vi må udstede et grønt miljømærkat til dette køretøj.',
      'result.noGreen.status':'Ud fra dine oplysninger opfylder køretøjet aktuelt ikke kravene til et grønt miljømærkat.',
      'result.manual.status':'Vi anbefaler manuel kontrol af dit køretøj.',
      'result.notice.after_order':'Efter din bestilling kontrollerer vi naturligvis dine dokumenter, før miljømærkatet udstedes.',
      'result.notice.manual':'Få venligst dokumenterne kontrolleret før bestilling.',
      'result.notice.no_order':'For dette resultat anbefales bestilling af et grønt miljømærkat ikke.',
      'buttons.order_now':'Bestil nu',
      'buttons.more_info':'Læs mere'
    }
  };
  Object.keys(RESULT_PAGE_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], RESULT_PAGE_TRANSLATIONS[lang]);
  });


  const V45_TRANSLATIONS = {
    de: {
      'trust.shipping':'▱ Bearbeitung und Versand innerhalb eines Werktages',
      'hero.subtitle':'Finden Sie in weniger als einer Minute heraus, welche Umweltplakette für Ihr Fahrzeug erteilt werden kann.',
      'products.green.b1':'Erforderlich für die Einfahrt in deutsche Umweltzonen',
      'products.green.b2':'Individuell mit Ihrem Kennzeichen UV-beständig bedruckt',
      'products.green.b3':'Hochwertige Qualität – Made in Germany',
      'products.green.b4':'Schnelle Bearbeitung und Versand innerhalb eines Werktages',
      'products.blue.title':'Blaue E-Plakette',
      'products.blue.addon':'Zusätzlich empfohlen',
      'products.blue.subtitle':'Empfohlen für ausländisch zugelassene Elektro- und Plug-in-Hybridfahrzeuge',
      'products.blue.b1':'Je nach Stadt Vorteile beim Parken',
      'products.blue.b2':'Vorteile an öffentlichen Ladestationen',
      'products.blue.b3':'Offizielle Kennzeichnung als Elektro- oder Plug-in-Hybridfahrzeug',
      'products.blue.b4':'Die jeweiligen Regelungen werden von Städten und Gemeinden festgelegt',
      'buttons.order_now':'Umweltplakette jetzt bestellen',
      'buttons.more_info':'E-Plakette ansehen'
    },
    en: {
      'trust.shipping':'▱ Processing and dispatch within one working day',
      'hero.subtitle':'Find out in less than one minute which German environmental sticker can be issued for your vehicle.',
      'products.green.b1':'Required for entering German low-emission zones',
      'products.green.b2':'Individually printed with your registration number in UV-resistant quality',
      'products.green.b3':'High quality – Made in Germany',
      'products.green.b4':'Fast processing and dispatch within one working day',
      'products.blue.title':'Blue E-sticker',
      'products.blue.addon':'Additional recommendation',
      'products.blue.subtitle':'Recommended for foreign-registered electric and plug-in hybrid vehicles',
      'products.blue.b1':'Depending on the city, parking benefits may apply',
      'products.blue.b2':'Benefits at public charging stations may apply',
      'products.blue.b3':'Official identification as an electric or plug-in hybrid vehicle',
      'products.blue.b4':'The exact rules are set by cities and municipalities',
      'buttons.order_now':'Order environmental sticker',
      'buttons.more_info':'View E-sticker'
    },
    nl: {
      'trust.shipping':'▱ Verwerking en verzending binnen één werkdag',
      'hero.subtitle':'Ontdek in minder dan één minuut welke Duitse milieusticker voor uw voertuig kan worden afgegeven.',
      'products.green.b1':'Vereist voor toegang tot Duitse milieuzones',
      'products.green.b2':'Individueel met uw kenteken UV-bestendig bedrukt',
      'products.green.b3':'Hoge kwaliteit – Made in Germany',
      'products.green.b4':'Snelle verwerking en verzending binnen één werkdag',
      'products.blue.title':'Blauwe E-sticker',
      'products.blue.addon':'Aanvullend aanbevolen',
      'products.blue.subtitle':'Aanbevolen voor in het buitenland geregistreerde elektrische en plug-in hybride voertuigen',
      'products.blue.b1':'Afhankelijk van de stad voordelen bij parkeren',
      'products.blue.b2':'Voordelen bij openbare laadstations mogelijk',
      'products.blue.b3':'Officiële aanduiding als elektrisch of plug-in hybride voertuig',
      'products.blue.b4':'De exacte regels worden door steden en gemeenten vastgesteld',
      'buttons.order_now':'Milieusticker nu bestellen',
      'buttons.more_info':'E-sticker bekijken'
    },
    fr: {
      'trust.shipping':'▱ Traitement et expédition sous un jour ouvré',
      'hero.subtitle':'Découvrez en moins d’une minute quelle vignette écologique allemande peut être délivrée pour votre véhicule.',
      'products.green.b1':'Obligatoire pour accéder aux zones environnementales allemandes',
      'products.green.b2':'Impression UV résistante avec votre numéro d’immatriculation',
      'products.green.b3':'Haute qualité – Made in Germany',
      'products.green.b4':'Traitement rapide et expédition sous un jour ouvré',
      'products.blue.title':'Vignette E bleue',
      'products.blue.addon':'Recommandation supplémentaire',
      'products.blue.subtitle':'Recommandée pour les véhicules électriques et hybrides rechargeables immatriculés à l’étranger',
      'products.blue.b1':'Selon la ville, des avantages de stationnement peuvent s’appliquer',
      'products.blue.b2':'Des avantages aux bornes de recharge publiques peuvent s’appliquer',
      'products.blue.b3':'Identification officielle comme véhicule électrique ou hybride rechargeable',
      'products.blue.b4':'Les règles exactes sont fixées par les villes et communes',
      'buttons.order_now':'Commander la vignette environnementale',
      'buttons.more_info':'Voir la vignette E'
    },
    it: {
      'trust.shipping':'▱ Elaborazione e spedizione entro un giorno lavorativo',
      'hero.subtitle':'Scopra in meno di un minuto quale bollino ambientale tedesco può essere rilasciato per il suo veicolo.',
      'products.green.b1':'Necessario per accedere alle zone ambientali tedesche',
      'products.green.b2':'Stampato individualmente con la targa, resistente ai raggi UV',
      'products.green.b3':'Alta qualità – Made in Germany',
      'products.green.b4':'Elaborazione rapida e spedizione entro un giorno lavorativo',
      'products.blue.title':'Bollino E blu',
      'products.blue.addon':'Consigliato in aggiunta',
      'products.blue.subtitle':'Consigliato per veicoli elettrici e plug-in hybrid immatricolati all’estero',
      'products.blue.b1':'A seconda della città, possibili vantaggi per il parcheggio',
      'products.blue.b2':'Possibili vantaggi presso stazioni di ricarica pubbliche',
      'products.blue.b3':'Identificazione ufficiale come veicolo elettrico o plug-in hybrid',
      'products.blue.b4':'Le regole precise sono stabilite da città e comuni',
      'buttons.order_now':'Ordina il bollino ambientale',
      'buttons.more_info':'Vedi bollino E'
    },
    pl: {
      'trust.shipping':'▱ Obsługa i wysyłka w ciągu jednego dnia roboczego',
      'hero.subtitle':'Sprawdź w mniej niż minutę, jaka niemiecka plakietka ekologiczna może zostać wydana dla Twojego pojazdu.',
      'products.green.b1':'Wymagana do wjazdu do niemieckich stref ekologicznych',
      'products.green.b2':'Indywidualny, odporny na UV nadruk z numerem rejestracyjnym',
      'products.green.b3':'Wysoka jakość – Made in Germany',
      'products.green.b4':'Szybka obsługa i wysyłka w ciągu jednego dnia roboczego',
      'products.blue.title':'Niebieska plakietka E',
      'products.blue.addon':'Dodatkowo polecane',
      'products.blue.subtitle':'Polecana dla zagranicznych pojazdów elektrycznych i hybryd plug-in',
      'products.blue.b1':'W zależności od miasta możliwe korzyści przy parkowaniu',
      'products.blue.b2':'Możliwe korzyści przy publicznych stacjach ładowania',
      'products.blue.b3':'Oficjalne oznaczenie jako pojazd elektryczny lub hybryda plug-in',
      'products.blue.b4':'Szczegółowe zasady ustalają miasta i gminy',
      'buttons.order_now':'Zamów plakietkę ekologiczną',
      'buttons.more_info':'Zobacz plakietkę E'
    },
    cs: {
      'trust.shipping':'▱ Zpracování a odeslání do jednoho pracovního dne',
      'hero.subtitle':'Za méně než minutu zjistíte, jaká německá ekologická plaketa může být pro vaše vozidlo vydána.',
      'products.green.b1':'Vyžadována pro vjezd do německých ekologických zón',
      'products.green.b2':'Individuálně potištěna vaší registrační značkou s UV odolností',
      'products.green.b3':'Vysoká kvalita – Made in Germany',
      'products.green.b4':'Rychlé zpracování a odeslání do jednoho pracovního dne',
      'products.blue.title':'Modrá E-plaketa',
      'products.blue.addon':'Doporučeno navíc',
      'products.blue.subtitle':'Doporučeno pro zahraniční elektromobily a plug-in hybridy',
      'products.blue.b1':'Podle města možné výhody při parkování',
      'products.blue.b2':'Možné výhody u veřejných dobíjecích stanic',
      'products.blue.b3':'Oficiální označení jako elektromobil nebo plug-in hybrid',
      'products.blue.b4':'Přesná pravidla stanovují města a obce',
      'buttons.order_now':'Objednat ekologickou plaketu',
      'buttons.more_info':'Zobrazit E-plaketu'
    },
    da: {
      'trust.shipping':'▱ Behandling og afsendelse inden for én arbejdsdag',
      'hero.subtitle':'Find på under ét minut ud af, hvilket tysk miljømærkat der kan udstedes til dit køretøj.',
      'products.green.b1':'Påkrævet for indkørsel i tyske miljøzoner',
      'products.green.b2':'Individuelt trykt med din nummerplade i UV-bestandig kvalitet',
      'products.green.b3':'Høj kvalitet – Made in Germany',
      'products.green.b4':'Hurtig behandling og afsendelse inden for én arbejdsdag',
      'products.blue.title':'Blåt E-mærkat',
      'products.blue.addon':'Anbefales som tillæg',
      'products.blue.subtitle':'Anbefales til udenlandsk registrerede el- og plug-in-hybridkøretøjer',
      'products.blue.b1':'Afhængigt af byen kan der være parkeringsfordele',
      'products.blue.b2':'Mulige fordele ved offentlige ladestationer',
      'products.blue.b3':'Officiel identifikation som el- eller plug-in-hybridkøretøj',
      'products.blue.b4':'De præcise regler fastsættes af byer og kommuner',
      'buttons.order_now':'Bestil miljømærkat',
      'buttons.more_info':'Se E-mærkat'
    }
  };
  Object.keys(V45_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V45_TRANSLATIONS[lang]);
  });

  const V60_TRANSLATIONS = {
    de: {
      'hero.eyebrow':'Kostenlose Fahrzeug- & Reisezielprüfung',
      'hero.subtitle':'Finden Sie schnell heraus, ob Ihr Fahrzeug eine Umweltplakette erhalten kann, ob Ihr Reiseziel in Deutschland eine Umweltplakette benötigt oder ob Ihre Fahrtroute durch Umweltzonen führt.',
      'v60.steps.choose':'Prüfung wählen','v60.steps.start':'Prüfung starten','v60.steps.destination':'Reiseziel','v60.start.title':'Was möchten Sie prüfen?','v60.start.sub':'Wählen Sie den passenden Assistenten für Ihre Anfrage.','v60.start.vehicle.title':'Mein Fahrzeug prüfen','v60.start.vehicle.text':'Welche Umweltplakette kann für mein Fahrzeug erteilt werden?','v60.start.vehicle.b1':'Für deutsche und ausländische Fahrzeuge','v60.start.vehicle.b2':'In weniger als einer Minute','v60.start.vehicle.b3':'Direkt zur passenden Plakette','v60.start.vehicle.button':'Fahrzeug jetzt prüfen','v60.start.destination.title':'Mein Reiseziel prüfen','v60.start.destination.text':'Benötige ich für mein Reiseziel in Deutschland eine Umweltplakette?','v60.start.destination.b1':'Ideal für Reisen und Städtereisen','v60.start.destination.b2':'Prüfung von Umweltzonen','v60.start.destination.b3':'Danach Fahrzeug direkt prüfen','v60.start.destination.button':'Reiseziel prüfen','v60.start.note':'Nicht sicher? Prüfen Sie zuerst Ihr Reiseziel – danach können Sie direkt Ihr Fahrzeug prüfen.',
      'zone.title':'Reiseziel prüfen','zone.sub':'Geben Sie eine Stadt, einen Ort oder eine Region in Deutschland ein.','zone.input.label':'Ihr Reiseziel','zone.input.placeholder':'z. B. München / Munich, Berlin, Köln / Cologne, Stuttgart oder Ruhrgebiet / Ruhr area','zone.button':'Reiseziel prüfen','zone.examples':'Bitte geben Sie den deutschen oder englischen Ortsnamen ein. Beispiele: München / Munich, Berlin, Köln / Cologne, Stuttgart, Ruhrgebiet / Ruhr area','zone.error.empty':'Bitte geben Sie Ihr Reiseziel ein.','zone.result.title':'Ergebnis Reisezielprüfung','zone.found.status':'Für Ihr Reiseziel ist eine grüne Umweltplakette erforderlich.','zone.found.permission':'In der dortigen Umweltzone dürfen in der Regel nur Fahrzeuge mit gültiger grüner Umweltplakette fahren.','zone.notfound.status':'Für dieses Reiseziel ist in unserer Umweltzonen-Datenbank aktuell keine aktive Umweltzone hinterlegt.','zone.notfound.permission':'Wenn Sie zusätzlich andere deutsche Städte besuchen oder unsicher sind, empfehlen wir die vorsorgliche Fahrzeugprüfung.','zone.note.found':'Datenstand Umweltzonen: {date}. Maßgeblich ist die jeweils ausgeschilderte Umweltzone vor Ort.','zone.note.notfound':'Datenstand Umweltzonen: {date}. Die Prüfung ersetzt keine Kontrolle der Beschilderung vor Ort.','zone.cta.vehicle':'Fahrzeug jetzt prüfen','zone.cta.vehiclePrecaution':'Fahrzeug vorsorglich prüfen','zone.cta.another':'Anderes Reiseziel prüfen','zone.facts.destination':'Reiseziel','zone.facts.zone':'Umweltzone','zone.facts.state':'Bundesland','zone.facts.badge':'Benötigte Plakette','zone.facts.validFrom':'Gültig seit','zone.facts.dataVersion':'Datenstand','zone.badge.green':'grüne Umweltplakette','zone.multiple.entries':'Mehrere Einträge gefunden'
    },
    en: {
      'hero.eyebrow':'Free vehicle & destination check','hero.subtitle':'Quickly find out whether your vehicle can receive an environmental sticker – or whether your destination in Germany requires one.',
      'v60.steps.choose':'Choose check','v60.steps.start':'Start check','v60.steps.destination':'Destination','v60.start.title':'What would you like to check?','v60.start.sub':'Select the assistant that matches your request.','v60.start.vehicle.title':'Check my vehicle','v60.start.vehicle.text':'Which environmental sticker can be issued for my vehicle?','v60.start.vehicle.b1':'For German and foreign vehicles','v60.start.vehicle.b2':'In less than one minute','v60.start.vehicle.b3':'Directly to the suitable sticker','v60.start.vehicle.button':'Check vehicle now','v60.start.destination.title':'Check my destination','v60.start.destination.text':'Do I need an environmental sticker for my destination in Germany?','v60.start.destination.b1':'Ideal for travel and city trips','v60.start.destination.b2':'Checks environmental zones','v60.start.destination.b3':'Then check your vehicle directly','v60.start.destination.button':'Check destination','v60.start.note':'Not sure? Check your destination first – then you can check your vehicle directly.',
      'zone.title':'Check destination','zone.sub':'Enter a city, town or region in Germany.','zone.input.label':'Your destination','zone.input.placeholder':'e.g. München / Munich, Berlin, Köln / Cologne, Stuttgart or Ruhrgebiet / Ruhr area','zone.button':'Check destination','zone.examples':'Please enter the German or English place name. Examples: München / Munich, Berlin, Köln / Cologne, Stuttgart, Ruhrgebiet / Ruhr area','zone.error.empty':'Please enter your destination.','zone.result.title':'Destination check result','zone.found.status':'A green environmental sticker is required for your destination.','zone.found.permission':'In that environmental zone, vehicles generally may only enter with a valid green environmental sticker.','zone.notfound.status':'Our environmental-zone database currently does not list an active environmental zone for this destination.','zone.notfound.permission':'If you also visit other German cities or are unsure, we recommend checking your vehicle as a precaution.','zone.note.found':'Environmental zone data as of {date}. The local road signs are authoritative.','zone.note.notfound':'Environmental zone data as of {date}. This check does not replace checking local signage.','zone.cta.vehicle':'Check vehicle now','zone.cta.vehiclePrecaution':'Check vehicle as precaution','zone.cta.another':'Check another destination','zone.facts.destination':'Destination','zone.facts.zone':'Environmental zone','zone.facts.state':'Federal state','zone.facts.badge':'Required sticker','zone.facts.validFrom':'Valid since','zone.facts.dataVersion':'Data version','zone.badge.green':'green environmental sticker','zone.multiple.entries':'Several entries found'
    },
    nl: {
      'hero.eyebrow':'Gratis voertuig- en reisdoelcheck','hero.subtitle':'Ontdek snel of uw voertuig een milieusticker kan krijgen – of dat voor uw reisdoel in Duitsland een milieusticker nodig is.',
      'v60.steps.choose':'Controle kiezen','v60.steps.start':'Controle starten','v60.steps.destination':'Reisdoel','v60.start.title':'Wat wilt u controleren?','v60.start.sub':'Kies de passende assistent voor uw aanvraag.','v60.start.vehicle.title':'Mijn voertuig controleren','v60.start.vehicle.text':'Welke milieusticker kan voor mijn voertuig worden afgegeven?','v60.start.vehicle.b1':'Voor Duitse en buitenlandse voertuigen','v60.start.vehicle.b2':'In minder dan één minuut','v60.start.vehicle.b3':'Direct naar de passende sticker','v60.start.vehicle.button':'Voertuig nu controleren','v60.start.destination.title':'Mijn reisdoel controleren','v60.start.destination.text':'Heb ik voor mijn reisdoel in Duitsland een milieusticker nodig?','v60.start.destination.b1':'Ideaal voor reizen en stedentrips','v60.start.destination.b2':'Controle van milieuzones','v60.start.destination.b3':'Daarna direct voertuig controleren','v60.start.destination.button':'Reisdoel controleren','v60.start.note':'Niet zeker? Controleer eerst uw reisdoel – daarna kunt u direct uw voertuig controleren.',
      'zone.title':'Reisdoel controleren','zone.sub':'Voer een stad, plaats of regio in Duitsland in.','zone.input.label':'Uw reisdoel','zone.input.placeholder':'bijv. München / Munich, Berlin, Köln / Cologne, Stuttgart of Ruhrgebiet / Ruhr area','zone.button':'Reisdoel controleren','zone.examples':'Voer de Duitse of Engelse plaatsnaam in. Voorbeelden: München / Munich, Berlin, Köln / Cologne, Stuttgart, Ruhrgebiet / Ruhr area','zone.error.empty':'Voer uw reisdoel in.','zone.result.title':'Resultaat reisdoelcontrole','zone.found.status':'Voor uw reisdoel is een groene milieusticker vereist.','zone.found.permission':'In deze milieuzone mogen voertuigen doorgaans alleen rijden met een geldige groene milieusticker.','zone.notfound.status':'Voor dit reisdoel is in onze milieuzone-database momenteel geen actieve milieuzone opgenomen.','zone.notfound.permission':'Als u ook andere Duitse steden bezoekt of twijfelt, adviseren wij een voorzichtige voertuigcontrole.','zone.note.found':'Gegevensstand milieuzones: {date}. De borden ter plaatse zijn doorslaggevend.','zone.note.notfound':'Gegevensstand milieuzones: {date}. Deze controle vervangt niet de controle van de borden ter plaatse.','zone.cta.vehicle':'Voertuig nu controleren','zone.cta.vehiclePrecaution':'Voertuig uit voorzorg controleren','zone.cta.another':'Ander reisdoel controleren','zone.facts.destination':'Reisdoel','zone.facts.zone':'Milieuzone','zone.facts.state':'Deelstaat','zone.facts.badge':'Benodigde sticker','zone.facts.validFrom':'Geldig sinds','zone.facts.dataVersion':'Gegevensstand','zone.badge.green':'groene milieusticker','zone.multiple.entries':'Meerdere vermeldingen gevonden'
    },
    fr: {
      'hero.eyebrow':'Contrôle gratuit du véhicule et de la destination','hero.subtitle':'Découvrez rapidement si votre véhicule peut recevoir une vignette environnementale – ou si votre destination en Allemagne en exige une.',
      'v60.steps.choose':'Choisir le contrôle','v60.steps.start':'Démarrer le contrôle','v60.steps.destination':'Destination','v60.start.title':'Que souhaitez-vous vérifier ?','v60.start.sub':'Choisissez l’assistant adapté à votre demande.','v60.start.vehicle.title':'Vérifier mon véhicule','v60.start.vehicle.text':'Quelle vignette environnementale peut être délivrée pour mon véhicule ?','v60.start.vehicle.b1':'Pour véhicules allemands et étrangers','v60.start.vehicle.b2':'En moins d’une minute','v60.start.vehicle.b3':'Directement vers la vignette adaptée','v60.start.vehicle.button':'Vérifier le véhicule','v60.start.destination.title':'Vérifier ma destination','v60.start.destination.text':'Ai-je besoin d’une vignette pour ma destination en Allemagne ?','v60.start.destination.b1':'Idéal pour voyages et séjours urbains','v60.start.destination.b2':'Vérification des zones environnementales','v60.start.destination.b3':'Puis vérifier directement le véhicule','v60.start.destination.button':'Vérifier la destination','v60.start.note':'Pas sûr ? Vérifiez d’abord votre destination – puis vous pourrez vérifier directement votre véhicule.',
      'zone.title':'Vérifier la destination','zone.sub':'Saisissez une ville, un lieu ou une région en Allemagne.','zone.input.label':'Votre destination','zone.input.placeholder':'p. ex. München / Munich, Berlin, Köln / Cologne, Stuttgart ou Ruhrgebiet / Ruhr area','zone.button':'Vérifier la destination','zone.examples':'Saisissez le nom allemand ou anglais du lieu. Exemples : München / Munich, Berlin, Köln / Cologne, Stuttgart, Ruhrgebiet / Ruhr area','zone.error.empty':'Veuillez saisir votre destination.','zone.result.title':'Résultat du contrôle de destination','zone.found.status':'Une vignette environnementale verte est requise pour votre destination.','zone.found.permission':'Dans cette zone environnementale, les véhicules ne peuvent généralement circuler qu’avec une vignette verte valable.','zone.notfound.status':'Aucune zone environnementale active n’est actuellement enregistrée pour cette destination dans notre base de données.','zone.notfound.permission':'Si vous visitez également d’autres villes allemandes ou si vous avez un doute, nous recommandons de vérifier votre véhicule par précaution.','zone.note.found':'Données des zones environnementales au {date}. La signalisation sur place fait foi.','zone.note.notfound':'Données des zones environnementales au {date}. Ce contrôle ne remplace pas la vérification de la signalisation sur place.','zone.cta.vehicle':'Vérifier le véhicule','zone.cta.vehiclePrecaution':'Vérifier le véhicule par précaution','zone.cta.another':'Vérifier une autre destination','zone.facts.destination':'Destination','zone.facts.zone':'Zone environnementale','zone.facts.state':'Land fédéral','zone.facts.badge':'Vignette requise','zone.facts.validFrom':'Valable depuis','zone.facts.dataVersion':'Données au','zone.badge.green':'vignette environnementale verte','zone.multiple.entries':'Plusieurs entrées trouvées'
    },
    it: {
      'hero.eyebrow':'Controllo gratuito veicolo e destinazione','hero.subtitle':'Scopra rapidamente se il veicolo può ottenere un bollino ambientale – o se la destinazione in Germania lo richiede.',
      'v60.steps.choose':'Scegli controllo','v60.steps.start':'Avvia controllo','v60.steps.destination':'Destinazione','v60.start.title':'Che cosa desidera verificare?','v60.start.sub':'Scelga l’assistente adatto alla sua richiesta.','v60.start.vehicle.title':'Verificare il mio veicolo','v60.start.vehicle.text':'Quale bollino ambientale può essere rilasciato per il mio veicolo?','v60.start.vehicle.b1':'Per veicoli tedeschi ed esteri','v60.start.vehicle.b2':'In meno di un minuto','v60.start.vehicle.b3':'Direttamente al bollino adatto','v60.start.vehicle.button':'Verifica veicolo','v60.start.destination.title':'Verificare la mia destinazione','v60.start.destination.text':'Ho bisogno di un bollino ambientale per la mia destinazione in Germania?','v60.start.destination.b1':'Ideale per viaggi e city trip','v60.start.destination.b2':'Controllo delle zone ambientali','v60.start.destination.b3':'Poi verifica diretta del veicolo','v60.start.destination.button':'Verifica destinazione','v60.start.note':'Non è sicuro? Verifichi prima la destinazione – poi potrà controllare direttamente il veicolo.',
      'zone.title':'Verifica destinazione','zone.sub':'Inserisca una città, una località o una regione in Germania.','zone.input.label':'La sua destinazione','zone.input.placeholder':'es. München / Munich, Berlin, Köln / Cologne, Stuttgart o Ruhrgebiet / Ruhr area','zone.button':'Verifica destinazione','zone.examples':'Inserisca il nome della località in tedesco o inglese. Esempi: München / Munich, Berlin, Köln / Cologne, Stuttgart, Ruhrgebiet / Ruhr area','zone.error.empty':'Inserisca la destinazione.','zone.result.title':'Risultato verifica destinazione','zone.found.status':'Per la sua destinazione è richiesto un bollino ambientale verde.','zone.found.permission':'In questa zona ambientale, di norma i veicoli possono circolare solo con un bollino verde valido.','zone.notfound.status':'Per questa destinazione non è attualmente registrata alcuna zona ambientale attiva nella nostra banca dati.','zone.notfound.permission':'Se visita anche altre città tedesche o non è sicuro, consigliamo una verifica preventiva del veicolo.','zone.note.found':'Dati zone ambientali aggiornati al {date}. Fa fede la segnaletica sul posto.','zone.note.notfound':'Dati zone ambientali aggiornati al {date}. Questa verifica non sostituisce il controllo della segnaletica locale.','zone.cta.vehicle':'Verifica veicolo','zone.cta.vehiclePrecaution':'Verifica preventiva veicolo','zone.cta.another':'Verifica altra destinazione','zone.facts.destination':'Destinazione','zone.facts.zone':'Zona ambientale','zone.facts.state':'Land federale','zone.facts.badge':'Bollino richiesto','zone.facts.validFrom':'Valido dal','zone.facts.dataVersion':'Dati aggiornati al','zone.badge.green':'bollino ambientale verde','zone.multiple.entries':'Più voci trovate'
    },
    pl: {
      'hero.eyebrow':'Bezpłatna kontrola pojazdu i celu podróży','hero.subtitle':'Szybko sprawdź, czy pojazd może otrzymać plakietkę ekologiczną – albo czy jest ona potrzebna w miejscu docelowym w Niemczech.',
      'v60.steps.choose':'Wybierz kontrolę','v60.steps.start':'Rozpocznij kontrolę','v60.steps.destination':'Cel podróży','v60.start.title':'Co chcesz sprawdzić?','v60.start.sub':'Wybierz asystenta odpowiedniego do zapytania.','v60.start.vehicle.title':'Sprawdź mój pojazd','v60.start.vehicle.text':'Jaka plakietka ekologiczna może zostać wydana dla mojego pojazdu?','v60.start.vehicle.b1':'Dla pojazdów niemieckich i zagranicznych','v60.start.vehicle.b2':'W mniej niż minutę','v60.start.vehicle.b3':'Bezpośrednio do właściwej plakietki','v60.start.vehicle.button':'Sprawdź pojazd','v60.start.destination.title':'Sprawdź cel podróży','v60.start.destination.text':'Czy dla mojego celu podróży w Niemczech potrzebna jest plakietka ekologiczna?','v60.start.destination.b1':'Idealne na podróże i wyjazdy miejskie','v60.start.destination.b2':'Kontrola stref ekologicznych','v60.start.destination.b3':'Następnie bezpośrednia kontrola pojazdu','v60.start.destination.button':'Sprawdź cel podróży','v60.start.note':'Nie masz pewności? Najpierw sprawdź cel podróży – potem możesz bezpośrednio sprawdzić pojazd.',
      'zone.title':'Sprawdź cel podróży','zone.sub':'Wpisz miasto, miejscowość lub region w Niemczech.','zone.input.label':'Cel podróży','zone.input.placeholder':'np. München / Munich, Berlin, Köln / Cologne, Stuttgart lub Ruhrgebiet / Ruhr area','zone.button':'Sprawdź cel podróży','zone.examples':'Wpisz niemiecką lub angielską nazwę miejscowości. Przykłady: München / Munich, Berlin, Köln / Cologne, Stuttgart, Ruhrgebiet / Ruhr area','zone.error.empty':'Wpisz cel podróży.','zone.result.title':'Wynik kontroli celu podróży','zone.found.status':'Dla tego celu podróży wymagana jest zielona plakietka ekologiczna.','zone.found.permission':'W tej strefie ekologicznej pojazdy zwykle mogą poruszać się tylko z ważną zieloną plakietką.','zone.notfound.status':'Dla tego celu podróży w naszej bazie danych nie ma obecnie aktywnej strefy ekologicznej.','zone.notfound.permission':'Jeśli odwiedzasz także inne niemieckie miasta lub masz wątpliwości, zalecamy profilaktyczną kontrolę pojazdu.','zone.note.found':'Stan danych stref ekologicznych: {date}. Decydujące jest oznakowanie na miejscu.','zone.note.notfound':'Stan danych stref ekologicznych: {date}. Kontrola nie zastępuje sprawdzenia oznakowania na miejscu.','zone.cta.vehicle':'Sprawdź pojazd','zone.cta.vehiclePrecaution':'Sprawdź pojazd profilaktycznie','zone.cta.another':'Sprawdź inny cel podróży','zone.facts.destination':'Cel podróży','zone.facts.zone':'Strefa ekologiczna','zone.facts.state':'Kraj związkowy','zone.facts.badge':'Wymagana plakietka','zone.facts.validFrom':'Obowiązuje od','zone.facts.dataVersion':'Stan danych','zone.badge.green':'zielona plakietka ekologiczna','zone.multiple.entries':'Znaleziono kilka wpisów'
    },
    cs: {
      'hero.eyebrow':'Bezplatná kontrola vozidla a cíle cesty','hero.subtitle':'Rychle zjistěte, zda vaše vozidlo může získat ekologickou plaketu – nebo zda ji vyžaduje cíl vaší cesty v Německu.',
      'v60.steps.choose':'Vybrat kontrolu','v60.steps.start':'Spustit kontrolu','v60.steps.destination':'Cíl cesty','v60.start.title':'Co chcete ověřit?','v60.start.sub':'Vyberte asistenta odpovídajícího vašemu požadavku.','v60.start.vehicle.title':'Ověřit moje vozidlo','v60.start.vehicle.text':'Jaká ekologická plaketa může být pro moje vozidlo vydána?','v60.start.vehicle.b1':'Pro německá i zahraniční vozidla','v60.start.vehicle.b2':'Za méně než minutu','v60.start.vehicle.b3':'Přímo k vhodné plaketě','v60.start.vehicle.button':'Ověřit vozidlo','v60.start.destination.title':'Ověřit cíl cesty','v60.start.destination.text':'Potřebuji pro svůj cíl v Německu ekologickou plaketu?','v60.start.destination.b1':'Ideální pro cesty a návštěvy měst','v60.start.destination.b2':'Kontrola ekologických zón','v60.start.destination.b3':'Poté přímo ověřit vozidlo','v60.start.destination.button':'Ověřit cíl cesty','v60.start.note':'Nejste si jisti? Nejdříve ověřte cíl cesty – poté můžete přímo zkontrolovat vozidlo.',
      'zone.title':'Ověřit cíl cesty','zone.sub':'Zadejte město, obec nebo region v Německu.','zone.input.label':'Cíl cesty','zone.input.placeholder':'např. München / Munich, Berlin, Köln / Cologne, Stuttgart nebo Ruhrgebiet / Ruhr area','zone.button':'Ověřit cíl cesty','zone.examples':'Zadejte německý nebo anglický název místa. Příklady: München / Munich, Berlin, Köln / Cologne, Stuttgart, Ruhrgebiet / Ruhr area','zone.error.empty':'Zadejte prosím cíl cesty.','zone.result.title':'Výsledek kontroly cíle cesty','zone.found.status':'Pro tento cíl cesty je vyžadována zelená ekologická plaketa.','zone.found.permission':'V této ekologické zóně mohou vozidla zpravidla jezdit pouze s platnou zelenou plaketou.','zone.notfound.status':'Pro tento cíl cesty není v naší databázi aktuálně uložena žádná aktivní ekologická zóna.','zone.notfound.permission':'Pokud navštívíte i jiná německá města nebo si nejste jisti, doporučujeme preventivní kontrolu vozidla.','zone.note.found':'Stav údajů ekologických zón: {date}. Rozhodující je místní dopravní značení.','zone.note.notfound':'Stav údajů ekologických zón: {date}. Tato kontrola nenahrazuje kontrolu místního značení.','zone.cta.vehicle':'Ověřit vozidlo','zone.cta.vehiclePrecaution':'Ověřit vozidlo preventivně','zone.cta.another':'Ověřit jiný cíl cesty','zone.facts.destination':'Cíl cesty','zone.facts.zone':'Ekologická zóna','zone.facts.state':'Spolková země','zone.facts.badge':'Potřebná plaketa','zone.facts.validFrom':'Platí od','zone.facts.dataVersion':'Stav údajů','zone.badge.green':'zelená ekologická plaketa','zone.multiple.entries':'Nalezeno více záznamů'
    },
    da: {
      'hero.eyebrow':'Gratis køretøjs- og rejsemålstjek','hero.subtitle':'Find hurtigt ud af, om dit køretøj kan få et miljømærkat – eller om dit rejsemål i Tyskland kræver et.',
      'v60.steps.choose':'Vælg kontrol','v60.steps.start':'Start kontrol','v60.steps.destination':'Rejsemål','v60.start.title':'Hvad vil du kontrollere?','v60.start.sub':'Vælg den assistent, der passer til din forespørgsel.','v60.start.vehicle.title':'Kontrollér mit køretøj','v60.start.vehicle.text':'Hvilket miljømærkat kan udstedes til mit køretøj?','v60.start.vehicle.b1':'For tyske og udenlandske køretøjer','v60.start.vehicle.b2':'På under ét minut','v60.start.vehicle.b3':'Direkte til det passende mærkat','v60.start.vehicle.button':'Kontrollér køretøj','v60.start.destination.title':'Kontrollér mit rejsemål','v60.start.destination.text':'Har jeg brug for et miljømærkat til mit rejsemål i Tyskland?','v60.start.destination.b1':'Ideelt til rejser og storbyferier','v60.start.destination.b2':'Kontrol af miljøzoner','v60.start.destination.b3':'Derefter direkte køretøjstjek','v60.start.destination.button':'Kontrollér rejsemål','v60.start.note':'Ikke sikker? Kontrollér først dit rejsemål – derefter kan du kontrollere dit køretøj direkte.',
      'zone.title':'Kontrollér rejsemål','zone.sub':'Indtast en by, et sted eller en region i Tyskland.','zone.input.label':'Dit rejsemål','zone.input.placeholder':'fx München / Munich, Berlin, Köln / Cologne, Stuttgart eller Ruhrgebiet / Ruhr area','zone.button':'Kontrollér rejsemål','zone.examples':'Indtast det tyske eller engelske stednavn. Eksempler: München / Munich, Berlin, Köln / Cologne, Stuttgart, Ruhrgebiet / Ruhr area','zone.error.empty':'Indtast dit rejsemål.','zone.result.title':'Resultat for rejsemålstjek','zone.found.status':'Der kræves et grønt miljømærkat til dit rejsemål.','zone.found.permission':'I denne miljøzone må køretøjer som regel kun køre med et gyldigt grønt miljømærkat.','zone.notfound.status':'For dette rejsemål findes der aktuelt ingen aktiv miljøzone i vores database.','zone.notfound.permission':'Hvis du også besøger andre tyske byer eller er usikker, anbefaler vi et forebyggende køretøjstjek.','zone.note.found':'Datastand miljøzoner: {date}. Skiltningen på stedet er afgørende.','zone.note.notfound':'Datastand miljøzoner: {date}. Kontrollen erstatter ikke kontrol af lokal skiltning.','zone.cta.vehicle':'Kontrollér køretøj','zone.cta.vehiclePrecaution':'Kontrollér køretøj forebyggende','zone.cta.another':'Kontrollér andet rejsemål','zone.facts.destination':'Rejsemål','zone.facts.zone':'Miljøzone','zone.facts.state':'Delstat','zone.facts.badge':'Påkrævet mærkat','zone.facts.validFrom':'Gyldig fra','zone.facts.dataVersion':'Datastand','zone.badge.green':'grønt miljømærkat','zone.multiple.entries':'Flere poster fundet'
    }
  };
  Object.keys(V60_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V60_TRANSLATIONS[lang]);
  });

  const V604_TRANSLATIONS = {
    de: {
      'zone.nearby.title':'Umweltzonen in der Nähe oder auf möglichen weiteren Reiserouten',
      'zone.nearby.lead':'Auch wenn für dieses Reiseziel keine aktive Umweltzone hinterlegt ist, können in der Umgebung oder bei weiteren Stopps Umweltzonen relevant sein:',
      'zone.nearby.generic':'Bekannte Umweltzonen, die häufig auf Reisen relevant sind:',
      'zone.nearby.distance':'ca. {km} km entfernt',
      'zone.recommendation.found':'Kaufempfehlung: Für dieses Reiseziel empfehlen wir die grüne Umweltplakette. Sie können die Plakette direkt bestellen oder optional vorher Ihr Fahrzeug prüfen.'
    },
    en: {
      'zone.nearby.title':'Environmental zones nearby or on possible onward travel routes',
      'zone.nearby.lead':'Even if no active environmental zone is listed for this destination, zones nearby or at additional stops may still be relevant:',
      'zone.nearby.generic':'Well-known environmental zones that are often relevant when travelling:',
      'zone.nearby.distance':'approx. {km} km away',
      'zone.recommendation.found':'Purchase recommendation: for this destination we recommend the green environmental sticker. You can order it directly or optionally check your vehicle first.'
    },
    nl: {
      'zone.nearby.title':'Milieuzones in de buurt of op mogelijke verdere reisroutes',
      'zone.nearby.lead':'Ook als voor dit reisdoel geen actieve milieuzone is opgenomen, kunnen milieuzones in de omgeving of bij extra stops toch relevant zijn:',
      'zone.nearby.generic':'Bekende milieuzones die vaak relevant zijn tijdens reizen:',
      'zone.nearby.distance':'ca. {km} km verwijderd',
      'zone.recommendation.found':'Aankooptip: voor dit reisdoel adviseren wij de groene milieusticker. U kunt de sticker direct bestellen of optioneel eerst uw voertuig controleren.'
    },
    fr: {
      'zone.nearby.title':'Zones environnementales à proximité ou sur de possibles itinéraires de voyage',
      'zone.nearby.lead':'Même si aucune zone environnementale active n’est enregistrée pour cette destination, des zones à proximité ou lors d’autres arrêts peuvent être pertinentes :',
      'zone.nearby.generic':'Zones environnementales connues souvent pertinentes lors des voyages :',
      'zone.nearby.distance':'env. {km} km',
      'zone.recommendation.found':'Recommandation d’achat : pour cette destination, nous recommandons la vignette environnementale verte. Vous pouvez la commander directement ou vérifier d’abord votre véhicule.'
    },
    it: {
      'zone.nearby.title':'Zone ambientali nelle vicinanze o su possibili ulteriori itinerari',
      'zone.nearby.lead':'Anche se per questa destinazione non è registrata alcuna zona ambientale attiva, le zone nelle vicinanze o in ulteriori tappe possono essere rilevanti:',
      'zone.nearby.generic':'Zone ambientali note che sono spesso rilevanti durante i viaggi:',
      'zone.nearby.distance':'circa {km} km',
      'zone.recommendation.found':'Consiglio d’acquisto: per questa destinazione consigliamo il bollino ambientale verde. Può ordinarlo direttamente oppure verificare prima il veicolo.'
    },
    pl: {
      'zone.nearby.title':'Strefy ekologiczne w pobliżu lub na możliwych dalszych trasach podróży',
      'zone.nearby.lead':'Nawet jeśli dla tego celu podróży nie ma aktywnej strefy ekologicznej w bazie, strefy w okolicy lub przy kolejnych postojach mogą być istotne:',
      'zone.nearby.generic':'Znane strefy ekologiczne często istotne podczas podróży:',
      'zone.nearby.distance':'ok. {km} km',
      'zone.recommendation.found':'Rekomendacja zakupu: dla tego celu podróży zalecamy zieloną plakietkę ekologiczną. Możesz zamówić ją od razu lub opcjonalnie najpierw sprawdzić pojazd.'
    },
    cs: {
      'zone.nearby.title':'Ekologické zóny v okolí nebo na možných dalších cestovních trasách',
      'zone.nearby.lead':'I když pro tento cíl není v databázi uvedena aktivní ekologická zóna, zóny v okolí nebo při dalších zastávkách mohou být důležité:',
      'zone.nearby.generic':'Známé ekologické zóny, které jsou při cestování často relevantní:',
      'zone.nearby.distance':'cca {km} km',
      'zone.recommendation.found':'Doporučení k nákupu: pro tento cíl doporučujeme zelenou ekologickou plaketu. Můžete ji objednat přímo nebo si nejprve ověřit vozidlo.'
    },
    da: {
      'zone.nearby.title':'Miljøzoner i nærheden eller på mulige videre rejseruter',
      'zone.nearby.lead':'Selv om der ikke er registreret en aktiv miljøzone for dette rejsemål, kan zoner i nærheden eller ved andre stop stadig være relevante:',
      'zone.nearby.generic':'Kendte miljøzoner, som ofte er relevante på rejser:',
      'zone.nearby.distance':'ca. {km} km væk',
      'zone.recommendation.found':'Købsanbefaling: Til dette rejsemål anbefaler vi det grønne miljømærkat. Du kan bestille det direkte eller valgfrit kontrollere køretøjet først.'
    }
  };
  Object.keys(V604_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V604_TRANSLATIONS[lang]);
  });


  const V606_TRANSLATIONS = {
    de: { 'hero.direct_buy':'Grüne Plakette direkt bestellen' },
    en: { 'hero.direct_buy':'Order green sticker directly' },
    nl: { 'hero.direct_buy':'Groene sticker direct bestellen' },
    fr: { 'hero.direct_buy':'Commander directement la vignette verte' },
    it: { 'hero.direct_buy':'Ordina subito il bollino verde' },
    pl: { 'hero.direct_buy':'Zamów zieloną plakietkę bezpośrednio' },
    cs: { 'hero.direct_buy':'Objednat zelenou plaketu přímo' },
    da: { 'hero.direct_buy':'Bestil grønt mærkat direkte' }
  };
  Object.keys(V606_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V606_TRANSLATIONS[lang]);
  });

  const V611_TRANSLATIONS = {
    de: {
      'zone.foreign.status':'Dieses Reiseziel liegt außerhalb Deutschlands.',
      'zone.foreign.permission':'Für die Fahrt nach oder durch Deutschland kann eine grüne Umweltplakette dennoch sinnvoll oder erforderlich sein, wenn Sie deutsche Umweltzonen oder Innenstädte besuchen.',
      'zone.foreign.note':'Der aktuelle Zielort-Assistent prüft deutsche Städte, Orte und Regionen. Für Reisen außerhalb Deutschlands empfehlen wir zusätzlich die Fahrzeugprüfung oder die Eingabe einer deutschen Stadt auf Ihrer Route.'
    },
    en: {
      'zone.foreign.status':'This destination is outside Germany.',
      'zone.foreign.permission':'For travel to or through Germany, a green environmental sticker may still be useful or required if you visit German environmental zones or city centres.',
      'zone.foreign.note':'The current destination assistant checks German cities, towns and regions. For trips outside Germany, we recommend also checking your vehicle or entering a German city on your route.'
    },
    nl: {
      'zone.foreign.status':'Deze bestemming ligt buiten Duitsland.',
      'zone.foreign.permission':'Voor reizen naar of door Duitsland kan een groene milieusticker toch zinvol of nodig zijn als u Duitse milieuzones of binnensteden bezoekt.',
      'zone.foreign.note':'De huidige reisdoel-assistent controleert Duitse steden, plaatsen en regio’s. Voor reizen buiten Duitsland adviseren wij daarnaast de voertuigcontrole of het invoeren van een Duitse stad op uw route.'
    },
    fr: {
      'zone.foreign.status':'Cette destination se trouve en dehors de l’Allemagne.',
      'zone.foreign.permission':'Pour un trajet vers ou à travers l’Allemagne, une vignette environnementale verte peut toutefois être utile ou nécessaire si vous visitez des zones environnementales ou centres-villes allemands.',
      'zone.foreign.note':'L’assistant de destination actuel vérifie les villes, localités et régions allemandes. Pour les voyages hors d’Allemagne, nous recommandons aussi la vérification du véhicule ou la saisie d’une ville allemande sur votre itinéraire.'
    },
    it: {
      'zone.foreign.status':'Questa destinazione si trova fuori dalla Germania.',
      'zone.foreign.permission':'Per un viaggio verso o attraverso la Germania, il bollino ambientale verde può comunque essere utile o necessario se si visitano zone ambientali o centri cittadini tedeschi.',
      'zone.foreign.note':'L’assistente attuale per la destinazione verifica città, località e regioni in Germania. Per viaggi fuori dalla Germania consigliamo anche il controllo del veicolo o l’inserimento di una città tedesca lungo il percorso.'
    },
    pl: {
      'zone.foreign.status':'Ten cel podróży znajduje się poza Niemcami.',
      'zone.foreign.permission':'Podczas podróży do Niemiec lub przez Niemcy zielona plakietka ekologiczna może być mimo to przydatna albo wymagana, jeśli odwiedzasz niemieckie strefy ekologiczne lub centra miast.',
      'zone.foreign.note':'Obecny asystent celu podróży sprawdza niemieckie miasta, miejscowości i regiony. W przypadku podróży poza Niemcy zalecamy także kontrolę pojazdu lub wpisanie niemieckiego miasta na trasie.'
    },
    cs: {
      'zone.foreign.status':'Tento cíl cesty se nachází mimo Německo.',
      'zone.foreign.permission':'Při cestě do Německa nebo přes Německo může být zelená ekologická plaketa přesto užitečná nebo nutná, pokud navštívíte německé ekologické zóny nebo centra měst.',
      'zone.foreign.note':'Současný asistent cíle cesty kontroluje německá města, obce a regiony. Pro cesty mimo Německo doporučujeme také kontrolu vozidla nebo zadání německého města na trase.'
    },
    da: {
      'zone.foreign.status':'Denne destination ligger uden for Tyskland.',
      'zone.foreign.permission':'Ved rejser til eller gennem Tyskland kan et grønt miljømærkat stadig være nyttigt eller nødvendigt, hvis du besøger tyske miljøzoner eller bycentre.',
      'zone.foreign.note':'Den aktuelle destinationsassistent kontrollerer tyske byer, steder og regioner. Ved rejser uden for Tyskland anbefaler vi også at kontrollere køretøjet eller indtaste en tysk by på ruten.'
    }
  };
  Object.keys(V611_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V611_TRANSLATIONS[lang]);
  });

  const V62_TRANSLATIONS = {
    de: {
      'v62.choice.title':'Wie möchten Sie Ihre Reise prüfen?',
      'v62.choice.sub':'Wählen Sie zwischen der lokalen Zielortprüfung ohne Datenübermittlung und der neuen Routenplanung mit Start- und Zielort.',
      'v62.choice.local.title':'Nur Reiseziel prüfen',
      'v62.choice.local.text':'Prüft eine deutsche Stadt, einen Ort oder eine Region vollständig lokal – ohne Datenübermittlung an Google Maps oder einen anderen Kartendienst.',
      'v62.choice.local.b1':'Ohne Datenübermittlung an Google Maps',
      'v62.choice.local.b2':'Nahe Umweltzonen mit Entfernung',
      'v62.choice.local.b3':'Schnell und datenschutzfreundlich','v62.choice.local.button':'Reiseziel lokal prüfen',
      'v62.choice.route.title':'Route mit Start- und Zielort prüfen',
      'v62.choice.route.text':'Berechnet Ihre Fahrtroute mit Hilfe von Google Maps und prüft, welche deutschen Umweltzonen auf oder nahe Ihrer Strecke liegen.',
      'v62.choice.route.b1':'Mit Google Maps berechnete Fahrtroute',
      'v62.choice.route.b2':'Erkannte Umweltzonen auf oder nahe der Strecke',
      'v62.choice.route.b3':'Karte bleibt auf dieser Seite','v62.choice.route.button':'Routenplaner starten',
      'route.title':'Route auf Umweltzonen prüfen',
      'route.sub':'Geben Sie Start- und Zielort möglichst mit Land an.',
      'route.start.label':'Startort',
      'route.start.placeholder':'z. B. Utrecht, Niederlande',
      'route.destination.label':'Zielort',
      'route.destination.placeholder':'z. B. München, Deutschland',
      'route.button':'Route prüfen',
      'route.loading':'Route wird berechnet …',
      'route.hint':'Tipp: Ort und Land reichen meist aus. Eine genaue Straße ist nur nötig, wenn mehrere Orte denselben Namen haben.',
      'route.privacy':'Mit Klick auf „Route prüfen“ werden Start- und Zielort einmalig an Google Maps übermittelt. Während der Eingabe findet keine Übertragung statt.',
      'route.map.privacy':'Die interaktive Google-Karte wird erst nach Ihrem Klick auf „Route auf Karte anzeigen“ geladen.',
      'route.error.empty':'Bitte geben Sie Start- und Zielort ein.',
      'route.error.same':'Start- und Zielort müssen unterschiedlich sein.',
      'route.error.network':'Die Routenprüfung ist momentan nicht erreichbar. Bitte versuchen Sie es später erneut.',
      'route.error.config':'Der Routenplaner ist noch nicht vollständig eingerichtet.',
      'route.error.notfound':'Für diese Eingaben konnte keine Fahrroute gefunden werden. Bitte ergänzen Sie Ort und Land.',
      'route.error.rate':'Zu viele Routenprüfungen in kurzer Zeit. Bitte warten Sie einige Minuten.',
      'route.result.title':'Ergebnis Routenprüfung',
      'route.found.status':'Auf oder nahe Ihrer berechneten Route wurden deutsche Umweltzonen erkannt.',
      'route.found.permission':'Für Fahrten in diese Umweltzonen ist in der Regel eine gültige grüne Umweltplakette erforderlich.',
      'route.none.status':'Auf der berechneten Route wurden keine deutschen Umweltzonen erkannt.',
      'route.none.permission':'Bei Abweichungen von der Route oder zusätzlichen Stadtbesuchen kann dennoch eine Umweltplakette erforderlich sein.',
      'route.facts.start':'Start',
      'route.facts.destination':'Ziel',
      'route.facts.distance':'Strecke',
      'route.facts.duration':'Fahrzeit ohne Echtzeitverkehr',
      'route.facts.zones':'Erkannte Umweltzonen',
      'route.zones.title':'Umweltzonen auf oder nahe der Route',
      'route.zones.lead':'Die folgenden Umweltzonen wurden anhand der berechneten Strecke erkannt:',
      'route.zones.routeDistance':'ca. {km} km von der Route',
      'route.zones.endpoint':'Start oder Ziel liegt in dieser Umweltzone',
      'route.beta.note':'Beta-Hinweis: Diese erste Version vergleicht die echte Route mit lokalen Umweltzonen-Mittelpunkten. Die genaue Flächenprüfung wird in der nächsten Ausbaustufe ergänzt. Maßgeblich bleiben die Beschilderung vor Ort und die tatsächlich gefahrene Strecke.',
      'route.cta.vehicle':'Fahrzeug jetzt prüfen',
      'route.cta.another':'Andere Route prüfen',
      'route.cta.map':'Route auf Karte anzeigen',
      'route.cta.google':'In Google Maps öffnen',
      'route.modal.title':'Ihre Route',
      'route.modal.close':'Karte schließen',
      'route.modal.noKey':'Die eingebettete Karte ist noch nicht eingerichtet. Sie können die Route in Google Maps öffnen.',
      'v62.steps.route':'Start & Ziel'
    },
    en: {
      'v62.choice.title':'How would you like to check your trip?','v62.choice.sub':'Choose between the local destination check without data transfer and the new route planner with an origin and destination.','v62.choice.local.title':'Check destination only','v62.choice.local.text':'Checks a German city, town or region entirely locally without sending data to Google Maps or another map service.','v62.choice.local.b1':'No data is sent to Google Maps','v62.choice.local.b2':'Nearby environmental zones with distances','v62.choice.local.b3':'Fast and privacy-friendly','v62.choice.local.button':'Check destination locally','v62.choice.route.title':'Check route with origin and destination','v62.choice.route.text':'Calculates your driving route with the help of Google Maps and checks which German environmental zones lie on or near it.','v62.choice.route.b1':'Driving route calculated with Google Maps','v62.choice.route.b2':'Detected environmental zones on or near the route','v62.choice.route.b3':'The map stays on this page','v62.choice.route.button':'Start route planner','route.title':'Check route for environmental zones','route.sub':'Enter the origin and destination, preferably including the country.','route.start.label':'Origin','route.start.placeholder':'e.g. Utrecht, Netherlands','route.destination.label':'Destination','route.destination.placeholder':'e.g. Munich, Germany','route.button':'Check route','route.loading':'Calculating route …','route.hint':'Tip: City and country are usually sufficient. A street is only needed if several places share the same name.','route.privacy':'By clicking “Check route”, the origin and destination are sent once to Google Maps. Nothing is transmitted while you type.','route.map.privacy':'The interactive Google map is loaded only after you click “Show route on map”.','route.error.empty':'Please enter an origin and destination.','route.error.same':'Origin and destination must be different.','route.error.network':'The route check is currently unavailable. Please try again later.','route.error.config':'The route planner has not yet been fully configured.','route.error.notfound':'No driving route could be found for these entries. Please add the city and country.','route.error.rate':'Too many route checks in a short time. Please wait a few minutes.','route.result.title':'Route check result','route.found.status':'German environmental zones were detected on or near your calculated route.','route.found.permission':'A valid green environmental sticker is generally required when driving into these zones.','route.none.status':'No German environmental zones were detected on the calculated route.','route.none.permission':'A sticker may still be required if you leave the route or visit additional cities.','route.facts.start':'Origin','route.facts.destination':'Destination','route.facts.distance':'Distance','route.facts.duration':'Driving time without live traffic','route.facts.zones':'Detected zones','route.zones.title':'Environmental zones on or near the route','route.zones.lead':'The following environmental zones were detected from the calculated route:','route.zones.routeDistance':'approx. {km} km from the route','route.zones.endpoint':'Origin or destination is in this environmental zone','route.beta.note':'Beta note: This first version compares the real route with local environmental-zone centre points. Exact polygon checks will be added in the next stage. Local signs and the route actually driven remain decisive.','route.cta.vehicle':'Check vehicle now','route.cta.another':'Check another route','route.cta.map':'Show route on map','route.cta.google':'Open in Google Maps','route.modal.title':'Your route','route.modal.close':'Close map','route.modal.noKey':'The embedded map has not yet been configured. You can open the route in Google Maps.','v62.steps.route':'Origin & destination'
    },
    nl: {
      'v62.choice.title':'Hoe wilt u uw reis controleren?','v62.choice.sub':'Kies de lokale bestemmingscontrole of de nieuwe routecontrole met vertrek- en aankomstplaats.','v62.choice.local.title':'Alleen bestemming controleren','v62.choice.local.text':'Controleert een Duitse stad, plaats of regio volledig lokaal, zonder gegevens naar een kaartendienst te sturen.','v62.choice.local.b1':'Geen gegevensoverdracht naar Google Maps','v62.choice.local.b2':'Nabije milieuzones met afstand','v62.choice.local.b3':'Snel en privacyvriendelijk','v62.choice.local.button':'Bestemming lokaal controleren','v62.choice.route.title':'Route met vertrek en bestemming controleren','v62.choice.route.text':'Berekent een echte autoroute en controleert welke Duitse milieuzones op of nabij de route liggen.','v62.choice.route.b1':'Rijroute berekend met Google Maps','v62.choice.route.b2':'De kaart blijft op deze pagina','v62.choice.route.b3':'Kaart blijft op deze pagina','v62.choice.route.button':'Routeplanner starten','route.title':'Route op milieuzones controleren','route.sub':'Voer vertrek- en aankomstplaats in, bij voorkeur met land.','route.start.label':'Vertrekplaats','route.start.placeholder':'bijv. Utrecht, Nederland','route.destination.label':'Bestemming','route.destination.placeholder':'bijv. München, Duitsland','route.button':'Route controleren','route.loading':'Route wordt berekend …','route.hint':'Tip: plaats en land zijn meestal voldoende. Een straat is alleen nodig bij gelijknamige plaatsen.','route.privacy':'Door op “Route controleren” te klikken, worden vertrek- en aankomstplaats één keer naar Google Maps gestuurd. Tijdens het typen wordt niets verzonden.','route.map.privacy':'De interactieve Google-kaart wordt pas geladen nadat u op “Route op kaart tonen” klikt.','route.error.empty':'Vul vertrek- en aankomstplaats in.','route.error.same':'Vertrek- en aankomstplaats moeten verschillend zijn.','route.error.network':'De routecontrole is momenteel niet bereikbaar. Probeer het later opnieuw.','route.error.config':'De routeplanner is nog niet volledig ingesteld.','route.error.notfound':'Voor deze invoer kon geen autoroute worden gevonden. Voeg plaats en land toe.','route.error.rate':'Te veel routecontroles in korte tijd. Wacht enkele minuten.','route.result.title':'Resultaat routecontrole','route.found.status':'Op of nabij uw berekende route zijn Duitse milieuzones gevonden.','route.found.permission':'Voor het inrijden van deze milieuzones is doorgaans een geldige groene milieusticker nodig.','route.none.status':'Op de berekende route zijn geen Duitse milieuzones gevonden.','route.none.permission':'Bij afwijkingen van de route of extra stadsbezoeken kan toch een milieusticker nodig zijn.','route.facts.start':'Vertrek','route.facts.destination':'Bestemming','route.facts.distance':'Afstand','route.facts.duration':'Rijtijd zonder live verkeer','route.facts.zones':'Gevonden milieuzones','route.zones.title':'Milieuzones op of nabij de route','route.zones.lead':'De volgende milieuzones zijn op basis van de berekende route gevonden:','route.zones.routeDistance':'ca. {km} km van de route','route.zones.endpoint':'Vertrek of bestemming ligt in deze milieuzone','route.beta.note':'Beta-opmerking: deze eerste versie vergelijkt de echte route met lokale middelpunten van milieuzones. De exacte vlakcontrole volgt in de volgende fase. Plaatselijke borden en de werkelijk gereden route blijven bepalend.','route.cta.vehicle':'Voertuig nu controleren','route.cta.another':'Andere route controleren','route.cta.map':'Route op kaart tonen','route.cta.google':'Openen in Google Maps','route.modal.title':'Uw route','route.modal.close':'Kaart sluiten','route.modal.noKey':'De ingesloten kaart is nog niet ingesteld. U kunt de route in Google Maps openen.','v62.steps.route':'Vertrek & bestemming'
    },
    fr: {
      'v62.choice.title':'Comment souhaitez-vous vérifier votre trajet ?','v62.choice.sub':'Choisissez la vérification locale de la destination ou la nouvelle vérification d’itinéraire avec départ et arrivée.','v62.choice.local.title':'Vérifier uniquement la destination','v62.choice.local.text':'Vérifie une ville, une localité ou une région allemande entièrement en local, sans transmission à un service cartographique.','v62.choice.local.b1':'Aucune donnée transmise à Google Maps','v62.choice.local.b2':'Zones proches avec distances','v62.choice.local.b3':'Rapide et respectueux de la vie privée','v62.choice.local.button':'Vérifier la destination localement','v62.choice.route.title':'Vérifier l’itinéraire avec départ et arrivée','v62.choice.route.text':'Calcule un véritable itinéraire routier et vérifie les zones environnementales allemandes situées sur ou près du trajet.','v62.choice.route.b1':'Une seule requête d’itinéraire par contrôle','v62.choice.route.b2':'Zones environnementales détectées sur ou près du trajet','v62.choice.route.button':'Démarrer le planificateur','route.title':'Vérifier les zones environnementales sur l’itinéraire','route.sub':'Saisissez le départ et l’arrivée, de préférence avec le pays.','route.start.label':'Départ','route.start.placeholder':'p. ex. Utrecht, Pays-Bas','route.destination.label':'Arrivée','route.destination.placeholder':'p. ex. Munich, Allemagne','route.button':'Vérifier l’itinéraire','route.loading':'Calcul de l’itinéraire …','route.hint':'Conseil : la ville et le pays suffisent généralement. Une rue n’est nécessaire qu’en cas d’homonymie.','route.privacy':'En cliquant sur « Vérifier l’itinéraire », le départ et l’arrivée sont transmis une seule fois à Google Maps. Aucune transmission pendant la saisie.','route.map.privacy':'La carte Google interactive n’est chargée qu’après un clic sur « Afficher l’itinéraire sur la carte ».','route.error.empty':'Saisissez le départ et l’arrivée.','route.error.same':'Le départ et l’arrivée doivent être différents.','route.error.network':'La vérification d’itinéraire est momentanément indisponible. Réessayez plus tard.','route.error.config':'Le planificateur d’itinéraire n’est pas encore entièrement configuré.','route.error.notfound':'Aucun itinéraire routier n’a été trouvé. Ajoutez la ville et le pays.','route.error.rate':'Trop de vérifications en peu de temps. Attendez quelques minutes.','route.result.title':'Résultat de la vérification d’itinéraire','route.found.status':'Des zones environnementales allemandes ont été détectées sur ou près de votre itinéraire.','route.found.permission':'Une vignette verte valide est généralement requise pour entrer dans ces zones.','route.none.status':'Aucune zone environnementale allemande n’a été détectée sur l’itinéraire calculé.','route.none.permission':'Une vignette peut toutefois être nécessaire en cas de détour ou de visite d’autres villes.','route.facts.start':'Départ','route.facts.destination':'Arrivée','route.facts.distance':'Distance','route.facts.duration':'Durée sans trafic en temps réel','route.facts.zones':'Zones détectées','route.zones.title':'Zones environnementales sur ou près de l’itinéraire','route.zones.lead':'Les zones suivantes ont été détectées à partir de l’itinéraire calculé :','route.zones.routeDistance':'env. {km} km de l’itinéraire','route.zones.endpoint':'Le départ ou l’arrivée se trouve dans cette zone','route.beta.note':'Note bêta : cette première version compare l’itinéraire réel avec les centres locaux des zones. Le contrôle précis des polygones sera ajouté à l’étape suivante. La signalisation locale et le trajet réellement suivi restent déterminants.','route.cta.vehicle':'Vérifier le véhicule','route.cta.another':'Vérifier un autre itinéraire','route.cta.map':'Afficher l’itinéraire sur la carte','route.cta.google':'Ouvrir dans Google Maps','route.modal.title':'Votre itinéraire','route.modal.close':'Fermer la carte','route.modal.noKey':'La carte intégrée n’est pas encore configurée. Vous pouvez ouvrir l’itinéraire dans Google Maps.','v62.steps.route':'Départ & arrivée'
    },
    it: {
      'v62.choice.title':'Come desidera controllare il viaggio?','v62.choice.sub':'Scelga il controllo locale della destinazione oppure il nuovo controllo del percorso con partenza e arrivo.','v62.choice.local.title':'Controllare solo la destinazione','v62.choice.local.text':'Controlla una città, località o regione tedesca interamente in locale, senza inviare dati a un servizio cartografico.','v62.choice.local.b1':'Nessun dato viene trasmesso a Google Maps','v62.choice.local.b2':'Zone vicine con distanza','v62.choice.local.button':'Controlla destinazione localmente','v62.choice.route.title':'Controllare il percorso con partenza e arrivo','v62.choice.route.text':'Calcola un vero percorso automobilistico e verifica le zone ambientali tedesche lungo o vicino al tragitto.','v62.choice.route.b1':'Una sola richiesta di percorso per controllo','v62.choice.route.b2':'La mappa resta su questa pagina','v62.choice.route.button':'Avvia pianificatore','route.title':'Controllare il percorso per le zone ambientali','route.sub':'Inserisca partenza e arrivo, preferibilmente con il Paese.','route.start.label':'Partenza','route.start.placeholder':'es. Utrecht, Paesi Bassi','route.destination.label':'Arrivo','route.destination.placeholder':'es. Monaco, Germania','route.button':'Controlla percorso','route.loading':'Calcolo del percorso …','route.hint':'Suggerimento: città e Paese sono generalmente sufficienti. La via serve solo per località omonime.','route.privacy':'Facendo clic su “Controlla percorso”, partenza e arrivo vengono inviati una sola volta a Google Maps. Durante la digitazione non viene trasmesso nulla.','route.map.privacy':'La mappa Google interattiva viene caricata solo dopo il clic su “Mostra percorso sulla mappa”.','route.error.empty':'Inserisca partenza e arrivo.','route.error.same':'Partenza e arrivo devono essere diversi.','route.error.network':'Il controllo del percorso non è momentaneamente disponibile. Riprovi più tardi.','route.error.config':'Il pianificatore non è ancora completamente configurato.','route.error.notfound':'Non è stato trovato un percorso automobilistico. Aggiunga città e Paese.','route.error.rate':'Troppe verifiche in poco tempo. Attenda alcuni minuti.','route.result.title':'Risultato controllo percorso','route.found.status':'Sono state rilevate zone ambientali tedesche lungo o vicino al percorso calcolato.','route.found.permission':'Per entrare in queste zone è generalmente necessario un bollino verde valido.','route.none.status':'Non sono state rilevate zone ambientali tedesche sul percorso calcolato.','route.none.permission':'In caso di deviazioni o visite ad altre città, il bollino può comunque essere necessario.','route.facts.start':'Partenza','route.facts.destination':'Arrivo','route.facts.distance':'Distanza','route.facts.duration':'Durata senza traffico in tempo reale','route.facts.zones':'Zone rilevate','route.zones.title':'Zone ambientali lungo o vicino al percorso','route.zones.lead':'Le seguenti zone sono state rilevate dal percorso calcolato:','route.zones.routeDistance':'circa {km} km dal percorso','route.zones.endpoint':'La partenza o l’arrivo si trova in questa zona','route.beta.note':'Nota beta: questa prima versione confronta il percorso reale con i punti centrali locali delle zone. Il controllo preciso delle aree sarà aggiunto nella fase successiva. Restano determinanti la segnaletica locale e il tragitto effettivamente percorso.','route.cta.vehicle':'Controlla veicolo','route.cta.another':'Controlla altro percorso','route.cta.map':'Mostra percorso sulla mappa','route.cta.google':'Apri in Google Maps','route.modal.title':'Il suo percorso','route.modal.close':'Chiudi mappa','route.modal.noKey':'La mappa incorporata non è ancora configurata. Può aprire il percorso in Google Maps.','v62.steps.route':'Partenza & arrivo'
    },
    pl: {
      'v62.choice.title':'Jak chcesz sprawdzić podróż?','v62.choice.sub':'Wybierz lokalną kontrolę celu albo nową kontrolę trasy z miejscem startu i celem.','v62.choice.local.title':'Sprawdź tylko cel podróży','v62.choice.local.text':'Sprawdza niemieckie miasto, miejscowość lub region całkowicie lokalnie, bez wysyłania danych do usługi mapowej.','v62.choice.local.b1':'Szybko i z poszanowaniem prywatności','v62.choice.local.b2':'Pobliskie strefy z odległością','v62.choice.local.b3':'Szybko i przyjaźnie dla prywatności','v62.choice.local.button':'Sprawdź cel lokalnie','v62.choice.route.title':'Sprawdź trasę ze startem i celem','v62.choice.route.text':'Oblicza rzeczywistą trasę samochodową i sprawdza niemieckie strefy ekologiczne na trasie lub w jej pobliżu.','v62.choice.route.b1':'Tylko jedno zapytanie o trasę','v62.choice.route.b2':'Wykryte strefy ekologiczne na trasie lub w jej pobliżu','v62.choice.route.b3':'Mapa pozostaje na tej stronie','v62.choice.route.button':'Uruchom planer trasy','route.title':'Sprawdź trasę pod kątem stref ekologicznych','route.sub':'Wpisz miejsce startu i cel, najlepiej wraz z krajem.','route.start.label':'Miejsce startu','route.start.placeholder':'np. Utrecht, Holandia','route.destination.label':'Cel','route.destination.placeholder':'np. Monachium, Niemcy','route.button':'Sprawdź trasę','route.loading':'Obliczanie trasy …','route.hint':'Wskazówka: miasto i kraj zwykle wystarczą. Ulica jest potrzebna tylko przy miejscowościach o tej samej nazwie.','route.privacy':'Klikając „Sprawdź trasę”, jednorazowo przesyłasz miejsce startu i cel do Google Maps. Podczas wpisywania nic nie jest wysyłane.','route.map.privacy':'Interaktywna mapa Google zostanie załadowana dopiero po kliknięciu „Pokaż trasę na mapie”.','route.error.empty':'Wpisz miejsce startu i cel.','route.error.same':'Miejsce startu i cel muszą być różne.','route.error.network':'Kontrola trasy jest obecnie niedostępna. Spróbuj ponownie później.','route.error.config':'Planer trasy nie jest jeszcze w pełni skonfigurowany.','route.error.notfound':'Nie znaleziono trasy samochodowej. Dodaj miasto i kraj.','route.error.rate':'Zbyt wiele kontroli w krótkim czasie. Odczekaj kilka minut.','route.result.title':'Wynik kontroli trasy','route.found.status':'Na obliczonej trasie lub w jej pobliżu wykryto niemieckie strefy ekologiczne.','route.found.permission':'Wjazd do tych stref zwykle wymaga ważnej zielonej plakietki.','route.none.status':'Na obliczonej trasie nie wykryto niemieckich stref ekologicznych.','route.none.permission':'Przy zjechaniu z trasy lub odwiedzeniu dodatkowych miast plakietka może być mimo to wymagana.','route.facts.start':'Start','route.facts.destination':'Cel','route.facts.distance':'Odległość','route.facts.duration':'Czas bez ruchu na żywo','route.facts.zones':'Wykryte strefy','route.zones.title':'Strefy ekologiczne na trasie lub w jej pobliżu','route.zones.lead':'Na podstawie obliczonej trasy wykryto następujące strefy:','route.zones.routeDistance':'ok. {km} km od trasy','route.zones.endpoint':'Start lub cel znajduje się w tej strefie','route.beta.note':'Uwaga beta: pierwsza wersja porównuje rzeczywistą trasę z lokalnymi punktami środkowymi stref. Dokładna kontrola obszarów zostanie dodana w kolejnym etapie. Decydujące pozostają znaki na miejscu i faktycznie przejechana trasa.','route.cta.vehicle':'Sprawdź pojazd','route.cta.another':'Sprawdź inną trasę','route.cta.map':'Pokaż trasę na mapie','route.cta.google':'Otwórz w Google Maps','route.modal.title':'Twoja trasa','route.modal.close':'Zamknij mapę','route.modal.noKey':'Osadzona mapa nie jest jeszcze skonfigurowana. Możesz otworzyć trasę w Google Maps.','v62.steps.route':'Start i cel'
    },
    cs: {
      'v62.choice.title':'Jak chcete zkontrolovat cestu?','v62.choice.sub':'Vyberte místní kontrolu cíle nebo novou kontrolu trasy se startem a cílem.','v62.choice.local.title':'Zkontrolovat pouze cíl','v62.choice.local.text':'Kontroluje německé město, obec nebo region zcela lokálně bez odeslání údajů mapové službě.','v62.choice.local.b1':'Bez přenosu dat do Google Maps','v62.choice.local.b2':'Blízké ekologické zóny se vzdáleností','v62.choice.local.b3':'Rychlé a šetrné k soukromí','v62.choice.local.button':'Zkontrolovat cíl lokálně','v62.choice.route.title':'Zkontrolovat trasu se startem a cílem','v62.choice.route.text':'Vypočítá skutečnou jízdní trasu a zkontroluje německé ekologické zóny na trase nebo v její blízkosti.','v62.choice.route.b1':'Pouze jeden dotaz na trasu','v62.choice.route.b2':'Mapa zůstane na této stránce','v62.choice.route.b3':'Mapa zůstává na této stránce','v62.choice.route.button':'Spustit plánovač trasy','route.title':'Zkontrolovat ekologické zóny na trase','route.sub':'Zadejte start a cíl, nejlépe včetně země.','route.start.label':'Start','route.start.placeholder':'např. Utrecht, Nizozemsko','route.destination.label':'Cíl','route.destination.placeholder':'např. Mnichov, Německo','route.button':'Zkontrolovat trasu','route.loading':'Trasa se vypočítává …','route.hint':'Tip: město a země obvykle stačí. Ulice je nutná jen u stejně pojmenovaných míst.','route.privacy':'Kliknutím na „Zkontrolovat trasu“ se start a cíl jednorázově odešlou do Google Maps. Během psaní se nic neodesílá.','route.map.privacy':'Interaktivní mapa Google se načte až po kliknutí na „Zobrazit trasu na mapě“.','route.error.empty':'Zadejte start a cíl.','route.error.same':'Start a cíl musí být odlišné.','route.error.network':'Kontrola trasy je momentálně nedostupná. Zkuste to později.','route.error.config':'Plánovač trasy ještě není zcela nastaven.','route.error.notfound':'Pro zadaná místa nebyla nalezena jízdní trasa. Doplňte město a zemi.','route.error.rate':'Příliš mnoho kontrol v krátké době. Počkejte několik minut.','route.result.title':'Výsledek kontroly trasy','route.found.status':'Na vypočítané trase nebo v její blízkosti byly zjištěny německé ekologické zóny.','route.found.permission':'Pro vjezd do těchto zón je zpravidla nutná platná zelená plaketa.','route.none.status':'Na vypočítané trase nebyly zjištěny žádné německé ekologické zóny.','route.none.permission':'Při odchylce od trasy nebo návštěvě dalších měst může být plaketa přesto nutná.','route.facts.start':'Start','route.facts.destination':'Cíl','route.facts.distance':'Vzdálenost','route.facts.duration':'Doba jízdy bez živého provozu','route.facts.zones':'Zjištěné zóny','route.zones.title':'Ekologické zóny na trase nebo v její blízkosti','route.zones.lead':'Podle vypočítané trasy byly zjištěny následující zóny:','route.zones.routeDistance':'asi {km} km od trasy','route.zones.endpoint':'Start nebo cíl leží v této ekologické zóně','route.beta.note':'Poznámka beta: tato první verze porovnává skutečnou trasu s místními středy ekologických zón. Přesná plošná kontrola bude doplněna v další fázi. Rozhodující zůstává místní značení a skutečně projetá trasa.','route.cta.vehicle':'Zkontrolovat vozidlo','route.cta.another':'Zkontrolovat jinou trasu','route.cta.map':'Zobrazit trasu na mapě','route.cta.google':'Otevřít v Google Maps','route.modal.title':'Vaše trasa','route.modal.close':'Zavřít mapu','route.modal.noKey':'Vložená mapa ještě není nastavena. Trasu můžete otevřít v Google Maps.','v62.steps.route':'Start a cíl'
    },
    da: {
      'v62.choice.title':'Hvordan vil du kontrollere rejsen?','v62.choice.sub':'Vælg den lokale destinationskontrol eller den nye rutekontrol med start og mål.','v62.choice.local.title':'Kontrollér kun destinationen','v62.choice.local.text':'Kontrollerer en tysk by, et sted eller en region helt lokalt uden at sende data til en korttjeneste.','v62.choice.local.b1':'Ingen data sendes til Google Maps','v62.choice.local.b2':'Nærliggende miljøzoner med afstand','v62.choice.local.b3':'Hurtig og privatlivsvenlig','v62.choice.local.button':'Kontrollér destination lokalt','v62.choice.route.title':'Kontrollér rute med start og mål','v62.choice.route.text':'Beregner din kørerute med hjælp fra Google Maps og kontrollerer, hvilke tyske miljøzoner der ligger på eller nær ruten.','v62.choice.route.b1':'Kørerute beregnet med Google Maps','v62.choice.route.b2':'Registrerede miljøzoner på eller nær ruten','v62.choice.route.b3':'Kortet bliver på denne side','v62.choice.route.button':'Start ruteplanlægger','route.title':'Kontrollér ruten for miljøzoner','route.sub':'Indtast start og mål, helst med land.','route.start.label':'Startsted','route.start.placeholder':'f.eks. Utrecht, Nederlandene','route.destination.label':'Mål','route.destination.placeholder':'f.eks. München, Tyskland','route.button':'Kontrollér rute','route.loading':'Ruten beregnes …','route.hint':'Tip: by og land er normalt nok. En gade er kun nødvendig ved steder med samme navn.','route.privacy':'Når du klikker på “Kontrollér rute”, sendes start og mål én gang til Google Maps. Der overføres intet, mens du skriver.','route.map.privacy':'Det interaktive Google-kort indlæses først, når du klikker på “Vis rute på kort”.','route.error.empty':'Indtast start og mål.','route.error.same':'Start og mål skal være forskellige.','route.error.network':'Rutekontrollen er ikke tilgængelig lige nu. Prøv igen senere.','route.error.config':'Ruteplanlæggeren er endnu ikke fuldt konfigureret.','route.error.notfound':'Der blev ikke fundet en kørerute. Tilføj by og land.','route.error.rate':'For mange rutekontroller på kort tid. Vent nogle minutter.','route.result.title':'Resultat af rutekontrol','route.found.status':'Der blev fundet tyske miljøzoner på eller nær den beregnede rute.','route.found.permission':'Et gyldigt grønt miljømærkat er normalt nødvendigt for at køre ind i disse zoner.','route.none.status':'Der blev ikke fundet tyske miljøzoner på den beregnede rute.','route.none.permission':'Ved afvigelser eller ekstra bybesøg kan et mærkat stadig være nødvendigt.','route.facts.start':'Start','route.facts.destination':'Mål','route.facts.distance':'Afstand','route.facts.duration':'Køretid uden live trafik','route.facts.zones':'Fundne zoner','route.zones.title':'Miljøzoner på eller nær ruten','route.zones.lead':'Følgende miljøzoner blev fundet ud fra den beregnede rute:','route.zones.routeDistance':'ca. {km} km fra ruten','route.zones.endpoint':'Start eller mål ligger i denne miljøzone','route.beta.note':'Beta-bemærkning: Denne første version sammenligner den rigtige rute med lokale midtpunkter for miljøzoner. Den præcise fladekontrol tilføjes i næste trin. Lokal skiltning og den faktisk kørte rute er fortsat afgørende.','route.cta.vehicle':'Kontrollér køretøj','route.cta.another':'Kontrollér en anden rute','route.cta.map':'Vis rute på kort','route.cta.google':'Åbn i Google Maps','route.modal.title':'Din rute','route.modal.close':'Luk kort','route.modal.noKey':'Det integrerede kort er endnu ikke konfigureret. Du kan åbne ruten i Google Maps.','v62.steps.route':'Start & mål'
    }
  };
  Object.keys(V62_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V62_TRANSLATIONS[lang]);
  });


  const V62B3_TRANSLATIONS = {
    de: {
      'hero.subtitle':'Finden Sie schnell heraus, ob Ihr Fahrzeug eine Umweltplakette erhalten kann, ob Ihr Reiseziel in Deutschland eine Umweltplakette benötigt oder ob Ihre Fahrtroute durch Umweltzonen führt.',
      'v62.choice.sub':'Wählen Sie zwischen der lokalen Zielortprüfung ohne Datenübermittlung und der Routenplanung mit Start- und Zielort.',
      'route.error.daily':'Der Routenplaner ist heute sehr stark genutzt worden. Bitte versuchen Sie es morgen erneut oder nutzen Sie vorerst die lokale Reisezielprüfung.',
      'route.beta.note':'Beta-Hinweis: Diese Version vergleicht die echte Route bereits mit verbesserten Umweltzonen-Radien. Die exakte Flächenprüfung mit Umweltzonen-Grenzen wird in der nächsten Ausbaustufe ergänzt. Maßgeblich bleibt die Beschilderung vor Ort und die tatsächlich gefahrene Route.'
    },
    en: {
      'hero.subtitle':'Quickly find out whether your vehicle can receive an environmental sticker, whether your destination in Germany requires one, or whether your route passes through environmental zones.',
      'v62.choice.sub':'Choose between the local destination check without data transfer and route planning with an origin and destination.',
      'route.error.daily':'The route planner has reached today’s request limit. Please try again tomorrow or use the local destination check for now.',
      'route.beta.note':'Beta note: This version already compares the real route using improved environmental-zone radii. Exact area checks with environmental-zone boundaries will be added in the next stage. Local signs and the route actually driven remain decisive.'
    },
    nl: {
      'hero.subtitle':'Ontdek snel of uw voertuig een milieusticker kan krijgen, of uw bestemming in Duitsland er een vereist, of dat uw route door milieuzones loopt.',
      'v62.choice.sub':'Kies tussen de lokale controle van het reisdoel zonder gegevensoverdracht en de routeplanning met start- en eindpunt.',
      'route.error.daily':'De routeplanner heeft het daglimiet bereikt. Probeer het morgen opnieuw of gebruik voorlopig de lokale reisdoelcontrole.',
      'route.beta.note':'Bèta-opmerking: Deze versie vergelijkt de echte route al met verbeterde milieuzone-stralen. De exacte controle met milieuzonegrenzen volgt in de volgende stap. Doorslaggevend blijven de lokale borden en de werkelijk gereden route.'
    },
    fr: {
      'hero.subtitle':'Découvrez rapidement si votre véhicule peut obtenir une vignette environnementale, si votre destination en Allemagne en nécessite une ou si votre itinéraire passe par des zones environnementales.',
      'v62.choice.sub':'Choisissez entre le contrôle local de la destination sans transmission de données et la planification d’itinéraire avec point de départ et destination.',
      'route.error.daily':'Le planificateur d’itinéraire a atteint la limite de demandes pour aujourd’hui. Veuillez réessayer demain ou utiliser pour le moment le contrôle local de destination.',
      'route.beta.note':'Remarque bêta : cette version compare déjà l’itinéraire réel avec des rayons de zones environnementales améliorés. Le contrôle exact avec les limites de zone sera ajouté lors de la prochaine étape. La signalisation locale et l’itinéraire réellement emprunté restent déterminants.'
    },
    it: {
      'hero.subtitle':'Scopra rapidamente se il suo veicolo può ottenere una vignetta ambientale, se la sua destinazione in Germania ne richiede una oppure se il suo percorso attraversa zone ambientali.',
      'v62.choice.sub':'Scelga tra il controllo locale della destinazione senza trasmissione di dati e la pianificazione del percorso con punto di partenza e destinazione.',
      'route.error.daily':'Il pianificatore di percorso ha raggiunto il limite giornaliero di richieste. Riprovi domani oppure utilizzi per ora il controllo locale della destinazione.',
      'route.beta.note':'Nota beta: questa versione confronta già il percorso reale con raggi migliorati delle zone ambientali. Il controllo esatto con i confini delle zone sarà aggiunto nella prossima fase. Restano determinanti la segnaletica locale e il percorso effettivamente seguito.'
    },
    pl: {
      'hero.subtitle':'Szybko sprawdź, czy Twój pojazd może otrzymać plakietkę ekologiczną, czy jest ona wymagana dla Twojego celu podróży w Niemczech lub czy Twoja trasa prowadzi przez strefy ekologiczne.',
      'v62.choice.sub':'Wybierz między lokalnym sprawdzeniem celu podróży bez przekazywania danych a planowaniem trasy z punktem startowym i docelowym.',
      'route.error.daily':'Planer trasy osiągnął dzisiejszy limit zapytań. Spróbuj ponownie jutro albo skorzystaj na razie z lokalnego sprawdzenia celu podróży.',
      'route.beta.note':'Uwaga beta: ta wersja porównuje już rzeczywistą trasę z ulepszonymi promieniami stref ekologicznych. Dokładne sprawdzanie z granicami stref zostanie dodane w kolejnym etapie. Decydujące pozostają lokalne oznakowanie i rzeczywiście przejechana trasa.'
    },
    cs: {
      'hero.subtitle':'Rychle zjistěte, zda může vaše vozidlo získat ekologickou plaketu, zda ji vaše cílové místo v Německu vyžaduje nebo zda vaše trasa vede přes ekologické zóny.',
      'v62.choice.sub':'Zvolte mezi místní kontrolou cíle bez přenosu dat a plánováním trasy se startem a cílem.',
      'route.error.daily':'Plánovač tras dnes dosáhl limitu požadavků. Zkuste to znovu zítra nebo prozatím použijte místní kontrolu cíle.',
      'route.beta.note':'Poznámka beta: tato verze již porovnává skutečnou trasu se zlepšenými poloměry ekologických zón. Přesná kontrola s hranicemi zón bude doplněna v další fázi. Rozhodující zůstává místní značení a skutečně projetá trasa.'
    },
    da: {
      'hero.subtitle':'Find hurtigt ud af, om dit køretøj kan få et miljømærke, om din destination i Tyskland kræver et, eller om din rute fører gennem miljøzoner.',
      'v62.choice.sub':'Vælg mellem den lokale destinationskontrol uden dataoverførsel og ruteplanlægning med start og mål.',
      'route.error.daily':'Ruteplanlæggeren har nået dagens grænse for forespørgsler. Prøv igen i morgen eller brug den lokale destinationskontrol indtil da.',
      'route.beta.note':'Beta-bemærkning: Denne version sammenligner allerede den rigtige rute med forbedrede miljøzone-radier. Den præcise kontrol med zonegrænser tilføjes i næste trin. Lokal skiltning og den faktisk kørte rute er fortsat afgørende.'
    }
  };
  Object.keys(V62B3_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V62B3_TRANSLATIONS[lang]);
  });


  const V62B4_TRANSLATIONS = {
    de: {
      'route.zones.exact':'Die berechnete Route führt durch oder berührt die offizielle Umweltzonenfläche.',
      'route.polygon.note':'Die Route wurde lokal gegen die zuvor vom Umweltbundesamt abgerufenen Umweltzonenflächen geprüft. Bei normalen Routenanfragen wird keine Verbindung zum UBA-Dienst hergestellt. Maßgeblich bleiben die Beschilderung vor Ort und die tatsächlich gefahrene Route.',
      'route.radius.note':'Die exakten Umweltzonenflächen sind auf dem Server noch nicht aktiviert. Bis zur ersten Datenaktualisierung verwendet der Assistent vorübergehend die bisherige Radius-Prüfung.'
    },
    en: {
      'route.zones.exact':'The calculated route passes through or touches the official environmental-zone area.',
      'route.polygon.note':'The route was checked locally against environmental-zone polygons previously downloaded from the German Environment Agency. Normal route requests do not contact the UBA service. Local signs and the route actually driven remain decisive.',
      'route.radius.note':'The exact environmental-zone polygons have not yet been activated on the server. Until the first data update, the assistant temporarily uses the previous radius check.'
    },
    nl: {
      'route.zones.exact':'De berekende route loopt door of raakt het officiële gebied van de milieuzone.',
      'route.polygon.note':'De route is lokaal gecontroleerd aan de hand van milieuzonevlakken die eerder van het Duitse Umweltbundesamt zijn opgehaald. Bij normale routecontroles wordt geen verbinding met de UBA-dienst gemaakt. Plaatselijke borden en de werkelijk gereden route blijven bepalend.',
      'route.radius.note':'De exacte milieuzonevlakken zijn op de server nog niet geactiveerd. Tot de eerste gegevensupdate gebruikt de assistent tijdelijk de eerdere radiuscontrole.'
    },
    fr: {
      'route.zones.exact':'L’itinéraire calculé traverse ou touche la surface officielle de la zone environnementale.',
      'route.polygon.note':'L’itinéraire a été vérifié localement à l’aide des surfaces de zones environnementales téléchargées auparavant auprès de l’Agence fédérale allemande de l’environnement. Les contrôles normaux ne contactent pas le service UBA. La signalisation locale et l’itinéraire réellement emprunté restent déterminants.',
      'route.radius.note':'Les surfaces exactes des zones environnementales ne sont pas encore activées sur le serveur. Jusqu’à la première mise à jour, l’assistant utilise temporairement l’ancien contrôle par rayon.'
    },
    it: {
      'route.zones.exact':'Il percorso calcolato attraversa o tocca l’area ufficiale della zona ambientale.',
      'route.polygon.note':'Il percorso è stato controllato localmente utilizzando le aree delle zone ambientali scaricate in precedenza dall’Agenzia federale tedesca per l’ambiente. Le normali richieste di percorso non contattano il servizio UBA. Restano determinanti la segnaletica locale e il percorso effettivamente seguito.',
      'route.radius.note':'Le aree esatte delle zone ambientali non sono ancora attivate sul server. Fino al primo aggiornamento dei dati, l’assistente utilizza temporaneamente il precedente controllo a raggio.'
    },
    pl: {
      'route.zones.exact':'Wyznaczona trasa przebiega przez oficjalny obszar strefy ekologicznej lub go dotyka.',
      'route.polygon.note':'Trasa została lokalnie sprawdzona względem obszarów stref ekologicznych pobranych wcześniej z niemieckiego Urzędu Ochrony Środowiska. Zwykłe zapytania o trasę nie łączą się z usługą UBA. Decydujące pozostają lokalne oznakowanie i rzeczywiście przejechana trasa.',
      'route.radius.note':'Dokładne obszary stref ekologicznych nie zostały jeszcze aktywowane na serwerze. Do pierwszej aktualizacji danych asystent tymczasowo korzysta z dotychczasowego sprawdzania promieniem.'
    },
    cs: {
      'route.zones.exact':'Vypočítaná trasa prochází oficiální plochou ekologické zóny nebo se jí dotýká.',
      'route.polygon.note':'Trasa byla lokálně porovnána s plochami ekologických zón, které byly předem staženy z německého Spolkového úřadu pro životní prostředí. Běžné dotazy na trasu službu UBA nekontaktují. Rozhodující zůstává místní značení a skutečně projetá trasa.',
      'route.radius.note':'Přesné plochy ekologických zón ještě nejsou na serveru aktivovány. Do první aktualizace dat používá asistent dočasně dosavadní kontrolu pomocí poloměru.'
    },
    da: {
      'route.zones.exact':'Den beregnede rute går gennem eller berører det officielle miljøzoneområde.',
      'route.polygon.note':'Ruten blev kontrolleret lokalt mod miljøzoneflader, som tidligere er hentet fra det tyske miljøagentur. Normale rutekontroller kontakter ikke UBA-tjenesten. Lokal skiltning og den faktisk kørte rute er fortsat afgørende.',
      'route.radius.note':'De præcise miljøzoneflader er endnu ikke aktiveret på serveren. Indtil den første dataopdatering bruger assistenten midlertidigt den tidligere radiuskontrol.'
    }
  };
  Object.keys(V62B4_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V62B4_TRANSLATIONS[lang]);
  });


  const V62B5_TRANSLATIONS = {
    de: {
      'route.source.label':'Datenquelle Umweltzonen',
      'route.source.text':'{source}. Für den Umweltplaketten-Assistenten bearbeitet und geometrisch vereinfacht. Datenstand: {date}.',
      'route.source.map':'Umweltzonen-Auswertung: {source}. Für den Assistenten bearbeitet und geometrisch vereinfacht. Datenstand: {date}.'
    },
    en: {
      'route.source.label':'Environmental-zone data source',
      'route.source.text':'{source}. Processed and geometrically simplified for the environmental-sticker assistant. Data retrieved: {date}.',
      'route.source.map':'Environmental-zone analysis: {source}. Processed and geometrically simplified for the assistant. Data retrieved: {date}.'
    },
    nl: {
      'route.source.label':'Gegevensbron milieuzones',
      'route.source.text':'{source}. Voor de milieustickerassistent verwerkt en geometrisch vereenvoudigd. Gegevensstand: {date}.',
      'route.source.map':'Milieuzone-analyse: {source}. Voor de assistent verwerkt en geometrisch vereenvoudigd. Gegevensstand: {date}.'
    },
    fr: {
      'route.source.label':'Source des données des zones environnementales',
      'route.source.text':'{source}. Données traitées et géométriquement simplifiées pour l’assistant de vignette environnementale. Date des données : {date}.',
      'route.source.map':'Analyse des zones environnementales : {source}. Données traitées et géométriquement simplifiées pour l’assistant. Date des données : {date}.'
    },
    it: {
      'route.source.label':'Fonte dei dati delle zone ambientali',
      'route.source.text':'{source}. Dati elaborati e semplificati geometricamente per l’assistente delle vignette ambientali. Data dei dati: {date}.',
      'route.source.map':'Analisi delle zone ambientali: {source}. Dati elaborati e semplificati geometricamente per l’assistente. Data dei dati: {date}.'
    },
    pl: {
      'route.source.label':'Źródło danych o strefach ekologicznych',
      'route.source.text':'{source}. Dane opracowane i geometrycznie uproszczone na potrzeby asystenta plakietek ekologicznych. Stan danych: {date}.',
      'route.source.map':'Analiza stref ekologicznych: {source}. Dane opracowane i geometrycznie uproszczone na potrzeby asystenta. Stan danych: {date}.'
    },
    cs: {
      'route.source.label':'Zdroj dat ekologických zón',
      'route.source.text':'{source}. Data byla pro asistenta ekologických plaket zpracována a geometricky zjednodušena. Stav dat: {date}.',
      'route.source.map':'Vyhodnocení ekologických zón: {source}. Data byla pro asistenta zpracována a geometricky zjednodušena. Stav dat: {date}.'
    },
    da: {
      'route.source.label':'Datakilde for miljøzoner',
      'route.source.text':'{source}. Data er bearbejdet og geometrisk forenklet til miljømærkeassistenten. Datastatus: {date}.',
      'route.source.map':'Miljøzoneanalyse: {source}. Data er bearbejdet og geometrisk forenklet til assistenten. Datastatus: {date}.'
    }
  };
  Object.keys(V62B5_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V62B5_TRANSLATIONS[lang]);
  });


  const V62B6_TRANSLATIONS = {
    de: {
      'route.beta.note':'Die Route wird schnell gegen einen lokalen Umweltzonen-Korridor geprüft. Zusätzlich werden vorhandene UBA-Flächendaten für exakte Treffer ausgewertet. Maßgeblich bleiben die Beschilderung vor Ort und die tatsächlich gefahrene Route.'
    },
    en: {
      'route.beta.note':'The route is checked quickly against a local environmental-zone corridor. Available UBA area data is additionally evaluated for exact matches. Local signs and the route actually driven remain decisive.'
    },
    nl: {
      'route.beta.note':'De route wordt snel gecontroleerd met een lokale milieuzonecorridor. Beschikbare UBA-gebiedsgegevens worden daarnaast gebruikt voor exacte treffers. Doorslaggevend blijven de lokale borden en de werkelijk gereden route.'
    },
    fr: {
      'route.beta.note':'L’itinéraire est rapidement contrôlé à l’aide d’un corridor local de zones environnementales. Les données surfaciques disponibles de l’UBA sont également analysées pour les correspondances exactes. La signalisation locale et l’itinéraire réellement emprunté restent déterminants.'
    },
    it: {
      'route.beta.note':'Il percorso viene controllato rapidamente tramite un corridoio locale delle zone ambientali. I dati territoriali UBA disponibili vengono inoltre analizzati per le corrispondenze esatte. Restano determinanti la segnaletica locale e il percorso effettivamente seguito.'
    },
    pl: {
      'route.beta.note':'Trasa jest szybko sprawdzana względem lokalnego korytarza stref ekologicznych. Dostępne dane powierzchniowe UBA są dodatkowo analizowane pod kątem dokładnych trafień. Decydujące pozostają lokalne oznakowanie i rzeczywiście przejechana trasa.'
    },
    cs: {
      'route.beta.note':'Trasa je rychle kontrolována vůči místnímu koridoru ekologických zón. Dostupná plošná data UBA jsou navíc vyhodnocena pro přesné zásahy. Rozhodující zůstává místní značení a skutečně projetá trasa.'
    },
    da: {
      'route.beta.note':'Ruten kontrolleres hurtigt mod en lokal miljøzonekorridor. Tilgængelige UBA-fladedata vurderes desuden for præcise træffere. Lokal skiltning og den faktisk kørte rute er fortsat afgørende.'
    }
  };
  Object.keys(V62B6_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V62B6_TRANSLATIONS[lang]);
  });


  const V62B7_TRANSLATIONS = {
    de: {
      'route.cta.map':'Route mit Umweltzonen auf Karte anzeigen',
      'route.modal.noKey':'Die Kartenansicht mit Umweltzonen-Markierungen ist noch nicht vollständig konfiguriert. Sie können die Route weiterhin in Google Maps öffnen.',
      'route.modal.mapHint':'Auf dieser Karte sind Ihre Fahrtroute sowie die erkannten Umweltzonen markiert.','route.zones.polygon':'Umweltzone auf der berechneten Route erkannt.'
    },
    en: {
      'route.cta.map':'Show route with environmental zones on the map',
      'route.modal.noKey':'The map view with environmental-zone markers has not yet been fully configured. You can still open the route in Google Maps.',
      'route.modal.mapHint':'This map shows your driving route together with the detected environmental zones.','route.zones.polygon':'Environmental zone detected on the calculated route.'
    },
    nl: {
      'route.cta.map':'Route met milieuzones op kaart tonen',
      'route.modal.noKey':'De kaartweergave met markeringen voor milieuzones is nog niet volledig geconfigureerd. U kunt de route nog steeds in Google Maps openen.',
      'route.modal.mapHint':'Deze kaart toont uw rijroute samen met de gevonden milieuzones.','route.zones.polygon':'Milieuzone op de berekende route gedetecteerd.'
    },
    fr: {
      'route.cta.map':'Afficher l’itinéraire avec les zones environnementales sur la carte',
      'route.modal.noKey':'L’affichage cartographique avec repères des zones environnementales n’est pas encore entièrement configuré. Vous pouvez toujours ouvrir l’itinéraire dans Google Maps.',
      'route.modal.mapHint':'Cette carte affiche votre itinéraire ainsi que les zones environnementales détectées.','route.zones.polygon':'Zone environnementale détectée sur l’itinéraire calculé.'
    },
    it: {
      'route.cta.map':'Mostra il percorso con le zone ambientali sulla mappa',
      'route.modal.noKey':'La visualizzazione della mappa con i contrassegni delle zone ambientali non è ancora completamente configurata. Può comunque aprire il percorso in Google Maps.',
      'route.modal.mapHint':'Questa mappa mostra il suo percorso di guida insieme alle zone ambientali rilevate.','route.zones.polygon':'Zona ambientale rilevata sul percorso calcolato.'
    },
    pl: {
      'route.cta.map':'Pokaż trasę ze strefami ekologicznymi na mapie',
      'route.modal.noKey':'Widok mapy z oznaczeniami stref ekologicznych nie jest jeszcze w pełni skonfigurowany. Nadal możesz otworzyć trasę w Google Maps.',
      'route.modal.mapHint':'Ta mapa pokazuje Twoją trasę jazdy wraz z wykrytymi strefami ekologicznymi.','route.zones.polygon':'Wykryto strefę ekologiczną na obliczonej trasie.'
    },
    cs: {
      'route.cta.map':'Zobrazit trasu s ekologickými zónami na mapě',
      'route.modal.noKey':'Zobrazení mapy se značkami ekologických zón ještě není plně nakonfigurováno. Trasou můžete i nadále otevřít v Google Maps.',
      'route.modal.mapHint':'Tato mapa zobrazuje vaši trasu jízdy spolu se zjištěnými ekologickými zónami.','route.zones.polygon':'Ekologická zóna rozpoznána na vypočtené trase.'
    },
    da: {
      'route.cta.map':'Vis rute med miljøzoner på kortet',
      'route.modal.noKey':'Kortvisningen med markeringer af miljøzoner er endnu ikke fuldt konfigureret. Du kan stadig åbne ruten i Google Maps.',
      'route.modal.mapHint':'Dette kort viser din kørerute sammen med de registrerede miljøzoner.','route.zones.polygon':'Miljøzone registreret på den beregnede rute.'
    }
  };
  Object.keys(V62B7_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V62B7_TRANSLATIONS[lang]);
  });


  const V62FINAL_TRANSLATIONS = {
    de: {
      'route.polygon.note':'Die Route wurde lokal gegen die zuvor vom Umweltbundesamt abgerufenen Umweltzonenflächen geprüft. Bei normalen Routenanfragen wird keine Verbindung zum UBA-Dienst hergestellt.',
      'route.authoritative.note':'Maßgeblich bleiben die Beschilderung vor Ort und die tatsächlich gefahrene Route.'
    },
    en: {
      'route.polygon.note':'The route was checked locally against environmental-zone polygons previously downloaded from the German Environment Agency. Normal route requests do not contact the UBA service.',
      'route.authoritative.note':'Local signs and the route actually driven remain decisive.'
    },
    nl: {
      'route.polygon.note':'De route is lokaal gecontroleerd aan de hand van milieuzonevlakken die eerder van het Duitse Umweltbundesamt zijn opgehaald. Bij normale routecontroles wordt geen verbinding met de UBA-dienst gemaakt.',
      'route.authoritative.note':'Plaatselijke borden en de werkelijk gereden route blijven bepalend.'
    },
    fr: {
      'route.polygon.note':'L’itinéraire a été vérifié localement à l’aide des surfaces de zones environnementales téléchargées auparavant auprès de l’Agence fédérale allemande de l’environnement. Les contrôles normaux ne contactent pas le service UBA.',
      'route.authoritative.note':'La signalisation locale et l’itinéraire réellement emprunté restent déterminants.'
    },
    it: {
      'route.polygon.note':'Il percorso è stato controllato localmente utilizzando le aree delle zone ambientali scaricate in precedenza dall’Agenzia federale tedesca per l’ambiente. Le normali richieste di percorso non contattano il servizio UBA.',
      'route.authoritative.note':'Restano determinanti la segnaletica locale e il percorso effettivamente seguito.'
    },
    pl: {
      'route.polygon.note':'Trasa została lokalnie sprawdzona względem obszarów stref ekologicznych pobranych wcześniej z niemieckiego Urzędu Ochrony Środowiska. Zwykłe zapytania o trasę nie łączą się z usługą UBA.',
      'route.authoritative.note':'Decydujące pozostają lokalne oznakowanie i rzeczywiście przejechana trasa.'
    },
    cs: {
      'route.polygon.note':'Trasa byla lokálně porovnána s plochami ekologických zón, které byly předem staženy z německého Spolkového úřadu pro životní prostředí. Běžné dotazy na trasu službu UBA nekontaktují.',
      'route.authoritative.note':'Rozhodující zůstává místní značení a skutečně projetá trasa.'
    },
    da: {
      'route.polygon.note':'Ruten blev kontrolleret lokalt mod miljøzoneflader, som tidligere er hentet fra det tyske miljøagentur. Normale rutekontroller kontakter ikke UBA-tjenesten.',
      'route.authoritative.note':'Lokal skiltning og den faktisk kørte rute er fortsat afgørende.'
    }
  };
  Object.keys(V62FINAL_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V62FINAL_TRANSLATIONS[lang]);
  });


  const V621_TRANSLATIONS = {
    de: {
      'route.modal.mapHint':'Die Fahrtroute ist blau dargestellt. Erkannte Umweltzonen sind grün markiert und flächenhaft hinterlegt.',
      'route.map.area':'Umweltzone – flächenhafte Darstellung'
    },
    en: {
      'route.modal.mapHint':'The driving route is shown in blue. Detected environmental zones are marked and shaded in green.',
      'route.map.area':'Environmental zone – area representation'
    },
    nl: {
      'route.modal.mapHint':'De rijroute is blauw weergegeven. Gevonden milieuzones zijn groen gemarkeerd en als vlak weergegeven.',
      'route.map.area':'Milieuzone – vlakweergave'
    },
    fr: {
      'route.modal.mapHint':'L’itinéraire est affiché en bleu. Les zones environnementales détectées sont marquées et colorées en vert.',
      'route.map.area':'Zone environnementale – représentation surfacique'
    },
    it: {
      'route.modal.mapHint':'Il percorso è visualizzato in blu. Le zone ambientali rilevate sono contrassegnate e colorate in verde.',
      'route.map.area':'Zona ambientale – rappresentazione dell’area'
    },
    pl: {
      'route.modal.mapHint':'Trasa przejazdu jest pokazana na niebiesko. Wykryte strefy ekologiczne są oznaczone i zaznaczone na zielono.',
      'route.map.area':'Strefa ekologiczna – przedstawienie obszaru'
    },
    cs: {
      'route.modal.mapHint':'Trasa jízdy je zobrazena modře. Zjištěné ekologické zóny jsou označeny a plošně zvýrazněny zeleně.',
      'route.map.area':'Ekologická zóna – plošné zobrazení'
    },
    da: {
      'route.modal.mapHint':'Køreruten vises med blåt. Registrerede miljøzoner er markeret og fladefarvet med grønt.',
      'route.map.area':'Miljøzone – fladevisning'
    }
  };
  Object.keys(V621_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V621_TRANSLATIONS[lang]);
  });


  const V63_TRANSLATIONS = {
    de: {
      'zone.map.button.direct':'Umweltzone auf Karte anzeigen',
      'zone.map.button.nearby':'Nahe Umweltzonen auf Karte anzeigen',
      'zone.map.title.direct':'Umweltzone am Reiseziel',
      'zone.map.title.nearby':'Umweltzonen in der Nähe',
      'zone.map.hint.direct':'Das Reiseziel und die dortige Umweltzone sind auf der Karte markiert und flächenhaft dargestellt.',
      'zone.map.hint.nearby':'Das Reiseziel und die nächstgelegenen Umweltzonen sind auf der Karte markiert und flächenhaft dargestellt.',
      'zone.map.destination':'Ihr Reiseziel',
      'zone.map.openGoogle':'Reiseziel in Google Maps öffnen',
      'zone.map.noData':'Für dieses Reiseziel stehen derzeit keine Kartendaten zur Verfügung.',
      'pwa.card.title':'Umweltplaketten-Assistent speichern',
      'pwa.card.text':'Starten Sie die Fahrzeug-, Reiseziel- und Routenprüfung künftig direkt vom Startbildschirm – ohne erneut danach suchen zu müssen.',
      'pwa.card.button':'Auf diesem Gerät speichern',
      'pwa.card.close':'Hinweis ausblenden',
      'pwa.modal.title':'Assistent zum Startbildschirm hinzufügen',
      'pwa.modal.ios':'Tippen Sie in Safari auf das Teilen-Symbol und anschließend auf „Zum Home-Bildschirm“. Bestätigen Sie danach mit „Hinzufügen“.',
      'pwa.modal.android':'Öffnen Sie das Browser-Menü ⋮ und wählen Sie „App installieren“ oder „Zum Startbildschirm hinzufügen“.',
      'pwa.modal.generic':'Öffnen Sie das Browser-Menü und wählen Sie „App installieren“ oder „Zum Startbildschirm hinzufügen“.',
      'pwa.modal.close':'Verstanden',
      'pwa.installing':'Installation wird geöffnet …'
    },
    en: {
      'zone.map.button.direct':'Show environmental zone on map',
      'zone.map.button.nearby':'Show nearby environmental zones on map',
      'zone.map.title.direct':'Environmental zone at your destination',
      'zone.map.title.nearby':'Nearby environmental zones',
      'zone.map.hint.direct':'Your destination and its environmental zone are marked and shown as an area on the map.',
      'zone.map.hint.nearby':'Your destination and the nearest environmental zones are marked and shown as areas on the map.',
      'zone.map.destination':'Your destination',
      'zone.map.openGoogle':'Open destination in Google Maps',
      'zone.map.noData':'Map data is currently unavailable for this destination.',
      'pwa.card.title':'Save the environmental sticker assistant',
      'pwa.card.text':'Open the vehicle, destination and route checks directly from your home screen next time—without searching again.',
      'pwa.card.button':'Save on this device',
      'pwa.card.close':'Hide this message',
      'pwa.modal.title':'Add the assistant to your home screen',
      'pwa.modal.ios':'In Safari, tap the Share icon, then “Add to Home Screen”, and confirm with “Add”.',
      'pwa.modal.android':'Open the browser menu ⋮ and choose “Install app” or “Add to Home screen”.',
      'pwa.modal.generic':'Open the browser menu and choose “Install app” or “Add to Home screen”.',
      'pwa.modal.close':'Got it',
      'pwa.installing':'Opening installation …'
    },
    nl: {
      'zone.map.button.direct':'Milieuzone op kaart tonen',
      'zone.map.button.nearby':'Nabije milieuzones op kaart tonen',
      'zone.map.title.direct':'Milieuzone op uw bestemming',
      'zone.map.title.nearby':'Milieuzones in de buurt',
      'zone.map.hint.direct':'Uw bestemming en de milieuzone daar zijn op de kaart gemarkeerd en als vlak weergegeven.',
      'zone.map.hint.nearby':'Uw bestemming en de dichtstbijzijnde milieuzones zijn op de kaart gemarkeerd en als vlakken weergegeven.',
      'zone.map.destination':'Uw bestemming',
      'zone.map.openGoogle':'Bestemming in Google Maps openen',
      'zone.map.noData':'Voor deze bestemming zijn momenteel geen kaartgegevens beschikbaar.',
      'pwa.card.title':'Milieusticker-assistent opslaan',
      'pwa.card.text':'Start de voertuig-, bestemmings- en routecontrole voortaan direct vanaf uw beginscherm, zonder opnieuw te zoeken.',
      'pwa.card.button':'Op dit apparaat opslaan',
      'pwa.card.close':'Melding verbergen',
      'pwa.modal.title':'Assistent aan het beginscherm toevoegen',
      'pwa.modal.ios':'Tik in Safari op het deel-symbool, kies “Zet op beginscherm” en bevestig met “Voeg toe”.',
      'pwa.modal.android':'Open het browsermenu ⋮ en kies “App installeren” of “Toevoegen aan startscherm”.',
      'pwa.modal.generic':'Open het browsermenu en kies “App installeren” of “Toevoegen aan startscherm”.',
      'pwa.modal.close':'Begrepen',
      'pwa.installing':'Installatie wordt geopend …'
    },
    fr: {
      'zone.map.button.direct':'Afficher la zone environnementale sur la carte',
      'zone.map.button.nearby':'Afficher les zones environnementales proches',
      'zone.map.title.direct':'Zone environnementale à destination',
      'zone.map.title.nearby':'Zones environnementales à proximité',
      'zone.map.hint.direct':'Votre destination et sa zone environnementale sont indiquées et représentées en surface sur la carte.',
      'zone.map.hint.nearby':'Votre destination et les zones environnementales les plus proches sont indiquées et représentées en surface sur la carte.',
      'zone.map.destination':'Votre destination',
      'zone.map.openGoogle':'Ouvrir la destination dans Google Maps',
      'zone.map.noData':'Aucune donnée cartographique n’est actuellement disponible pour cette destination.',
      'pwa.card.title':'Enregistrer l’assistant de vignette environnementale',
      'pwa.card.text':'Accédez directement aux contrôles du véhicule, de la destination et de l’itinéraire depuis votre écran d’accueil, sans nouvelle recherche.',
      'pwa.card.button':'Enregistrer sur cet appareil',
      'pwa.card.close':'Masquer ce message',
      'pwa.modal.title':'Ajouter l’assistant à l’écran d’accueil',
      'pwa.modal.ios':'Dans Safari, touchez l’icône Partager, puis « Sur l’écran d’accueil » et confirmez avec « Ajouter ».',
      'pwa.modal.android':'Ouvrez le menu du navigateur ⋮ et choisissez « Installer l’application » ou « Ajouter à l’écran d’accueil ».',
      'pwa.modal.generic':'Ouvrez le menu du navigateur et choisissez « Installer l’application » ou « Ajouter à l’écran d’accueil ».',
      'pwa.modal.close':'Compris',
      'pwa.installing':'Ouverture de l’installation …'
    },
    it: {
      'zone.map.button.direct':'Mostra la zona ambientale sulla mappa',
      'zone.map.button.nearby':'Mostra le zone ambientali vicine',
      'zone.map.title.direct':'Zona ambientale alla destinazione',
      'zone.map.title.nearby':'Zone ambientali nelle vicinanze',
      'zone.map.hint.direct':'La destinazione e la relativa zona ambientale sono contrassegnate e mostrate come area sulla mappa.',
      'zone.map.hint.nearby':'La destinazione e le zone ambientali più vicine sono contrassegnate e mostrate come aree sulla mappa.',
      'zone.map.destination':'La sua destinazione',
      'zone.map.openGoogle':'Apri la destinazione in Google Maps',
      'zone.map.noData':'Al momento non sono disponibili dati cartografici per questa destinazione.',
      'pwa.card.title':'Salvare l’assistente per la vignetta ambientale',
      'pwa.card.text':'Apra in futuro i controlli del veicolo, della destinazione e del percorso direttamente dalla schermata iniziale, senza cercarli di nuovo.',
      'pwa.card.button':'Salva su questo dispositivo',
      'pwa.card.close':'Nascondi avviso',
      'pwa.modal.title':'Aggiungere l’assistente alla schermata iniziale',
      'pwa.modal.ios':'In Safari tocchi l’icona Condividi, poi “Aggiungi alla schermata Home” e confermi con “Aggiungi”.',
      'pwa.modal.android':'Apra il menu del browser ⋮ e scelga “Installa app” o “Aggiungi a schermata Home”.',
      'pwa.modal.generic':'Apra il menu del browser e scelga “Installa app” o “Aggiungi a schermata Home”.',
      'pwa.modal.close':'Ho capito',
      'pwa.installing':'Apertura dell’installazione …'
    },
    pl: {
      'zone.map.button.direct':'Pokaż strefę ekologiczną na mapie',
      'zone.map.button.nearby':'Pokaż pobliskie strefy ekologiczne',
      'zone.map.title.direct':'Strefa ekologiczna w miejscu docelowym',
      'zone.map.title.nearby':'Pobliskie strefy ekologiczne',
      'zone.map.hint.direct':'Miejsce docelowe i znajdująca się tam strefa ekologiczna są zaznaczone i pokazane powierzchniowo na mapie.',
      'zone.map.hint.nearby':'Miejsce docelowe i najbliższe strefy ekologiczne są zaznaczone i pokazane powierzchniowo na mapie.',
      'zone.map.destination':'Miejsce docelowe',
      'zone.map.openGoogle':'Otwórz cel w Google Maps',
      'zone.map.noData':'Dane mapowe dla tego miejsca są obecnie niedostępne.',
      'pwa.card.title':'Zapisz asystenta plakietki ekologicznej',
      'pwa.card.text':'Następnym razem uruchom sprawdzanie pojazdu, celu i trasy bezpośrednio z ekranu głównego, bez ponownego wyszukiwania.',
      'pwa.card.button':'Zapisz na tym urządzeniu',
      'pwa.card.close':'Ukryj komunikat',
      'pwa.modal.title':'Dodaj asystenta do ekranu głównego',
      'pwa.modal.ios':'W Safari dotknij ikony udostępniania, następnie „Do ekranu początkowego” i potwierdź „Dodaj”.',
      'pwa.modal.android':'Otwórz menu przeglądarki ⋮ i wybierz „Zainstaluj aplikację” lub „Dodaj do ekranu głównego”.',
      'pwa.modal.generic':'Otwórz menu przeglądarki i wybierz „Zainstaluj aplikację” lub „Dodaj do ekranu głównego”.',
      'pwa.modal.close':'Rozumiem',
      'pwa.installing':'Otwieranie instalacji …'
    },
    cs: {
      'zone.map.button.direct':'Zobrazit ekologickou zónu na mapě',
      'zone.map.button.nearby':'Zobrazit blízké ekologické zóny',
      'zone.map.title.direct':'Ekologická zóna v cíli',
      'zone.map.title.nearby':'Ekologické zóny v okolí',
      'zone.map.hint.direct':'Cíl a tamní ekologická zóna jsou na mapě označeny a zobrazeny plošně.',
      'zone.map.hint.nearby':'Cíl a nejbližší ekologické zóny jsou na mapě označeny a zobrazeny plošně.',
      'zone.map.destination':'Váš cíl',
      'zone.map.openGoogle':'Otevřít cíl v Google Maps',
      'zone.map.noData':'Pro tento cíl nejsou momentálně k dispozici mapová data.',
      'pwa.card.title':'Uložit asistenta ekologické plakety',
      'pwa.card.text':'Příště spusťte kontrolu vozidla, cíle a trasy přímo z domovské obrazovky bez nového hledání.',
      'pwa.card.button':'Uložit do tohoto zařízení',
      'pwa.card.close':'Skrýt upozornění',
      'pwa.modal.title':'Přidat asistenta na domovskou obrazovku',
      'pwa.modal.ios':'V Safari klepněte na ikonu Sdílet, potom na „Přidat na plochu“ a potvrďte „Přidat“.',
      'pwa.modal.android':'Otevřete nabídku prohlížeče ⋮ a zvolte „Nainstalovat aplikaci“ nebo „Přidat na plochu“.',
      'pwa.modal.generic':'Otevřete nabídku prohlížeče a zvolte „Nainstalovat aplikaci“ nebo „Přidat na plochu“.',
      'pwa.modal.close':'Rozumím',
      'pwa.installing':'Otevírání instalace …'
    },
    da: {
      'zone.map.button.direct':'Vis miljøzonen på kortet',
      'zone.map.button.nearby':'Vis nærliggende miljøzoner på kortet',
      'zone.map.title.direct':'Miljøzone ved destinationen',
      'zone.map.title.nearby':'Miljøzoner i nærheden',
      'zone.map.hint.direct':'Destinationen og miljøzonen dér er markeret og vist som et område på kortet.',
      'zone.map.hint.nearby':'Destinationen og de nærmeste miljøzoner er markeret og vist som områder på kortet.',
      'zone.map.destination':'Din destination',
      'zone.map.openGoogle':'Åbn destinationen i Google Maps',
      'zone.map.noData':'Der er i øjeblikket ingen kortdata til denne destination.',
      'pwa.card.title':'Gem miljømærke-assistenten',
      'pwa.card.text':'Start fremover køretøjs-, destinations- og rutekontrollen direkte fra startskærmen uden at søge igen.',
      'pwa.card.button':'Gem på denne enhed',
      'pwa.card.close':'Skjul meddelelse',
      'pwa.modal.title':'Føj assistenten til startskærmen',
      'pwa.modal.ios':'Tryk i Safari på delingsikonet, derefter på “Føj til hjemmeskærm”, og bekræft med “Tilføj”.',
      'pwa.modal.android':'Åbn browsermenuen ⋮, og vælg “Installer app” eller “Føj til startskærm”.',
      'pwa.modal.generic':'Åbn browsermenuen, og vælg “Installer app” eller “Føj til startskærm”.',
      'pwa.modal.close':'Forstået',
      'pwa.installing':'Åbner installation …'
    }
  };
  Object.keys(V63_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V63_TRANSLATIONS[lang]);
  });

  const V70_TRANSLATIONS = {
    de: {
      'v7.choice.title':"Wie möchten Sie Ihr Fahrzeug prüfen?",
      'v7.choice.sub':"Sie können die Fahrzeugdaten ohne Upload manuell eingeben oder den Fahrzeugschein einmal hochladen.",
      'v7.country.first.title':"Zuerst das Zulassungsland auswählen",
      'v7.country.first.sub':"Danach zeigt der Assistent nur die für dieses Land passenden Prüfmethoden.",
      'v7.rdw.choice.title':"Wie möchten Sie das niederländische Fahrzeug prüfen?",
      'v7.rdw.choice.sub':"Für niederländische Fahrzeuge wird die automatische RDW-Kennzeichenprüfung vorbereitet. Eine manuelle Prüfung bleibt als Rückfallweg verfügbar.",
      'v7.rdw.title':"Automatische RDW-Kennzeichenprüfung",
      'v7.rdw.text':"Für niederländische Fahrzeuge soll künftig nur das Kennzeichen benötigt werden.",
      'v7.rdw.plateLabel':"Niederländisches Kennzeichen",
      'v7.rdw.b1':"Keine Dokumentübermittlung vorgesehen",
      'v7.rdw.b2':"Fahrzeugdaten automatisch über RDW",
      'v7.rdw.b3':"Aktivierung der Schnittstelle folgt in V7.1",
      'v7.rdw.plateHint':"Geben Sie das niederländische Kennzeichen ein.",
      'v7.rdw.noteBeta':"Testmodus: Das Kennzeichen wird bereits übernommen. Die technischen Fahrzeugdaten werden danach noch manuell abgefragt.",
      'v7.rdw.button':"Mit Kennzeichen fortfahren",
      'v7.rdw.errorPlate':"Bitte geben Sie ein niederländisches Kennzeichen ein.",
      'v7.choice.manual.title':"Fahrzeugdaten manuell eingeben",
      'v7.choice.manual.text':"Kostenlose Prüfung ohne Upload. Sie geben nur die technischen Fahrzeugdaten ein.",
      'v7.choice.manual.b1':"Keine persönlichen Dokumente erforderlich",
      'v7.choice.manual.b2':"Ergebnis in weniger als einer Minute",
      'v7.choice.manual.b3':"Fahrzeugschein erst bei einer Bestellung",
      'v7.choice.manual.button':"Manuelle Prüfung starten",
      'v7.choice.upload.title':"Fahrzeugschein hochladen",
      'v7.choice.upload.text':"Kennzeichen und Dokument einmal eingeben; beim Kauf wird beides automatisch übernommen.",
      'v7.choice.upload.button':"Mit Upload prüfen",
      'v7.upload.title':'Fahrzeugschein einmal hochladen',
      'v7.upload.sub':'Der Fahrzeugschein wird mit Ihrem Fahrzeug verbunden und beim Kauf automatisch an die Bestellung übergeben.',
      'v7.upload.lead':'Fahrzeugschein nur einmal hochladen',
      'v7.upload.help':'Der Upload wird später zusammen mit den Fahrzeugdaten an die Bestellung übergeben.',
      'v7.upload.plateHint':'Bitte so eingeben, wie das Kennzeichen später auf der Plakette stehen soll.',
      'v7.upload.note':'Warten Sie, bis UploadKit den Upload vollständig abgeschlossen hat. Danach können Sie die Fahrzeugprüfung starten.',
      'v7.upload.continue':'Fahrzeugprüfung starten',
      'v7.upload.skip':'Ohne Upload mit der bisherigen Prüfung fortfahren',
      'v7.upload.errorPlate':'Bitte geben Sie das amtliche Kennzeichen ein.',
      'v7.upload.errorFile':'Bitte laden Sie mindestens einen Fahrzeugschein vollständig hoch. Der direkte UploadKit-Link wurde noch nicht gefunden.',
      'v7.upload.fact':'Fahrzeugschein',
      'v7.upload.factReady':'einmalig hochgeladen',
      'v7.order.withData':'Mit diesen Fahrzeugdaten bestellen',
      'v7.order.adding':'Wird in den Warenkorb gelegt …',
      'v7.order.error':'Das Produkt konnte nicht mit den Fahrzeugdaten in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut.',
      'v7.order.success':'Fahrzeugdaten an Warenkorb übergeben'
    },
    en: {
      'v7.choice.title':"How would you like to check your vehicle?",
      'v7.choice.sub':"Enter the vehicle data manually without uploading, or upload the registration document once.",
      'v7.country.first.title':"First select the registration country",
      'v7.country.first.sub':"The assistant will then show only the check methods available for that country.",
      'v7.rdw.choice.title':"How would you like to check the Dutch vehicle?",
      'v7.rdw.choice.sub':"The automatic RDW plate check is being prepared for Dutch vehicles. Manual checking remains available as a fallback.",
      'v7.rdw.title':"Automatic RDW plate check",
      'v7.rdw.text':"In future, only the license plate will be needed for Dutch vehicles.",
      'v7.rdw.plateLabel':"Dutch license plate number",
      'v7.rdw.b1':"No document upload planned",
      'v7.rdw.b2':"Vehicle data automatically from RDW",
      'v7.rdw.b3':"The interface will be activated in V7.1",
      'v7.rdw.plateHint':"Enter the Dutch license plate number.",
      'v7.rdw.noteBeta':"Test mode: The plate is already retained. The technical vehicle data are still entered manually afterwards.",
      'v7.rdw.button':"Continue with license plate",
      'v7.rdw.errorPlate':"Please enter a Dutch license plate number.",
      'v7.choice.manual.title':"Enter vehicle data manually",
      'v7.choice.manual.text':"Free check without an upload. You only enter the technical vehicle data.",
      'v7.choice.manual.b1':"No personal document required",
      'v7.choice.manual.b2':"Result in less than one minute",
      'v7.choice.manual.b3':"Document only required when ordering",
      'v7.choice.manual.button':"Start manual check",
      'v7.choice.upload.title':"Upload registration document",
      'v7.choice.upload.text':"Enter the plate and upload the document once; both are transferred automatically when ordering.",
      'v7.choice.upload.button':"Check with upload",
      'v7.upload.title':'Upload the registration document once',
      'v7.upload.sub':'The document is linked to your vehicle and automatically transferred to the order when you buy.',
      'v7.upload.lead':'Upload the registration document only once',
      'v7.upload.help':'The upload will later be transferred to the order together with the vehicle data.',
      'v7.upload.plateHint':'Enter the number exactly as it should appear on the sticker.',
      'v7.upload.note':'Wait until UploadKit has completed the upload. You can then start the vehicle check.',
      'v7.upload.continue':'Start vehicle check',
      'v7.upload.skip':'Continue with the previous check without uploading',
      'v7.upload.errorPlate':'Please enter the official license plate number.',
      'v7.upload.errorFile':'Please upload at least one registration document completely. The direct UploadKit link has not yet been found.',
      'v7.upload.fact':'Registration document',
      'v7.upload.factReady':'uploaded once',
      'v7.order.withData':'Order with these vehicle data',
      'v7.order.adding':'Adding to cart …',
      'v7.order.error':'The product could not be added with the vehicle data. Please try again.',
      'v7.order.success':'Vehicle data transferred to cart'
    },
    nl: {
      'v7.choice.title':"Hoe wilt u uw voertuig controleren?",
      'v7.choice.sub':"Voer de voertuiggegevens handmatig in zonder upload, of upload het kentekenbewijs één keer.",
      'v7.country.first.title':"Kies eerst het land van registratie",
      'v7.country.first.sub':"Daarna toont de assistent alleen de controlemethoden die voor dat land beschikbaar zijn.",
      'v7.rdw.choice.title':"Hoe wilt u het Nederlandse voertuig controleren?",
      'v7.rdw.choice.sub':"De automatische RDW-kentekencontrole wordt voorbereid. Handmatige controle blijft beschikbaar als terugvaloptie.",
      'v7.rdw.title':"Automatische RDW-kentekencontrole",
      'v7.rdw.text':"Voor Nederlandse voertuigen is straks alleen het kenteken nodig.",
      'v7.rdw.plateLabel':"Kenteken",
      'v7.rdw.b1':"Geen documentupload voorzien",
      'v7.rdw.b2':"Voertuiggegevens automatisch via RDW",
      'v7.rdw.b3':"Activering van de koppeling volgt in V7.1",
      'v7.rdw.plateHint':"Vul het Nederlandse kenteken in.",
      'v7.rdw.noteBeta':"Testmodus: Het kenteken wordt al overgenomen. De technische voertuiggegevens worden daarna nog handmatig ingevoerd.",
      'v7.rdw.button':"Doorgaan met kenteken",
      'v7.rdw.errorPlate':"Vul een Nederlands kenteken in.",
      'v7.choice.manual.title':"Voertuiggegevens handmatig invoeren",
      'v7.choice.manual.text':"Gratis controle zonder upload. U voert alleen de technische voertuiggegevens in.",
      'v7.choice.manual.b1':"Geen persoonlijk document nodig",
      'v7.choice.manual.b2':"Resultaat binnen één minuut",
      'v7.choice.manual.b3':"Kentekenbewijs pas nodig bij bestelling",
      'v7.choice.manual.button':"Handmatige controle starten",
      'v7.choice.upload.title':"Kentekenbewijs uploaden",
      'v7.choice.upload.text':"Voer het kenteken in en upload het document één keer; bij aankoop wordt alles automatisch overgenomen.",
      'v7.choice.upload.button':"Controleren met upload",
      'v7.upload.title':'Kentekenbewijs één keer uploaden',
      'v7.upload.sub':'Het document wordt aan uw voertuig gekoppeld en bij aankoop automatisch aan de bestelling toegevoegd.',
      'v7.upload.lead':'Kentekenbewijs slechts één keer uploaden',
      'v7.upload.help':'De upload wordt later samen met de voertuiggegevens aan de bestelling doorgegeven.',
      'v7.upload.plateHint':'Vul het kenteken in zoals het later op de sticker moet staan.',
      'v7.upload.note':'Wacht tot UploadKit de upload volledig heeft afgerond. Daarna kunt u de voertuigcontrole starten.',
      'v7.upload.continue':'Voertuigcontrole starten',
      'v7.upload.skip':'Doorgaan met de bestaande controle zonder upload',
      'v7.upload.errorPlate':'Vul het kenteken in.',
      'v7.upload.errorFile':'Upload ten minste één kentekenbewijs volledig. De directe UploadKit-link is nog niet gevonden.',
      'v7.upload.fact':'Kentekenbewijs',
      'v7.upload.factReady':'één keer geüpload',
      'v7.order.withData':'Met deze voertuiggegevens bestellen',
      'v7.order.adding':'Wordt aan winkelwagen toegevoegd …',
      'v7.order.error':'Het product kon niet met de voertuiggegevens worden toegevoegd. Probeer het opnieuw.',
      'v7.order.success':'Voertuiggegevens aan winkelwagen doorgegeven'
    },
    fr: {
      'v7.choice.title':"Comment souhaitez-vous contrôler votre véhicule ?",
      'v7.choice.sub':"Saisissez les données du véhicule manuellement sans fichier, ou téléversez la carte grise une seule fois.",
      'v7.country.first.title':"Sélectionnez d’abord le pays d’immatriculation",
      'v7.country.first.sub':"L’assistant affiche ensuite uniquement les méthodes disponibles pour ce pays.",
      'v7.rdw.choice.title':"Comment souhaitez-vous vérifier le véhicule néerlandais ?",
      'v7.rdw.choice.sub':"La vérification automatique via RDW est en préparation. La saisie manuelle reste disponible comme solution de secours.",
      'v7.rdw.title':"Vérification automatique RDW",
      'v7.rdw.text':"Pour les véhicules néerlandais, seul le numéro d’immatriculation sera bientôt nécessaire.",
      'v7.rdw.plateLabel':"Immatriculation néerlandaise",
      'v7.rdw.b1':"Aucun document à téléverser prévu",
      'v7.rdw.b2':"Données du véhicule automatiquement via RDW",
      'v7.rdw.b3':"Activation de l’interface prévue en V7.1",
      'v7.rdw.plateHint':"Saisissez l’immatriculation néerlandaise.",
      'v7.rdw.noteBeta':"Mode test : l’immatriculation est déjà conservée. Les données techniques sont encore saisies manuellement ensuite.",
      'v7.rdw.button':"Continuer avec l’immatriculation",
      'v7.rdw.errorPlate':"Veuillez saisir une immatriculation néerlandaise.",
      'v7.choice.manual.title':"Saisir les données manuellement",
      'v7.choice.manual.text':"Contrôle gratuit sans téléversement. Vous saisissez uniquement les données techniques du véhicule.",
      'v7.choice.manual.b1':"Aucun document personnel nécessaire",
      'v7.choice.manual.b2':"Résultat en moins d’une minute",
      'v7.choice.manual.b3':"Carte grise requise seulement à la commande",
      'v7.choice.manual.button':"Démarrer le contrôle manuel",
      'v7.choice.upload.title':"Téléverser la carte grise",
      'v7.choice.upload.text':"Saisissez l’immatriculation et téléversez le document une fois ; les deux seront repris automatiquement lors de la commande.",
      'v7.choice.upload.button':"Contrôler avec le document",
      'v7.upload.title':'Téléverser la carte grise une seule fois',
      'v7.upload.sub':'Le document est associé à votre véhicule et transmis automatiquement à la commande lors de l’achat.',
      'v7.upload.lead':'Téléverser la carte grise une seule fois',
      'v7.upload.help':'Le fichier sera ensuite transmis à la commande avec les données du véhicule.',
      'v7.upload.plateHint':'Saisissez l’immatriculation telle qu’elle devra apparaître sur la vignette.',
      'v7.upload.note':'Attendez qu’UploadKit ait terminé le téléversement avant de lancer le contrôle.',
      'v7.upload.continue':'Lancer le contrôle du véhicule',
      'v7.upload.skip':'Continuer avec le contrôle actuel sans téléversement',
      'v7.upload.errorPlate':'Veuillez saisir le numéro d’immatriculation.',
      'v7.upload.errorFile':'Veuillez téléverser complètement au moins une carte grise. Le lien direct UploadKit n’a pas encore été trouvé.',
      'v7.upload.fact':'Carte grise',
      'v7.upload.factReady':'téléversée une fois',
      'v7.order.withData':'Commander avec ces données du véhicule',
      'v7.order.adding':'Ajout au panier …',
      'v7.order.error':'Le produit n’a pas pu être ajouté avec les données du véhicule. Veuillez réessayer.',
      'v7.order.success':'Données du véhicule transmises au panier'
    },
    it: {
      'v7.choice.title':"Come desidera controllare il veicolo?",
      'v7.choice.sub':"Inserisca manualmente i dati senza caricare file oppure carichi il libretto una sola volta.",
      'v7.country.first.title':"Selezionare prima il Paese di immatricolazione",
      'v7.country.first.sub':"L’assistente mostrerà poi solo i metodi disponibili per quel Paese.",
      'v7.rdw.choice.title':"Come desidera controllare il veicolo olandese?",
      'v7.rdw.choice.sub':"Il controllo automatico RDW è in preparazione. Il controllo manuale resta disponibile come alternativa.",
      'v7.rdw.title':"Controllo automatico RDW",
      'v7.rdw.text':"Per i veicoli olandesi in futuro servirà solo la targa.",
      'v7.rdw.plateLabel':"Targa olandese",
      'v7.rdw.b1':"Nessun caricamento di documenti previsto",
      'v7.rdw.b2':"Dati del veicolo automaticamente da RDW",
      'v7.rdw.b3':"Attivazione dell’interfaccia prevista in V7.1",
      'v7.rdw.plateHint':"Inserire la targa olandese.",
      'v7.rdw.noteBeta':"Modalità test: la targa viene già memorizzata. I dati tecnici vengono ancora inseriti manualmente nel passaggio successivo.",
      'v7.rdw.button':"Continua con la targa",
      'v7.rdw.errorPlate':"Inserire una targa olandese.",
      'v7.choice.manual.title':"Inserire i dati manualmente",
      'v7.choice.manual.text':"Controllo gratuito senza caricamento. Inserisce solo i dati tecnici del veicolo.",
      'v7.choice.manual.b1':"Nessun documento personale necessario",
      'v7.choice.manual.b2':"Risultato in meno di un minuto",
      'v7.choice.manual.b3':"Libretto richiesto solo per l’ordine",
      'v7.choice.manual.button':"Avvia controllo manuale",
      'v7.choice.upload.title':"Caricare il libretto",
      'v7.choice.upload.text':"Inserisca la targa e carichi il documento una sola volta; all’acquisto verranno trasferiti automaticamente.",
      'v7.choice.upload.button':"Controlla con caricamento",
      'v7.upload.title':'Carica il libretto una sola volta',
      'v7.upload.sub':'Il documento viene collegato al veicolo e trasferito automaticamente all’ordine al momento dell’acquisto.',
      'v7.upload.lead':'Carica il libretto una sola volta',
      'v7.upload.help':'Il file verrà poi trasferito all’ordine insieme ai dati del veicolo.',
      'v7.upload.plateHint':'Inserisci la targa come dovrà apparire sul bollino.',
      'v7.upload.note':'Attendi che UploadKit abbia completato il caricamento, poi avvia il controllo.',
      'v7.upload.continue':'Avvia controllo veicolo',
      'v7.upload.skip':'Continua con il controllo precedente senza caricamento',
      'v7.upload.errorPlate':'Inserisci la targa ufficiale.',
      'v7.upload.errorFile':'Carica completamente almeno un libretto. Il link diretto UploadKit non è ancora disponibile.',
      'v7.upload.fact':'Libretto',
      'v7.upload.factReady':'caricato una volta',
      'v7.order.withData':'Ordina con questi dati del veicolo',
      'v7.order.adding':'Aggiunta al carrello …',
      'v7.order.error':'Non è stato possibile aggiungere il prodotto con i dati del veicolo. Riprova.',
      'v7.order.success':'Dati del veicolo trasferiti al carrello'
    },
    pl: {
      'v7.choice.title':"Jak chcesz sprawdzić pojazd?",
      'v7.choice.sub':"Wprowadź dane pojazdu ręcznie bez przesyłania pliku albo prześlij dowód rejestracyjny tylko raz.",
      'v7.country.first.title':"Najpierw wybierz kraj rejestracji",
      'v7.country.first.sub':"Następnie asystent pokaże tylko metody dostępne dla tego kraju.",
      'v7.rdw.choice.title':"Jak chcesz sprawdzić pojazd z Holandii?",
      'v7.rdw.choice.sub':"Automatyczna kontrola numeru przez RDW jest przygotowywana. Kontrola ręczna pozostaje dostępna awaryjnie.",
      'v7.rdw.title':"Automatyczna kontrola RDW",
      'v7.rdw.text':"Dla pojazdów holenderskich w przyszłości wystarczy sam numer rejestracyjny.",
      'v7.rdw.plateLabel':"Holenderski numer rejestracyjny",
      'v7.rdw.b1':"Bez przesyłania dokumentu",
      'v7.rdw.b2':"Dane pojazdu automatycznie z RDW",
      'v7.rdw.b3':"Uruchomienie połączenia w V7.1",
      'v7.rdw.plateHint':"Wpisz holenderski numer rejestracyjny.",
      'v7.rdw.noteBeta':"Tryb testowy: numer jest już zapisywany. Dane techniczne są jeszcze wpisywane ręcznie w następnym kroku.",
      'v7.rdw.button':"Kontynuuj z numerem",
      'v7.rdw.errorPlate':"Wpisz holenderski numer rejestracyjny.",
      'v7.choice.manual.title':"Wprowadź dane pojazdu ręcznie",
      'v7.choice.manual.text':"Bezpłatna kontrola bez przesyłania dokumentu. Podajesz tylko dane techniczne pojazdu.",
      'v7.choice.manual.b1':"Bez podawania dokumentów osobistych",
      'v7.choice.manual.b2':"Wynik w mniej niż minutę",
      'v7.choice.manual.b3':"Dowód potrzebny dopiero przy zamówieniu",
      'v7.choice.manual.button':"Rozpocznij kontrolę ręczną",
      'v7.choice.upload.title':"Prześlij dowód rejestracyjny",
      'v7.choice.upload.text':"Wpisz numer i prześlij dokument jeden raz; przy zakupie oba zostaną automatycznie przekazane.",
      'v7.choice.upload.button':"Sprawdź z dokumentem",
      'v7.upload.title':'Prześlij dowód rejestracyjny tylko raz',
      'v7.upload.sub':'Dokument zostanie powiązany z pojazdem i automatycznie przekazany do zamówienia przy zakupie.',
      'v7.upload.lead':'Prześlij dowód rejestracyjny tylko raz',
      'v7.upload.help':'Plik zostanie później przekazany do zamówienia razem z danymi pojazdu.',
      'v7.upload.plateHint':'Wpisz numer tak, jak ma się później znaleźć na plakietce.',
      'v7.upload.note':'Poczekaj na pełne zakończenie przesyłania przez UploadKit, a następnie rozpocznij kontrolę.',
      'v7.upload.continue':'Rozpocznij kontrolę pojazdu',
      'v7.upload.skip':'Kontynuuj dotychczasową kontrolę bez przesyłania',
      'v7.upload.errorPlate':'Wpisz numer rejestracyjny.',
      'v7.upload.errorFile':'Prześlij w całości co najmniej jeden dowód rejestracyjny. Bezpośredni link UploadKit nie został jeszcze znaleziony.',
      'v7.upload.fact':'Dowód rejestracyjny',
      'v7.upload.factReady':'przesłany jeden raz',
      'v7.order.withData':'Zamów z tymi danymi pojazdu',
      'v7.order.adding':'Dodawanie do koszyka …',
      'v7.order.error':'Nie udało się dodać produktu z danymi pojazdu. Spróbuj ponownie.',
      'v7.order.success':'Dane pojazdu przekazane do koszyka'
    },
    cs: {
      'v7.choice.title':"Jak chcete vozidlo zkontrolovat?",
      'v7.choice.sub':"Zadejte údaje o vozidle ručně bez nahrávání, nebo jednou nahrajte technický průkaz.",
      'v7.country.first.title':"Nejprve vyberte zemi registrace",
      'v7.country.first.sub':"Asistent poté zobrazí pouze metody dostupné pro danou zemi.",
      'v7.rdw.choice.title':"Jak chcete zkontrolovat nizozemské vozidlo?",
      'v7.rdw.choice.sub':"Automatická kontrola RDW se připravuje. Ruční kontrola zůstává jako záložní možnost.",
      'v7.rdw.title':"Automatická kontrola RDW",
      'v7.rdw.text':"U nizozemských vozidel bude v budoucnu potřeba pouze registrační značka.",
      'v7.rdw.plateLabel':"Nizozemská registrační značka",
      'v7.rdw.b1':"Bez nahrávání dokumentu",
      'v7.rdw.b2':"Údaje o vozidle automaticky z RDW",
      'v7.rdw.b3':"Aktivace rozhraní bude ve V7.1",
      'v7.rdw.plateHint':"Zadejte nizozemskou registrační značku.",
      'v7.rdw.noteBeta':"Testovací režim: značka se již převezme. Technické údaje se zatím zadávají ručně v dalším kroku.",
      'v7.rdw.button':"Pokračovat s registrační značkou",
      'v7.rdw.errorPlate':"Zadejte nizozemskou registrační značku.",
      'v7.choice.manual.title':"Zadat údaje o vozidle ručně",
      'v7.choice.manual.text':"Bezplatná kontrola bez nahrávání. Zadáte pouze technické údaje vozidla.",
      'v7.choice.manual.b1':"Bez osobních dokumentů",
      'v7.choice.manual.b2':"Výsledek do jedné minuty",
      'v7.choice.manual.b3':"Doklad je nutný až při objednávce",
      'v7.choice.manual.button':"Spustit ruční kontrolu",
      'v7.choice.upload.title':"Nahrát technický průkaz",
      'v7.choice.upload.text':"Zadejte registrační značku a jednou nahrajte doklad; při nákupu se vše automaticky převezme.",
      'v7.choice.upload.button':"Zkontrolovat s dokladem",
      'v7.upload.title':'Nahrajte technický průkaz pouze jednou',
      'v7.upload.sub':'Dokument se propojí s vozidlem a při nákupu se automaticky předá k objednávce.',
      'v7.upload.lead':'Nahrajte technický průkaz pouze jednou',
      'v7.upload.help':'Soubor se později předá k objednávce společně s údaji vozidla.',
      'v7.upload.plateHint':'Zadejte registrační značku tak, jak má být uvedena na plakátě.',
      'v7.upload.note':'Počkejte, až UploadKit nahrávání dokončí, a potom spusťte kontrolu vozidla.',
      'v7.upload.continue':'Spustit kontrolu vozidla',
      'v7.upload.skip':'Pokračovat v dosavadní kontrole bez nahrání',
      'v7.upload.errorPlate':'Zadejte registrační značku.',
      'v7.upload.errorFile':'Nahrajte úplně alespoň jeden technický průkaz. Přímý odkaz UploadKit zatím nebyl nalezen.',
      'v7.upload.fact':'Technický průkaz',
      'v7.upload.factReady':'nahrán jednou',
      'v7.order.withData':'Objednat s těmito údaji vozidla',
      'v7.order.adding':'Přidává se do košíku …',
      'v7.order.error':'Produkt se nepodařilo přidat s údaji vozidla. Zkuste to znovu.',
      'v7.order.success':'Údaje vozidla předány do košíku'
    },
    da: {
      'v7.choice.title':"Hvordan vil du kontrollere køretøjet?",
      'v7.choice.sub':"Indtast køretøjsdata manuelt uden upload, eller upload registreringsattesten én gang.",
      'v7.country.first.title':"Vælg først registreringslandet",
      'v7.country.first.sub':"Derefter viser assistenten kun de kontrolmetoder, der er tilgængelige for landet.",
      'v7.rdw.choice.title':"Hvordan vil du kontrollere det nederlandske køretøj?",
      'v7.rdw.choice.sub':"Den automatiske RDW-kontrol forberedes. Manuel kontrol er fortsat tilgængelig som reserve.",
      'v7.rdw.title':"Automatisk RDW-kontrol",
      'v7.rdw.text':"For nederlandske køretøjer skal kun nummerpladen bruges fremover.",
      'v7.rdw.plateLabel':"Nederlandsk nummerplade",
      'v7.rdw.b1':"Ingen dokumentupload planlagt",
      'v7.rdw.b2':"Køretøjsdata automatisk fra RDW",
      'v7.rdw.b3':"Aktivering af forbindelsen følger i V7.1",
      'v7.rdw.plateHint':"Indtast den nederlandske nummerplade.",
      'v7.rdw.noteBeta':"Testtilstand: Nummerpladen gemmes allerede. De tekniske data indtastes stadig manuelt i næste trin.",
      'v7.rdw.button':"Fortsæt med nummerpladen",
      'v7.rdw.errorPlate':"Indtast en nederlandsk nummerplade.",
      'v7.choice.manual.title':"Indtast køretøjsdata manuelt",
      'v7.choice.manual.text':"Gratis kontrol uden upload. Du indtaster kun køretøjets tekniske data.",
      'v7.choice.manual.b1':"Ingen personlige dokumenter nødvendige",
      'v7.choice.manual.b2':"Resultat på under ét minut",
      'v7.choice.manual.b3':"Dokument først nødvendigt ved bestilling",
      'v7.choice.manual.button':"Start manuel kontrol",
      'v7.choice.upload.title':"Upload registreringsattest",
      'v7.choice.upload.text':"Indtast nummerpladen og upload dokumentet én gang; begge dele overføres automatisk ved køb.",
      'v7.choice.upload.button':"Kontrollér med upload",
      'v7.upload.title':'Upload registreringsattesten én gang',
      'v7.upload.sub':'Dokumentet knyttes til køretøjet og overføres automatisk til ordren ved køb.',
      'v7.upload.lead':'Upload registreringsattesten kun én gang',
      'v7.upload.help':'Filen overføres senere til ordren sammen med køretøjsdataene.',
      'v7.upload.plateHint':'Indtast nummeret, som det senere skal stå på mærket.',
      'v7.upload.note':'Vent, indtil UploadKit har afsluttet uploaden, og start derefter køretøjskontrollen.',
      'v7.upload.continue':'Start køretøjskontrol',
      'v7.upload.skip':'Fortsæt med den hidtidige kontrol uden upload',
      'v7.upload.errorPlate':'Indtast registreringsnummeret.',
      'v7.upload.errorFile':'Upload mindst én registreringsattest helt. Det direkte UploadKit-link er endnu ikke fundet.',
      'v7.upload.fact':'Registreringsattest',
      'v7.upload.factReady':'uploadet én gang',
      'v7.order.withData':'Bestil med disse køretøjsdata',
      'v7.order.adding':'Føjes til kurven …',
      'v7.order.error':'Produktet kunne ikke tilføjes med køretøjsdataene. Prøv igen.',
      'v7.order.success':'Køretøjsdata overført til kurven'
    }
  };
  Object.keys(V70_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V70_TRANSLATIONS[lang]);
  });

  // V7.1.3: Smart Add-on zeigt für Blau nur tatsächlich berechtigte Fahrzeuge.
  const V711_TRANSLATIONS = {
    de: {
      'v7.rdw.choice.sub':'Niederländische Fahrzeuge können automatisch über das Kennzeichen geprüft werden. Die manuelle Prüfung bleibt als Rückfallweg verfügbar.',
      'v7.rdw.title':'Automatische RDW-Kennzeichenprüfung',
      'v7.rdw.text':'Kennzeichen eingeben, offizielles Fahrzeug bestätigen und direkt die deutsche Plaketteneignung prüfen.',
      'v7.rdw.b1':'Kein Fahrzeugschein-Upload erforderlich',
      'v7.rdw.b2':'Offizielle Fahrzeugdaten direkt von RDW',
      'v7.rdw.b3':'Elektro und Plug-in-Hybrid werden automatisch erkannt',
      'v7.rdw.noteBeta':'Es werden keine Abfrageergebnisse dauerhaft gespeichert.',
      'v7.rdw.button':'RDW-Fahrzeug prüfen',
      'v711.rdw.loading':'RDW-Daten werden abgerufen …',
      'v711.rdw.errorNetwork':'Die RDW-Abfrage ist momentan nicht erreichbar. Bitte nutzen Sie die manuelle Prüfung.',
      'v711.rdw.errorNotFound':'Zu diesem Kennzeichen wurde kein Fahrzeug gefunden. Bitte prüfen Sie die Eingabe.',
      'v711.rdw.errorIncomplete':'Die RDW-Daten reichen für eine automatische Prüfung nicht aus. Bitte nutzen Sie die manuelle Prüfung.',
      'v711.rdw.foundTitle':'Ist dies Ihr Fahrzeug?',
      'v711.rdw.foundLead':'Die folgenden Angaben wurden aus den offiziellen RDW-Daten übernommen.',
      'v711.rdw.vehicle':'Fahrzeug',
      'v711.rdw.type':'Fahrzeugart',
      'v711.rdw.fuel':'Antrieb',
      'v711.rdw.firstReg':'Erstzulassung',
      'v711.rdw.euro':'Emissionsklasse',
      'v711.rdw.range':'Elektrische Reichweite',
      'v711.rdw.co2':'CO₂-Wert',
      'v711.rdw.blueEligible':'Blaue E-Plakette möglich',
      'v711.rdw.blueNotEligible':'Blaue E-Plakette nicht automatisch möglich',
      'v711.rdw.blueManual':'Blaue E-Plakette muss manuell geprüft werden',
      'v711.rdw.confirm':'Ja, dieses Fahrzeug prüfen',
      'v711.rdw.manual':'Nein, manuell eingeben',
      'v711.order.vehicleLabel':'RDW Fahrzeug',
      'v711.order.resultLabel':'RDW Prüfergebnis',
      'v711.order.greenYes':'Grün möglich',
      'v711.order.greenManual':'Grün manuell prüfen',
      'v711.order.greenNo':'Keine grüne Plakette',
      'v711.order.blueYes':'Blau möglich',
      'v711.order.blueManual':'Blau manuell prüfen',
      'v711.order.blueNo':'Blau nicht möglich'
    },
    en: {
      'v7.rdw.choice.sub':'Dutch vehicles can be checked automatically by license plate. Manual checking remains available as a fallback.',
      'v7.rdw.title':'Automatic RDW license plate check','v7.rdw.text':'Enter the plate, confirm the official vehicle and check German sticker eligibility directly.',
      'v7.rdw.b1':'No registration document upload required','v7.rdw.b2':'Official vehicle data directly from RDW','v7.rdw.b3':'Electric and plug-in hybrid vehicles are detected automatically','v7.rdw.noteBeta':'Lookup results are not stored permanently.','v7.rdw.button':'Check RDW vehicle',
      'v711.rdw.loading':'Retrieving RDW data …','v711.rdw.errorNetwork':'The RDW lookup is currently unavailable. Please use the manual check.','v711.rdw.errorNotFound':'No vehicle was found for this plate. Please check the entry.','v711.rdw.errorIncomplete':'The RDW data are not sufficient for an automatic check. Please use the manual check.','v711.rdw.foundTitle':'Is this your vehicle?','v711.rdw.foundLead':'The following details were taken from the official RDW data.','v711.rdw.vehicle':'Vehicle','v711.rdw.type':'Vehicle type','v711.rdw.fuel':'Drive','v711.rdw.firstReg':'First registration','v711.rdw.euro':'Emission class','v711.rdw.range':'Electric range','v711.rdw.co2':'CO₂ value','v711.rdw.blueEligible':'Blue E-sticker possible','v711.rdw.blueNotEligible':'Blue E-sticker not automatically possible','v711.rdw.blueManual':'Blue E-sticker requires manual verification','v711.rdw.confirm':'Yes, check this vehicle','v711.rdw.manual':'No, enter manually','v711.order.vehicleLabel':'RDW vehicle','v711.order.resultLabel':'RDW check result','v711.order.greenYes':'Green eligible','v711.order.greenManual':'Green: manual check','v711.order.greenNo':'No green sticker','v711.order.blueYes':'Blue eligible','v711.order.blueManual':'Blue: manual check','v711.order.blueNo':'Blue not eligible'
    },
    nl: {
      'v7.rdw.choice.sub':'Nederlandse voertuigen kunnen automatisch via het kenteken worden gecontroleerd. Handmatige controle blijft beschikbaar als terugvaloptie.',
      'v7.rdw.title':'Automatische RDW-kentekencontrole','v7.rdw.text':'Vul het kenteken in, bevestig het officiële voertuig en controleer direct de Duitse milieustickers.','v7.rdw.b1':'Geen upload van het kentekenbewijs nodig','v7.rdw.b2':'Officiële voertuiggegevens rechtstreeks van RDW','v7.rdw.b3':'Elektrisch en plug-in hybride worden automatisch herkend','v7.rdw.noteBeta':'De opgevraagde resultaten worden niet permanent opgeslagen.','v7.rdw.button':'RDW-voertuig controleren',
      'v711.rdw.loading':'RDW-gegevens worden opgehaald …','v711.rdw.errorNetwork':'De RDW-controle is momenteel niet bereikbaar. Gebruik de handmatige controle.','v711.rdw.errorNotFound':'Voor dit kenteken is geen voertuig gevonden. Controleer de invoer.','v711.rdw.errorIncomplete':'De RDW-gegevens zijn niet voldoende voor een automatische controle. Gebruik de handmatige controle.','v711.rdw.foundTitle':'Is dit uw voertuig?','v711.rdw.foundLead':'De volgende gegevens zijn uit de officiële RDW-data overgenomen.','v711.rdw.vehicle':'Voertuig','v711.rdw.type':'Voertuigsoort','v711.rdw.fuel':'Aandrijving','v711.rdw.firstReg':'Eerste toelating','v711.rdw.euro':'Emissieklasse','v711.rdw.range':'Elektrische actieradius','v711.rdw.co2':'CO₂-waarde','v711.rdw.blueEligible':'Blauwe E-sticker mogelijk','v711.rdw.blueNotEligible':'Blauwe E-sticker niet automatisch mogelijk','v711.rdw.blueManual':'Blauwe E-sticker moet handmatig worden gecontroleerd','v711.rdw.confirm':'Ja, dit voertuig controleren','v711.rdw.manual':'Nee, handmatig invoeren','v711.order.vehicleLabel':'RDW voertuig','v711.order.resultLabel':'RDW controleresultaat','v711.order.greenYes':'Groen mogelijk','v711.order.greenManual':'Groen handmatig controleren','v711.order.greenNo':'Geen groene sticker','v711.order.blueYes':'Blauw mogelijk','v711.order.blueManual':'Blauw handmatig controleren','v711.order.blueNo':'Blauw niet mogelijk'
    },
    fr: {
      'v7.rdw.choice.sub':'Les véhicules néerlandais peuvent être vérifiés automatiquement par immatriculation. La saisie manuelle reste disponible.','v7.rdw.title':'Vérification automatique RDW','v7.rdw.text':'Saisissez l’immatriculation, confirmez le véhicule officiel et vérifiez les vignettes allemandes.','v7.rdw.b1':'Aucun document à téléverser','v7.rdw.b2':'Données officielles directement de RDW','v7.rdw.b3':'Électrique et hybride rechargeable détectés automatiquement','v7.rdw.noteBeta':'Les résultats ne sont pas conservés durablement.','v7.rdw.button':'Vérifier le véhicule RDW','v711.rdw.loading':'Récupération des données RDW …','v711.rdw.errorNetwork':'RDW est momentanément indisponible. Utilisez la saisie manuelle.','v711.rdw.errorNotFound':'Aucun véhicule trouvé pour cette immatriculation.','v711.rdw.errorIncomplete':'Les données RDW ne suffisent pas. Utilisez la saisie manuelle.','v711.rdw.foundTitle':'Est-ce votre véhicule ?','v711.rdw.foundLead':'Données issues des informations officielles RDW.','v711.rdw.vehicle':'Véhicule','v711.rdw.type':'Type de véhicule','v711.rdw.fuel':'Motorisation','v711.rdw.firstReg':'Première immatriculation','v711.rdw.euro':'Classe d’émission','v711.rdw.range':'Autonomie électrique','v711.rdw.co2':'Valeur CO₂','v711.rdw.blueEligible':'Vignette E bleue possible','v711.rdw.blueNotEligible':'Vignette E bleue non disponible automatiquement','v711.rdw.blueManual':'Vignette E bleue à vérifier manuellement','v711.rdw.confirm':'Oui, vérifier ce véhicule','v711.rdw.manual':'Non, saisir manuellement','v711.order.vehicleLabel':'Véhicule RDW','v711.order.resultLabel':'Résultat RDW','v711.order.greenYes':'Verte possible','v711.order.greenManual':'Verte à vérifier','v711.order.greenNo':'Pas de vignette verte','v711.order.blueYes':'Bleue possible','v711.order.blueManual':'Bleue à vérifier','v711.order.blueNo':'Bleue non possible'
    },
    it: {
      'v7.rdw.choice.sub':'I veicoli olandesi possono essere controllati automaticamente tramite targa. Resta disponibile il controllo manuale.','v7.rdw.title':'Controllo automatico RDW','v7.rdw.text':'Inserire la targa, confermare il veicolo ufficiale e verificare i bollini tedeschi.','v7.rdw.b1':'Nessun documento da caricare','v7.rdw.b2':'Dati ufficiali direttamente da RDW','v7.rdw.b3':'Elettrico e plug-in hybrid riconosciuti automaticamente','v7.rdw.noteBeta':'I risultati non vengono memorizzati in modo permanente.','v7.rdw.button':'Controlla veicolo RDW','v711.rdw.loading':'Recupero dati RDW …','v711.rdw.errorNetwork':'RDW non è al momento raggiungibile. Usare il controllo manuale.','v711.rdw.errorNotFound':'Nessun veicolo trovato per questa targa.','v711.rdw.errorIncomplete':'I dati RDW non sono sufficienti. Usare il controllo manuale.','v711.rdw.foundTitle':'È questo il veicolo?','v711.rdw.foundLead':'Dati ricavati dalle informazioni ufficiali RDW.','v711.rdw.vehicle':'Veicolo','v711.rdw.type':'Tipo di veicolo','v711.rdw.fuel':'Alimentazione','v711.rdw.firstReg':'Prima immatricolazione','v711.rdw.euro':'Classe emissioni','v711.rdw.range':'Autonomia elettrica','v711.rdw.co2':'Valore CO₂','v711.rdw.blueEligible':'Bollino E blu possibile','v711.rdw.blueNotEligible':'Bollino E blu non disponibile automaticamente','v711.rdw.blueManual':'Bollino E blu da verificare manualmente','v711.rdw.confirm':'Sì, controlla questo veicolo','v711.rdw.manual':'No, inserisci manualmente','v711.order.vehicleLabel':'Veicolo RDW','v711.order.resultLabel':'Esito RDW','v711.order.greenYes':'Verde possibile','v711.order.greenManual':'Verde da verificare','v711.order.greenNo':'Nessun bollino verde','v711.order.blueYes':'Blu possibile','v711.order.blueManual':'Blu da verificare','v711.order.blueNo':'Blu non possibile'
    },
    pl: {
      'v7.rdw.choice.sub':'Pojazdy holenderskie można automatycznie sprawdzić po numerze rejestracyjnym. Kontrola ręczna pozostaje dostępna.','v7.rdw.title':'Automatyczna kontrola RDW','v7.rdw.text':'Wpisz numer, potwierdź oficjalne dane pojazdu i sprawdź niemieckie plakietki.','v7.rdw.b1':'Bez przesyłania dowodu rejestracyjnego','v7.rdw.b2':'Oficjalne dane bezpośrednio z RDW','v7.rdw.b3':'Pojazdy elektryczne i plug-in rozpoznawane automatycznie','v7.rdw.noteBeta':'Wyniki zapytania nie są trwale zapisywane.','v7.rdw.button':'Sprawdź pojazd RDW','v711.rdw.loading':'Pobieranie danych RDW …','v711.rdw.errorNetwork':'RDW jest chwilowo niedostępne. Użyj kontroli ręcznej.','v711.rdw.errorNotFound':'Nie znaleziono pojazdu dla tego numeru.','v711.rdw.errorIncomplete':'Dane RDW są niewystarczające. Użyj kontroli ręcznej.','v711.rdw.foundTitle':'Czy to Twój pojazd?','v711.rdw.foundLead':'Dane pochodzą z oficjalnych danych RDW.','v711.rdw.vehicle':'Pojazd','v711.rdw.type':'Rodzaj pojazdu','v711.rdw.fuel':'Napęd','v711.rdw.firstReg':'Pierwsza rejestracja','v711.rdw.euro':'Klasa emisji','v711.rdw.range':'Zasięg elektryczny','v711.rdw.co2':'Wartość CO₂','v711.rdw.blueEligible':'Niebieska plakietka E możliwa','v711.rdw.blueNotEligible':'Niebieska plakietka E nie jest automatycznie możliwa','v711.rdw.blueManual':'Niebieska plakietka E wymaga ręcznej kontroli','v711.rdw.confirm':'Tak, sprawdź ten pojazd','v711.rdw.manual':'Nie, wpisz ręcznie','v711.order.vehicleLabel':'Pojazd RDW','v711.order.resultLabel':'Wynik RDW','v711.order.greenYes':'Zielona możliwa','v711.order.greenManual':'Zielona: kontrola ręczna','v711.order.greenNo':'Brak zielonej plakietki','v711.order.blueYes':'Niebieska możliwa','v711.order.blueManual':'Niebieska: kontrola ręczna','v711.order.blueNo':'Niebieska niemożliwa'
    },
    cs: {
      'v7.rdw.choice.sub':'Nizozemská vozidla lze automaticky zkontrolovat podle registrační značky. Ruční kontrola zůstává dostupná.','v7.rdw.title':'Automatická kontrola RDW','v7.rdw.text':'Zadejte značku, potvrďte oficiální vozidlo a ověřte německé plakety.','v7.rdw.b1':'Bez nahrávání technického průkazu','v7.rdw.b2':'Oficiální údaje přímo z RDW','v7.rdw.b3':'Elektromobily a plug-in hybridy rozpoznány automaticky','v7.rdw.noteBeta':'Výsledky dotazu se trvale neukládají.','v7.rdw.button':'Zkontrolovat vozidlo RDW','v711.rdw.loading':'Načítají se údaje RDW …','v711.rdw.errorNetwork':'RDW je dočasně nedostupné. Použijte ruční kontrolu.','v711.rdw.errorNotFound':'Pro tuto značku nebylo nalezeno vozidlo.','v711.rdw.errorIncomplete':'Údaje RDW nestačí. Použijte ruční kontrolu.','v711.rdw.foundTitle':'Je toto vaše vozidlo?','v711.rdw.foundLead':'Údaje byly převzaty z oficiálních dat RDW.','v711.rdw.vehicle':'Vozidlo','v711.rdw.type':'Typ vozidla','v711.rdw.fuel':'Pohon','v711.rdw.firstReg':'První registrace','v711.rdw.euro':'Emisní třída','v711.rdw.range':'Elektrický dojezd','v711.rdw.co2':'Hodnota CO₂','v711.rdw.blueEligible':'Modrá E-plaketa možná','v711.rdw.blueNotEligible':'Modrá E-plaketa není automaticky možná','v711.rdw.blueManual':'Modrou E-plaketu je nutné ručně ověřit','v711.rdw.confirm':'Ano, zkontrolovat vozidlo','v711.rdw.manual':'Ne, zadat ručně','v711.order.vehicleLabel':'Vozidlo RDW','v711.order.resultLabel':'Výsledek RDW','v711.order.greenYes':'Zelená možná','v711.order.greenManual':'Zelená: ruční kontrola','v711.order.greenNo':'Bez zelené plakety','v711.order.blueYes':'Modrá možná','v711.order.blueManual':'Modrá: ruční kontrola','v711.order.blueNo':'Modrá není možná'
    },
    da: {
      'v7.rdw.choice.sub':'Nederlandske køretøjer kan kontrolleres automatisk via nummerpladen. Manuel kontrol er fortsat tilgængelig.','v7.rdw.title':'Automatisk RDW-kontrol','v7.rdw.text':'Indtast nummerpladen, bekræft køretøjet og kontrollér de tyske mærkater.','v7.rdw.b1':'Ingen registreringsattest skal uploades','v7.rdw.b2':'Officielle data direkte fra RDW','v7.rdw.b3':'El- og plug-in-hybrid registreres automatisk','v7.rdw.noteBeta':'Resultaterne gemmes ikke permanent.','v7.rdw.button':'Kontrollér RDW-køretøj','v711.rdw.loading':'Henter RDW-data …','v711.rdw.errorNetwork':'RDW er midlertidigt utilgængelig. Brug manuel kontrol.','v711.rdw.errorNotFound':'Der blev ikke fundet et køretøj til nummerpladen.','v711.rdw.errorIncomplete':'RDW-data er ikke tilstrækkelige. Brug manuel kontrol.','v711.rdw.foundTitle':'Er dette dit køretøj?','v711.rdw.foundLead':'Oplysningerne er hentet fra officielle RDW-data.','v711.rdw.vehicle':'Køretøj','v711.rdw.type':'Køretøjstype','v711.rdw.fuel':'Drivmiddel','v711.rdw.firstReg':'Første registrering','v711.rdw.euro':'Emissionsklasse','v711.rdw.range':'Elektrisk rækkevidde','v711.rdw.co2':'CO₂-værdi','v711.rdw.blueEligible':'Blåt E-mærkat muligt','v711.rdw.blueNotEligible':'Blåt E-mærkat er ikke automatisk muligt','v711.rdw.blueManual':'Blåt E-mærkat skal kontrolleres manuelt','v711.rdw.confirm':'Ja, kontrollér køretøjet','v711.rdw.manual':'Nej, indtast manuelt','v711.order.vehicleLabel':'RDW-køretøj','v711.order.resultLabel':'RDW-resultat','v711.order.greenYes':'Grønt muligt','v711.order.greenManual':'Grønt: manuel kontrol','v711.order.greenNo':'Intet grønt mærkat','v711.order.blueYes':'Blåt muligt','v711.order.blueManual':'Blåt: manuel kontrol','v711.order.blueNo':'Blåt ikke muligt'
    }
  };
  Object.keys(V711_TRANSLATIONS).forEach(lang => {
    T[lang] = T[lang] || {};
    Object.assign(T[lang], V711_TRANSLATIONS[lang]);
  });

  const tr = key => (T[locale] && T[locale][key]) || T.en[key] || T.de[key] || key;

  root.querySelectorAll('[data-i18n]').forEach(el => { el.textContent = tr(el.dataset.i18n); });
  root.querySelectorAll('[data-i18n-html]').forEach(el => { el.innerHTML = tr(el.dataset.i18nHtml); });



  const countries = ['DE','CH','NL','BE','FR','IT','PL','CZ','DK','AT','LU','GB','OTHER'].map(c => [c, ({DE:'🇩🇪',CH:'🇨🇭',NL:'🇳🇱',BE:'🇧🇪',FR:'🇫🇷',IT:'🇮🇹',PL:'🇵🇱',CZ:'🇨🇿',DK:'🇩🇰',AT:'🇦🇹',LU:'🇱🇺',GB:'🇬🇧',OTHER:'🌍'})[c], tr('country.'+c)]);
  const vehicles = [['car','🚗',tr('vehicle.car')],['camper','🚐',tr('vehicle.camper')],['van','🚚',tr('vehicle.van')],['truck','🚛',tr('vehicle.truck')],['bus','🚌',tr('vehicle.bus')],['motorcycle','🏍',tr('vehicle.motorcycle')],['oldtimer','🏛',tr('vehicle.oldtimer')]];
  const fuels = [['petrol','⛽',tr('fuel.petrol')],['diesel','🛢️',tr('fuel.diesel')],['electric','⚡',tr('fuel.electric')],['phev','🔌',tr('fuel.phev')],['hybrid','♻️',tr('fuel.hybrid')],['gas','🔥',tr('fuel.gas')],['hydrogen','💧',tr('fuel.hydrogen')],['unknown','❔',tr('fuel.unknown')]];
  const euroClasses = [['e6',tr('euro.e6')],['e5',tr('euro.e5')],['e4',tr('euro.e4')],['e3',tr('euro.e3')],['e2',tr('euro.e2')],['e1',tr('euro.e1')],['unknown',tr('euro.unknown')]];
  const pmLevels = [['unknown',tr('pm.unknown')],['none',tr('pm.none')],['pm01','PM 01'],['pm0','PM 0'],['pm1','PM 1'],['pm2','PM 2'],['pm3','PM 3'],['pm4','PM 4'],['pm5','PM 5']];

  // Exakte label_on_cart-Bezeichnungen aus den acht Shopsprachen.
  const PLATE_FIELD_LABELS = {
    de: 'Amtliches Kennzeichen',
    cs: 'Číslo licence',
    da: 'Licens nummer',
    en: 'License plate number',
    fr: 'Numéro de licence',
    it: 'Targa ufficiale',
    nl: 'Kenteken',
    pl: 'Numer licencji'
  };

  const state = { mode: null, step: 0, country: null, vehicle: null, fuel: null, emission: '', euro: null, firstReg: '', pm: null, baseResult: null, manualReason: '', plate: '', vehicleId: '', uploadProperties: {}, uploadSkipped: false, vehicleEntryMethod: '', lastVehicleResult: '', rdwData: null, rdwConfirmed: false, destinationQuery: '', zoneMatches: [], zoneMode: null, routeStart: '', routeDestination: '', routeData: null, routeZones: [], routeZoneCheck: null, destinationMapZones: [], destinationMapCenter: null, destinationMapDirect: false };

  const NEARBY_ZONE_HINTS = [
    // V6.1.1: Zielort-Assistent bleibt bewusst auf Deutschland fokussiert.
    // Auslandsziele werden nur als Fallback behandelt und später im echten Routenplaner verarbeitet.
    { terms:['nürnberg','nuernberg','nuremberg','fürth','fuerth','erlangen','bamberg','franken','franconia'], zones:['München','Augsburg','Regensburg'] },
    { terms:['bayern','bavaria','baviere','bavière','baviera','bawaria','bavorsko','allgäu','allgaeu','oberbayern','niederbayern'], zones:['München','Augsburg','Regensburg'] },
    { terms:['schwarzwald','black forest','foret noire','forêt noire','selva negra','freiburg','baden baden','offenburg','tübingen','tuebingen'], zones:['Stuttgart','Pforzheim','Ludwigsburg und Umgebung'] },
    { terms:['bodensee','lake constance','konstanz','constance','lindau','friedrichshafen'], zones:['Stuttgart','Pforzheim','Augsburg'] },
    { terms:['hessen','hesse','taunus','rhein main','rhein-main','mainz umgebung'], zones:['Frankfurt a.M.','Wiesbaden','Darmstadt'] },
    { terms:['nordrhein westfalen','nordrhein-westfalen','nrw','rheinland','ruhr area','ruhrgebiet','sauerland','köln umgebung','koeln umgebung'], zones:['Köln','Düsseldorf','Ruhrgebiet','Aachen'] },
    { terms:['niedersachsen','lower saxony','hannover','hanover','ostfriesland','emsland'], zones:['Osnabrück','Bremen'] },
    { terms:['sachsen','saxony','dresden','erzgebirge'], zones:['Leipzig'] },
    { terms:['sachsen anhalt','sachsen-anhalt','saxony anhalt','harz'], zones:['Halle','Magdeburg'] },
    { terms:['hamburg','kiel','lübeck','lubeck','schleswig holstein','schleswig-holstein','nordsee','ostsee'], zones:['Bremen','Berlin','Magdeburg'] },
    { terms:['deutschland','germany','durchreise','transit','road trip','roadtrip','route','rundreise','urlaub','holiday','vacation','städtereise','staedtereise'], zones:['München','Stuttgart','Köln','Berlin','Ruhrgebiet'] }
  ];

  const FOREIGN_DESTINATION_TERMS = [
    'niederlande','netherlands','holland','nederland','amsterdam','rotterdam','utrecht','eindhoven',
    'belgien','belgium','belgie','belgique','brüssel','bruessel','brussels','antwerpen','antwerp','liege','liège',
    'frankreich','france','elsass','alsace','strasbourg','straßburg','paris','colmar',
    'schweiz','switzerland','suisse','svizzera','zurich','zürich','basel','bern','luzern',
    'österreich','oesterreich','austria','bregenz','tirol','salzburg','wien','vienna','innsbruck',
    'italien','italy','italia','gardasee','lake garda','garda','verona','bozen','bolzano','südtirol','suedtirol',
    'polen','poland','polska','warsaw','warschau','poznan','posen','wroclaw','breslau',
    'tschechien','czech','czechia','prag','prague','praha','pilsen','plzen',
    'dänemark','daenemark','denmark','danmark','kopenhagen','copenhagen',
    'luxemburg','luxembourg','london','england','uk','united kingdom','großbritannien','grossbritannien'
  ];

  function hasCoordinates(entry) {
    return entry && Number.isFinite(Number(entry.lat)) && Number.isFinite(Number(entry.lng));
  }

  function toRadians(value) {
    return Number(value) * Math.PI / 180;
  }

  function distanceKm(a, b) {
    if (!hasCoordinates(a) || !hasCoordinates(b)) return null;
    const earthRadiusKm = 6371;
    const dLat = toRadians(Number(b.lat) - Number(a.lat));
    const dLng = toRadians(Number(b.lng) - Number(a.lng));
    const lat1 = toRadians(Number(a.lat));
    const lat2 = toRadians(Number(b.lat));
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
    return Math.round(earthRadiusKm * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h)));
  }

  function findZoneByName(name) {
    const wanted = normalizeZone(name);
    return (ZONES.zones || []).find(zone => normalizeZone(zone.name) === wanted);
  }

  function activeZonesWithCoordinates() {
    const seen = new Set();
    return (ZONES.zones || [])
      .filter(zone => zone && zone.status === 'active' && zone.hasZone !== false && zone.badgeRequired !== false && hasCoordinates(zone))
      .filter(zone => {
        const key = zone.nearbyKey || normalizeZone(zone.name);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  }

  function zoneNamesToExisting(names) {
    const seen = new Set();
    return names
      .map(name => findZoneByName(name))
      .filter(Boolean)
      .filter(zone => {
        const key = zone.nearbyKey || zone.name + '|' + zone.state;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .slice(0, 4);
  }

  function isForeignDestinationQuery(query) {
    const q = normalizeZone(query);
    if (!q) return false;
    return FOREIGN_DESTINATION_TERMS.map(normalizeZone).some(term => {
      if (!term) return false;
      // Kurze Kürzel wie „UK“ nur exakt abgleichen, damit deutsche Ortsnamen
      // nicht versehentlich als Auslandsziel eingestuft werden.
      if (term.length <= 3 || q.length <= 3) return q === term;
      return q === term || q.includes(term) || term.includes(q);
    });
  }

  function placeSearchTerms(place) {
    return [place.name].concat(place.aliases || []).map(normalizeZone).filter(Boolean);
  }

  function findPlaceMatch(query) {
    const q = normalizeZone(query);
    if (!q || isForeignDestinationQuery(query)) return null;
    const places = PLACES.places || [];
    const exact = places.find(place => placeSearchTerms(place).some(term => term === q));
    if (exact) return exact;
    if (q.length < 4) return null;
    return places.find(place => placeSearchTerms(place).some(term => term.includes(q) || q.includes(term))) || null;
  }

  function findNearbyZonesByDistance(query) {
    const place = findPlaceMatch(query);
    if (!place || !hasCoordinates(place)) return [];
    return activeZonesWithCoordinates()
      .map(zone => Object.assign({}, zone, { distanceKm: distanceKm(place, zone) }))
      .filter(zone => Number.isFinite(zone.distanceKm))
      .sort((a, b) => a.distanceKm - b.distanceKm)
      .slice(0, 4);
  }

  function findNearbyZones(query) {
    const q = normalizeZone(query);
    if (!q || isForeignDestinationQuery(query)) return [];

    const distanceSorted = findNearbyZonesByDistance(query);
    if (distanceSorted.length) return distanceSorted;

    for (const hint of NEARBY_ZONE_HINTS) {
      if ((hint.terms || []).map(normalizeZone).some(term => term && (q === term || q.includes(term) || term.includes(q)))) {
        const zones = zoneNamesToExisting(hint.zones || []);
        if (zones.length) return zones;
      }
    }
    return zoneNamesToExisting(['München','Stuttgart','Köln','Berlin','Ruhrgebiet']);
  }

  function renderNearbyZones(query) {
    const nearby = findNearbyZones(query);
    if (!nearby.length) return '';
    const genericQuery = ['deutschland','germany','durchreise','transit','road trip','route','urlaub','holiday','vacation'].some(term => normalizeZone(query).includes(normalizeZone(term)));
    const lead = genericQuery ? tr('zone.nearby.generic') : tr('zone.nearby.lead');
    const items = nearby.map(zone => {
      const distance = Number.isFinite(zone.distanceKm) ? tr('zone.nearby.distance').replace('{km}', String(zone.distanceKm)) : '';
      const meta = [zone.state || '', distance].filter(Boolean).join(' · ');
      return `<li><strong>${escapeHtml(zone.name)}</strong><span>${escapeHtml(meta)}</span></li>`;
    }).join('');
    return `<div class="gba__zone-nearby"><h4>${tr('zone.nearby.title')}</h4><p>${lead}</p><ul>${items}</ul></div>`;
  }

  function cartUpdateUrl() {
    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return rootPath.replace(/\/?$/, '/') + 'cart/update.js';
  }

  function persistAssistantAttributes(extra) {
    const attributes = Object.assign({
      'Umweltplaketten-Assistent genutzt': 'Ja',
      'Assistent Sprache': localeRaw || locale || 'de',
      'Assistent letzter Kontakt': new Date().toISOString()
    }, extra || {});

    try {
      window.sessionStorage.setItem('gbAssistantUsed', '1');
      Object.keys(attributes).forEach(key => window.sessionStorage.setItem('gbAttr_' + key, attributes[key]));
    } catch (error) {}

    if (!window.fetch) return Promise.resolve(false);
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes })
    }).then(response => response.ok).catch(() => false);
  }

  function trackAssistantEvent(extra) {
    persistAssistantAttributes(extra);
  }
  const title = root.querySelector('[data-question-title]');
  const sub = root.querySelector('[data-question-subtitle]');
  const content = root.querySelector('[data-question-content]');
  const next = root.querySelector('[data-next]');
  const back = root.querySelector('[data-back]');
  const result = root.querySelector('[data-result]');
  const panel = root.querySelector('[data-panel]');
  const progressSteps = root.querySelector('.gba__steps');
  const uploadStage = root.querySelector('[data-gba-upload-stage]');
  const uploadForm = root.querySelector('#gb-assistant-upload-form');
  const uploadPlateInput = root.querySelector('[data-gba-plate-input]');
  const uploadError = root.querySelector('[data-gba-upload-error]');
  const manualStart = root.querySelector('[data-gba-manual-start]');
  const uploadStart = root.querySelector('[data-gba-upload-start]');
  const manualCard = root.querySelector('[data-gba-manual-card]');
  const uploadCard = root.querySelector('[data-gba-upload-card]');
  const rdwCard = root.querySelector('[data-gba-rdw-card]');
  const rdwPlateInput = root.querySelector('[data-gba-rdw-plate-input]');
  const rdwStart = root.querySelector('[data-gba-rdw-start]');
  const rdwError = root.querySelector('[data-gba-rdw-error]');
  const rdwResultBox = root.querySelector('[data-gba-rdw-result]');
  const rdwResultTitle = root.querySelector('[data-gba-rdw-result-title]');
  const rdwResultLead = root.querySelector('[data-gba-rdw-result-lead]');
  const rdwResultFacts = root.querySelector('[data-gba-rdw-result-facts]');
  const rdwResultBlue = root.querySelector('[data-gba-rdw-blue-status]');
  const rdwConfirm = root.querySelector('[data-gba-rdw-confirm]');
  const rdwManual = root.querySelector('[data-gba-rdw-manual]');
  const blueCard = root.querySelector('[data-blue-card]');
  const greenCard = root.querySelector('[data-green-card]');
  const reason = root.querySelector('[data-result-reason]');
  const heading = root.querySelector('[data-result-heading]');
  const resultFacts = root.querySelector('[data-result-facts]');
  const resultIcon = root.querySelector('[data-result-icon]');
  const resultStatus = root.querySelector('[data-result-status]');
  const resultPermission = root.querySelector('[data-result-permission]');
  const reset = root.querySelector('[data-reset]');
  if (reset) reset.textContent = tr('buttons.restart');

  function updateSteps(n, progressMode) {
    const mode = progressMode || state.mode || 'start';
    const stepKeys = mode === 'vehicle'
      ? ['steps.country','steps.vehicle','steps.fuel','steps.data','steps.result']
      : mode === 'zone'
        ? ['v60.steps.choose', state.zoneMode === 'route' ? 'v62.steps.route' : 'v60.steps.destination','steps.result']
        : ['v60.steps.choose','v60.steps.start'];
    const displayStep = Math.max(1, Math.ceil(Number(n) || 1));
    root.querySelectorAll('[data-step-dot]').forEach((li, index) => {
      const stepNumber = index + 1;
      const label = li.querySelector('small');
      if (index >= stepKeys.length) {
        li.hidden = true;
        li.classList.remove('is-active','is-complete','is-done');
        return;
      }
      li.hidden = false;
      if (label) label.textContent = tr(stepKeys[index]);
      const number = li.querySelector('span');
      if (number) number.textContent = String(stepNumber);
      li.classList.toggle('is-active', stepNumber === displayStep);
      li.classList.toggle('is-complete', stepNumber < displayStep);
      li.classList.toggle('is-done', stepNumber < displayStep);
    });
  }
  function setPanelView(view) {
    if (!panel) return;
    panel.classList.remove('gba__panel--start','gba__panel--zone','gba__panel--vehicle','gba__panel--vehicle-entry');
    if (view) panel.classList.add('gba__panel--' + view);
  }
  function setResultView(view) {
    if (!result) return;
    result.classList.remove('gba__result--zone-found','gba__result--zone-empty','gba__result--vehicle','gba__result--route-found','gba__result--route-empty');
    if (view) result.classList.add('gba__result--' + view);
  }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]));
  }
  function plateFieldLabel() {
    return PLATE_FIELD_LABELS[locale] || PLATE_FIELD_LABELS.en;
  }
  function sanitizePlateInput(value) {
    return String(value || '').toUpperCase().replace(/[^0-9A-ZÀ-Ž\- ]/g, '').replace(/\s+/g, ' ').slice(0, 24);
  }
  function cleanPlateInput(value) {
    return sanitizePlateInput(value).trim();
  }
  function createVehicleId() {
    try {
      const bytes = new Uint8Array(5);
      window.crypto.getRandomValues(bytes);
      return 'GB-' + Array.from(bytes).map(value => value.toString(16).padStart(2, '0')).join('').toUpperCase();
    } catch (error) {
      return 'GB-' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 6).toUpperCase();
    }
  }
  function isUploadKitUrl(value) {
    return /^https:\/\//i.test(String(value || '')) && /(getuploadkit\.com|shopify\.com-uploadkit\.app)/i.test(String(value || ''));
  }
  function readUploadKitProperties() {
    if (!uploadForm) return {};
    const properties = {};
    const formData = new FormData(uploadForm);
    formData.forEach((value, name) => {
      const match = String(name).match(/^properties\[(.+)\]$/);
      if (!match || typeof value !== 'string' || !value.trim()) return;
      properties[match[1]] = value.trim();
    });
    // Einige App-Versionen erzeugen versteckte Inputs, die FormData erst nach
    // Abschluss des Uploads zuverlässig erfasst. Deshalb zusätzlich direkt lesen.
    uploadForm.querySelectorAll('[name^="properties["]').forEach(input => {
      const match = String(input.name || '').match(/^properties\[(.+)\]$/);
      const value = typeof input.value === 'string' ? input.value.trim() : '';
      if (match && value) properties[match[1]] = value;
    });
    return properties;
  }
  function hasDirectUploadKitLink(properties) {
    return Object.entries(properties || {}).some(([key, value]) => /direct link/i.test(key) && /files\.getuploadkit\.com/i.test(String(value || '')));
  }
  function hasAssistantUpload() {
    return !!state.plate && hasDirectUploadKitLink(state.uploadProperties);
  }
  function hideUploadStage() {
    if (uploadStage) uploadStage.hidden = true;
    if (content) content.hidden = false;
    if (progressSteps) progressSteps.hidden = false;
  }
  function renderVehicleEntryChoice() {
    setPanelView('vehicle');
    panel.classList.add('gba__panel--vehicle-entry');
    result.hidden = true;
    panel.hidden = false;
    if (content) content.hidden = true;
    if (uploadStage) uploadStage.hidden = false;
    if (progressSteps) progressSteps.hidden = true;
    back.hidden = false;
    next.hidden = true;
    const rdwEnabled = window.GreenBadgeAssistantSettings?.rdwEnabled !== false;
    const isNetherlands = state.country === 'NL' && rdwEnabled;
    title.textContent = isNetherlands ? tr('v7.rdw.choice.title') : tr('v7.choice.title');
    sub.textContent = isNetherlands ? tr('v7.rdw.choice.sub') : (window.GreenBadgeAssistantSettings?.assistantUploadEnabled === true ? tr('v7.choice.sub') : tr('v7.choice.manual.text'));
    if (manualCard) manualCard.hidden = false;
    if (uploadCard) uploadCard.hidden = isNetherlands || window.GreenBadgeAssistantSettings?.assistantUploadEnabled !== true;
    if (rdwCard) rdwCard.hidden = !isNetherlands;

    const label = plateFieldLabel();
    const plateLabel = root.querySelector('[data-gba-plate-label]');
    const manualTitle = root.querySelector('[data-gba-manual-title]');
    const manualText = root.querySelector('[data-gba-manual-text]');
    const manualB1 = root.querySelector('[data-gba-manual-b1]');
    const manualB2 = root.querySelector('[data-gba-manual-b2]');
    const manualB3 = root.querySelector('[data-gba-manual-b3]');
    const lead = root.querySelector('[data-gba-upload-lead]');
    const help = root.querySelector('[data-gba-upload-help]');
    const hint = root.querySelector('[data-gba-plate-hint]');
    const note = root.querySelector('[data-gba-upload-note]');

    if (manualTitle) manualTitle.textContent = tr('v7.choice.manual.title');
    if (manualText) manualText.textContent = tr('v7.choice.manual.text');
    if (manualB1) manualB1.textContent = tr('v7.choice.manual.b1');
    if (manualB2) manualB2.textContent = tr('v7.choice.manual.b2');
    if (manualB3) manualB3.textContent = tr('v7.choice.manual.b3');
    if (manualStart) manualStart.textContent = tr('v7.choice.manual.button');
    if (plateLabel) plateLabel.textContent = label;
    if (lead) lead.textContent = tr('v7.choice.upload.title');
    if (help) help.textContent = tr('v7.choice.upload.text');
    if (hint) hint.textContent = tr('v7.upload.plateHint');
    if (note) note.textContent = tr('v7.upload.note');
    if (uploadStart) uploadStart.textContent = tr('v7.choice.upload.button');
    const rdwTitle = root.querySelector('[data-gba-rdw-title]');
    const rdwText = root.querySelector('[data-gba-rdw-text]');
    const rdwB1 = root.querySelector('[data-gba-rdw-b1]');
    const rdwB2 = root.querySelector('[data-gba-rdw-b2]');
    const rdwB3 = root.querySelector('[data-gba-rdw-b3]');
    const rdwPlateLabel = root.querySelector('[data-gba-rdw-plate-label]');
    const rdwHint = root.querySelector('[data-gba-rdw-hint]');
    const rdwNote = root.querySelector('[data-gba-rdw-note]');
    if (rdwTitle) rdwTitle.textContent = tr('v7.rdw.title');
    if (rdwText) rdwText.textContent = tr('v7.rdw.text');
    if (rdwB1) rdwB1.textContent = tr('v7.rdw.b1');
    if (rdwB2) rdwB2.textContent = tr('v7.rdw.b2');
    if (rdwB3) rdwB3.textContent = tr('v7.rdw.b3');
    if (rdwPlateLabel) rdwPlateLabel.textContent = tr('v7.rdw.plateLabel');
    if (rdwHint) rdwHint.textContent = tr('v7.rdw.plateHint');
    if (rdwNote) rdwNote.textContent = tr('v7.rdw.noteBeta');
    if (rdwStart) rdwStart.textContent = tr('v7.rdw.button');
    if (rdwResultTitle) rdwResultTitle.textContent = tr('v711.rdw.foundTitle');
    if (rdwResultLead) rdwResultLead.textContent = tr('v711.rdw.foundLead');
    if (rdwConfirm) rdwConfirm.textContent = tr('v711.rdw.confirm');
    if (rdwManual) rdwManual.textContent = tr('v711.rdw.manual');
    if (rdwPlateInput) {
      rdwPlateInput.value = state.plate || rdwPlateInput.value || '';
      if (rdwPlateInput.dataset.gbaBound !== '1') {
        rdwPlateInput.dataset.gbaBound = '1';
        rdwPlateInput.addEventListener('input', event => {
          const sanitized = sanitizePlateInput(event.target.value);
          event.target.value = sanitized;
          state.plate = sanitized;
          state.rdwData = null;
          state.rdwConfirmed = false;
          state.vehicleId = '';
          if (rdwResultBox) rdwResultBox.hidden = true;
          if (rdwError) rdwError.hidden = true;
        });
      }
    }
    if (rdwError) rdwError.hidden = true;
    if (rdwResultBox && !state.rdwData) rdwResultBox.hidden = true;

    if (uploadPlateInput) {
      uploadPlateInput.name = `properties[${label}]`;
      uploadPlateInput.value = state.plate || uploadPlateInput.value || '';
      if (uploadPlateInput.dataset.gbaBound !== '1') {
        uploadPlateInput.dataset.gbaBound = '1';
        uploadPlateInput.addEventListener('input', event => {
          // Während der Eingabe kein trim(): Ein gerade eingegebenes Leerzeichen
          // muss stehen bleiben, damit z. B. „LDK N 401“ möglich ist.
          const sanitized = sanitizePlateInput(event.target.value);
          event.target.value = sanitized;
          state.plate = sanitized;
          if (uploadError) uploadError.hidden = true;
        });
      }
    }
    if (uploadError) uploadError.hidden = true;
  }
  function captureUploadStage() {
    const plate = cleanPlateInput(uploadPlateInput ? uploadPlateInput.value : state.plate);
    if (!plate) {
      if (uploadError) { uploadError.textContent = tr('v7.upload.errorPlate'); uploadError.hidden = false; }
      if (uploadPlateInput) uploadPlateInput.focus();
      return false;
    }
    const properties = readUploadKitProperties();
    if (!hasDirectUploadKitLink(properties)) {
      if (uploadError) { uploadError.textContent = tr('v7.upload.errorFile'); uploadError.hidden = false; }
      return false;
    }
    const label = plateFieldLabel();
    properties[label] = plate;
    state.plate = plate;
    state.uploadProperties = properties;
    state.uploadSkipped = false;
    state.vehicleId = state.vehicleId || createVehicleId();
    trackAssistantEvent({
      'Assistent Dokument': 'UploadKit im Assistenten abgeschlossen',
      'Assistent Kennzeichen erfasst': 'Ja',
      'Assistent Fahrzeugreferenz': state.vehicleId
    });
    return true;
  }

  function resetVehicleState() {
    Object.assign(state, { country: null, vehicle: null, fuel: null, emission: '', euro: null, firstReg: '', pm: null, baseResult: null, manualReason: '', plate: '', vehicleId: '', uploadProperties: {}, uploadSkipped: false, vehicleEntryMethod: '', lastVehicleResult: '', rdwData: null, rdwConfirmed: false });
  }
  function resetToStart() {
    Object.assign(state, { mode: null, step: 0, destinationQuery: '', zoneMatches: [], zoneMode: null, routeStart: '', routeDestination: '', routeData: null, routeZones: [], routeZoneCheck: null, destinationMapZones: [], destinationMapCenter: null, destinationMapDirect: false });
    resetVehicleState();
  }
  function beginVehicleCheck() {
    resetVehicleState();
    state.mode = 'vehicle';
    trackAssistantEvent({ 'Assistent Modus': 'Fahrzeugprüfung', 'Assistent Ergebnis': 'gestartet' });
    state.step = 1;
    render();
  }
  function beginZoneCheck() {
    resetVehicleState();
    state.mode = 'zone';
    state.zoneMode = null;
    state.routeData = null;
    state.routeZones = [];
    trackAssistantEvent({ 'Assistent Modus': 'Reiseprüfung', 'Assistent Ergebnis': 'gestartet' });
    state.step = 'zoneChoice';
    render();
  }
  function cardGrid(items, field){ return `<div class="gba__grid">${items.map(([value,icon,label])=>{ const displayLabel = label || icon || value; const displayIcon = label ? icon : ''; return `<button type="button" class="gba__choice" data-pick="${field}" data-value="${value}"><span>${displayIcon||''}</span><strong>${displayLabel}</strong></button>`; }).join('')}</div>`; }
  function selectHtml(items, field){ return `<select class="gba__select" data-select="${field}">${items.map(([value,label])=>`<option value="${value}" ${state[field]===value?'selected':''}>${label}</option>`).join('')}</select>`; }
  function renderStartChoice() {
    setPanelView('start');
    result.hidden = true;
    panel.hidden = false;
    updateSteps(1, 'start');
    back.hidden = true;
    next.hidden = true;
    updateProductButtonModes();
    title.textContent = tr('v60.start.title');
    sub.textContent = tr('v60.start.sub');
    content.innerHTML = `
      <div class="gba__start-choices">
        <button type="button" class="gba__start-card gba__start-card--primary" data-start-mode="vehicle">
          <span class="gba__start-icon" aria-hidden="true">
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 40l4-11c1.2-3.4 2.8-5 6.7-5h6.6c3.9 0 5.5 1.6 6.7 5l4 11" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14 39.5c0-2.5 2-4.5 4.5-4.5h27c2.5 0 4.5 2 4.5 4.5V45c0 1.7-1.3 3-3 3H17c-1.7 0-3-1.3-3-3v-5.5z" stroke="currentColor" stroke-width="3.2" stroke-linejoin="round"/>
              <circle cx="21" cy="41.5" r="1.8" fill="currentColor"/>
              <circle cx="43" cy="41.5" r="1.8" fill="currentColor"/>
              <path d="M20 48v4M44 48v4" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/>
              <path d="M46 18c-5 0-8.5 3.2-8.5 7.5 0 5.4 5.3 8.7 8.5 13.5 3.2-4.8 8.5-8.1 8.5-13.5 0-4.3-3.5-7.5-8.5-7.5z" fill="currentColor" opacity=".14"/>
              <path d="M46 18c-5 0-8.5 3.2-8.5 7.5 0 5.4 5.3 8.7 8.5 13.5 3.2-4.8 8.5-8.1 8.5-13.5 0-4.3-3.5-7.5-8.5-7.5z" stroke="currentColor" stroke-width="2.8" stroke-linejoin="round"/>
              <path d="M42.5 25.5c2.3 2 3.8 4.5 4 8.2 2-3.7 4.9-6.3 8.5-8.2-3.7-.2-6.1-1.5-8.2-4.1-.5 1.7-1.5 2.9-4.3 4.1z" fill="currentColor"/>
            </svg>
          </span>
          <span class="gba__start-copy"><strong>${tr('v60.start.vehicle.title')}</strong><small>${tr('v60.start.vehicle.text')}</small></span>
          <span class="gba__start-list"><span><i class="gba__start-check" aria-hidden="true">✓</i>${tr('v60.start.vehicle.b1')}</span><span><i class="gba__start-check" aria-hidden="true">✓</i>${tr('v60.start.vehicle.b2')}</span><span><i class="gba__start-check" aria-hidden="true">✓</i>${tr('v60.start.vehicle.b3')}</span></span>
          <span class="gba__start-button">${tr('v60.start.vehicle.button')}</span>
        </button>
        <button type="button" class="gba__start-card" data-start-mode="zone">
          <span class="gba__start-icon" aria-hidden="true">
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M32 50c7.5-10 12-15.8 12-22 0-6.6-5.4-12-12-12s-12 5.4-12 12c0 6.2 4.5 12 12 22z" stroke="currentColor" stroke-width="3.2" stroke-linejoin="round"/>
              <circle cx="32" cy="28" r="4.8" fill="#f15a24" stroke="currentColor" stroke-width="2.2"/>
              <path d="M18 50h14" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/>
              <path d="M37 50h8c4 0 6.3-2.4 6.3-5.4 0-2.6-1.7-4.8-4.3-5.3" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-dasharray="3 5"/>
            </svg>
          </span>
          <span class="gba__start-copy"><strong>${tr('v60.start.destination.title')}</strong><small>${tr('v60.start.destination.text')}</small></span>
          <span class="gba__start-list"><span><i class="gba__start-check" aria-hidden="true">✓</i>${tr('v60.start.destination.b1')}</span><span><i class="gba__start-check" aria-hidden="true">✓</i>${tr('v60.start.destination.b2')}</span><span><i class="gba__start-check" aria-hidden="true">✓</i>${tr('v60.start.destination.b3')}</span></span>
          <span class="gba__start-button gba__start-button--outline">${tr('v60.start.destination.button')}</span>
        </button>
      </div>
      <p class="gba__start-note"><span class="gba__start-note-icon" aria-hidden="true">i</span><span>${tr('v60.start.note')}</span></p>`;
    content.querySelectorAll('[data-start-mode]').forEach(btn => {
      btn.addEventListener('click', () => btn.dataset.startMode === 'vehicle' ? beginVehicleCheck() : beginZoneCheck());
    });
  }
  function renderZoneChoice() {
    setPanelView('zone');
    result.hidden = true;
    panel.hidden = false;
    updateSteps(1, 'zone');
    back.hidden = false;
    next.hidden = true;
    title.textContent = tr('v62.choice.title');
    sub.textContent = tr('v62.choice.sub');
    content.innerHTML = `
      <div class="gba__route-choice-grid">
        <button type="button" class="gba__route-choice" data-zone-choice="destination">
          <span class="gba__route-choice-icon" aria-hidden="true">⌖</span>
          <span class="gba__route-choice-copy"><strong>${tr('v62.choice.local.title')}</strong><small>${tr('v62.choice.local.text')}</small></span>
          <span class="gba__route-choice-list gba__route-choice-list--local">
            <span><i aria-hidden="true">✓</i>${tr('v62.choice.local.b1')}</span>
            <span><i aria-hidden="true">✓</i>${tr('v62.choice.local.b2')}</span>
            <span><i aria-hidden="true">✓</i>${tr('v62.choice.local.b3')}</span>
          </span>
          <span class="gba__start-button gba__start-button--outline">${tr('v62.choice.local.button')}</span>
        </button>
        <button type="button" class="gba__route-choice gba__route-choice--primary" data-zone-choice="route">
          <span class="gba__route-choice-icon" aria-hidden="true">↝</span>
          <span class="gba__route-choice-copy"><strong>${tr('v62.choice.route.title')}</strong><small>${tr('v62.choice.route.text')}</small></span>
          <span class="gba__route-choice-list gba__route-choice-list--route">
            <span><i aria-hidden="true">✓</i>${tr('v62.choice.route.b1')}</span>
            <span><i aria-hidden="true">✓</i>${tr('v62.choice.route.b2')}</span>
            <span><i aria-hidden="true">✓</i>${tr('v62.choice.route.b3')}</span>
          </span>
          <span class="gba__start-button">${tr('v62.choice.route.button')}</span>
        </button>
      </div>`;
    content.querySelectorAll('[data-zone-choice]').forEach(button => {
      button.addEventListener('click', () => {
        state.zoneMode = button.dataset.zoneChoice;
        state.step = state.zoneMode === 'route' ? 'routeInput' : 'zoneInput';
        trackAssistantEvent({
          'Assistent Modus': state.zoneMode === 'route' ? 'Routenprüfung' : 'Reisezielprüfung',
          'Assistent Ergebnis': 'gestartet'
        });
        render();
      });
    });
  }

  function routeApiSettings() {
    const settings = window.GreenBadgeAssistantSettings || {};
    return {
      endpoint: String(settings.routeApiUrl || '').trim(),
      embedKey: String(settings.mapsEmbedApiKey || '').trim(),
      jsApiKey: String(settings.mapsJavascriptApiKey || '').trim(),
      zoneGeometryUrl: String(settings.zoneGeometryApiUrl || '').trim(),
      pwaEnabled: settings.pwaEnabled !== false,
      pwaManifestUrl: String(settings.pwaManifestUrl || '').trim(),
      pwaIconUrl: String(settings.pwaIconUrl || '').trim(),
      enabled: settings.routePlannerEnabled !== false
    };
  }

  function renderRouteInput() {
    setPanelView('zone');
    result.hidden = true;
    panel.hidden = false;
    updateSteps(2, 'zone');
    back.hidden = false;
    next.hidden = true;
    title.textContent = tr('route.title');
    sub.textContent = tr('route.sub');
    content.innerHTML = `
      <div class="gba__route-form">
        <div class="gba__route-fields">
          <label class="gba__route-field" for="gba-route-start"><span>${tr('route.start.label')}</span><input id="gba-route-start" class="gba__input" data-route-start maxlength="180" autocomplete="street-address" value="${escapeHtml(state.routeStart)}" placeholder="${escapeHtml(tr('route.start.placeholder'))}"></label>
          <span class="gba__route-arrow" aria-hidden="true">→</span>
          <label class="gba__route-field" for="gba-route-destination"><span>${tr('route.destination.label')}</span><input id="gba-route-destination" class="gba__input" data-route-destination maxlength="180" autocomplete="street-address" value="${escapeHtml(state.routeDestination)}" placeholder="${escapeHtml(tr('route.destination.placeholder'))}"></label>
        </div>
        <p class="gba__hint">${tr('route.hint')}</p>
        <div class="gba__route-privacy"><span aria-hidden="true">ⓘ</span><p>${tr('route.privacy')}<br><small>${tr('route.map.privacy')}</small></p></div>
        <p class="gba__error" data-route-error hidden></p>
        <button type="button" class="gba__button gba__route-submit" data-route-submit>${tr('route.button')}</button>
      </div>`;
    const startInput = content.querySelector('[data-route-start]');
    const destinationInput = content.querySelector('[data-route-destination]');
    const submit = content.querySelector('[data-route-submit]');
    const errorBox = content.querySelector('[data-route-error]');
    const settings = routeApiSettings();

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    async function runRouteCheck() {
      state.routeStart = (startInput.value || '').trim();
      state.routeDestination = (destinationInput.value || '').trim();
      if (!state.routeStart || !state.routeDestination) { showError(tr('route.error.empty')); return; }
      if (normalizeZone(state.routeStart) === normalizeZone(state.routeDestination)) { showError(tr('route.error.same')); return; }
      if (!settings.enabled || !settings.endpoint) { showError(tr('route.error.config')); return; }
      errorBox.hidden = true;
      submit.disabled = true;
      submit.textContent = tr('route.loading');
      try {
        const response = await fetch(settings.endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            origin: state.routeStart,
            destination: state.routeDestination,
            language: localeRaw || locale || 'de'
          })
        });
        let payload = null;
        try { payload = await response.json(); } catch (error) {}
        if (!response.ok || !payload || payload.ok !== true || !payload.route) {
          const code = payload && payload.error && payload.error.code;
          console.warn('[Green Badge] Route API failed', { status: response.status, code: code || 'NO_CODE' });
          if (code === 'DAILY_LIMIT') throw new Error('DAILY_LIMIT');
          if (response.status === 429 || code === 'RATE_LIMIT') throw new Error('RATE_LIMIT');
          if (code === 'NOT_FOUND' || response.status === 422) throw new Error('NOT_FOUND');
          if (code === 'CONFIG') throw new Error('CONFIG');
          throw new Error('NETWORK');
        }
        state.routeData = payload.route;
        state.routeZoneCheck = payload.route.zoneCheck || null;

        // V6.2 Beta 6: Die schnelle lokale Korridor-/Radiusprüfung bleibt immer aktiv.
        // Exakte Polygon-Treffer werden zusätzlich eingemischt und ersetzen den
        // entsprechenden lokalen Treffer. Dadurch gibt es auch bei einem leeren,
        // unvollständigen oder zeitlich abgebrochenen Polygonvergleich keinen
        // falschen Ergebniszustand „keine Umweltzonen“.
        const radiusZones = findZonesAlongRoute(payload.route.polyline || '', state.routeStart, state.routeDestination);
        const serverZones = state.routeZoneCheck && Array.isArray(state.routeZoneCheck.zones)
          ? state.routeZoneCheck.zones.map(serverZone => {
              const localZone = findZoneByName(serverZone.name) || {};
              return Object.assign({}, localZone, serverZone, {
                name: serverZone.name || localZone.name || '',
                state: serverZone.state || localZone.state || '',
                exactPolygon: true,
                routeDistanceKm: 0,
                routeSegmentIndex: Number(serverZone.routeSegmentIndex || 0),
                lat: Number.isFinite(Number(localZone.lat)) ? Number(localZone.lat) : Number(serverZone.markerLat),
                lng: Number.isFinite(Number(localZone.lng)) ? Number(localZone.lng) : Number(serverZone.markerLng)
              });
            }).filter(zone => zone.name)
          : [];

        const mergedZones = new Map();
        radiusZones.forEach(zone => mergedZones.set(normalizeZone(zone.name), zone));
        serverZones.forEach(zone => mergedZones.set(normalizeZone(zone.name), zone));
        state.routeZones = Array.from(mergedZones.values()).sort((a, b) =>
          Number(a.routeSegmentIndex || 0) - Number(b.routeSegmentIndex || 0)
        );
        showRouteResult();
      } catch (error) {
        const code = error && error.message;
        if (!['DAILY_LIMIT', 'RATE_LIMIT', 'NOT_FOUND', 'CONFIG', 'NETWORK'].includes(code)) console.warn('[Green Badge] Route request exception', { type: error?.name || 'unknown' });
        showError(code === 'DAILY_LIMIT' ? tr('route.error.daily') : code === 'RATE_LIMIT' ? tr('route.error.rate') : code === 'NOT_FOUND' ? tr('route.error.notfound') : code === 'CONFIG' ? tr('route.error.config') : tr('route.error.network'));
      } finally {
        submit.disabled = false;
        submit.textContent = tr('route.button');
      }
    }
    submit.addEventListener('click', runRouteCheck);
    [startInput, destinationInput].forEach(input => input.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); runRouteCheck(); }
    }));
    startInput.focus();
  }

  function decodeGooglePolyline(encoded) {
    const points = [];
    let index = 0, lat = 0, lng = 0;
    while (index < encoded.length) {
      let result = 0, shift = 0, byte;
      do { byte = encoded.charCodeAt(index++) - 63; result |= (byte & 0x1f) << shift; shift += 5; } while (byte >= 0x20 && index <= encoded.length);
      const dLat = (result & 1) ? ~(result >> 1) : (result >> 1);
      lat += dLat;
      result = 0; shift = 0;
      do { byte = encoded.charCodeAt(index++) - 63; result |= (byte & 0x1f) << shift; shift += 5; } while (byte >= 0x20 && index <= encoded.length);
      const dLng = (result & 1) ? ~(result >> 1) : (result >> 1);
      lng += dLng;
      points.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return points;
  }

  function localXY(point, refLat) {
    const kmPerDegree = 111.32;
    return { x: Number(point.lng) * kmPerDegree * Math.cos(toRadians(refLat)), y: Number(point.lat) * kmPerDegree };
  }

  function pointToSegmentDistance(point, a, b) {
    const refLat = (Number(point.lat) + Number(a.lat) + Number(b.lat)) / 3;
    const p = localXY(point, refLat), p1 = localXY(a, refLat), p2 = localXY(b, refLat);
    const dx = p2.x - p1.x, dy = p2.y - p1.y;
    const lengthSq = dx * dx + dy * dy;
    if (!lengthSq) return Math.hypot(p.x - p1.x, p.y - p1.y);
    const t = Math.max(0, Math.min(1, ((p.x - p1.x) * dx + (p.y - p1.y) * dy) / lengthSq));
    return Math.hypot(p.x - (p1.x + t * dx), p.y - (p1.y + t * dy));
  }

  function nearestRouteDistance(point, routePoints) {
    let min = Infinity, segmentIndex = 0;
    for (let i = 0; i < routePoints.length - 1; i += 1) {
      const distance = pointToSegmentDistance(point, routePoints[i], routePoints[i + 1]);
      if (distance < min) { min = distance; segmentIndex = i; }
    }
    return { distanceKm: min, segmentIndex };
  }

  function zoneApproxRadiusKm(zone) {
    const overrides = {
      'berlin': 18,
      'münchen': 18,
      'munchen': 18,
      'munich': 18,
      'köln': 15,
      'koeln': 15,
      'cologne': 15,
      'stuttgart': 14,
      'frankfurt a.m.': 13,
      'frankfurt am main': 13,
      'hannover': 12,
      'düsseldorf': 12,
      'dusseldorf': 12,
      'regensburg': 9,
      'augsburg': 9,
      'pforzheim': 9,
      'ludwigsburg und umgebung': 11,
      'ruhrgebiet': 26,
      'mainz und wiesbaden': 13,
      'mainz/wiesbaden': 13
    };
    const key = normalizeZone(zone && zone.name);
    if (overrides[key]) return overrides[key];
    if (zone && Number.isFinite(Number(zone.routeRadiusKm))) return Number(zone.routeRadiusKm);
    if (zone && zone.type === 'area') return 22;
    return 8;
  }

  function zoneRouteThresholdKm(zone) {
    const radius = zoneApproxRadiusKm(zone);
    const corridor = zone && zone.type === 'area' ? 4 : 3;
    return radius + corridor;
  }

  function findZonesAlongRoute(encodedPolyline, originText, destinationText) {
    const routePoints = decodeGooglePolyline(encodedPolyline || '');
    if (routePoints.length < 2) return [];
    const originNames = new Set(findZoneMatches(originText).map(zone => zone.name));
    const destinationNames = new Set(findZoneMatches(destinationText).map(zone => zone.name));
    const seen = new Set();
    return activeZonesWithCoordinates().map(zone => {
      const nearest = nearestRouteDistance(zone, routePoints);
      const endpointMatch = originNames.has(zone.name) || destinationNames.has(zone.name);
      const threshold = zoneRouteThresholdKm(zone);
      if (!endpointMatch && nearest.distanceKm > threshold) return null;
      return Object.assign({}, zone, {
        routeDistanceKm: Math.round(nearest.distanceKm * 10) / 10,
        routeSegmentIndex: endpointMatch && destinationNames.has(zone.name) ? routePoints.length : nearest.segmentIndex,
        endpointMatch,
        approxZoneRadiusKm: zoneApproxRadiusKm(zone),
        routeThresholdKm: threshold,
        routeHitType: endpointMatch ? 'endpoint' : (nearest.distanceKm <= zoneApproxRadiusKm(zone) ? 'inside' : 'near')
      });
    }).filter(Boolean).filter(zone => {
      const key = zone.nearbyKey || normalizeZone(zone.name);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    }).sort((a, b) => a.routeSegmentIndex - b.routeSegmentIndex);
  }

  function formatRouteDistance(meters) {
    const km = Number(meters || 0) / 1000;
    try { return new Intl.NumberFormat(localeRaw || undefined, { maximumFractionDigits: km < 100 ? 1 : 0 }).format(km) + ' km'; }
    catch (error) { return Math.round(km) + ' km'; }
  }

  function formatRouteDuration(durationValue) {
    const seconds = Math.max(0, Math.round(parseFloat(String(durationValue || '').replace('s','')) || 0));
    const hours = Math.floor(seconds / 3600), minutes = Math.max(1, Math.round((seconds % 3600) / 60));
    return hours ? `${hours} h ${minutes} min` : `${minutes} min`;
  }

  function formatRouteSourceDate(value) {
    const raw = String(value || '').trim();
    if (!raw) return String(ZONES.dataVersion || '29.09.2025');
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return raw;
    try {
      return new Intl.DateTimeFormat(localeRaw || undefined, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date);
    } catch (error) {
      return date.toLocaleDateString('de-DE');
    }
  }

  function routeSourceName() {
    const source = state.routeZoneCheck && state.routeZoneCheck.source;
    return String(source || 'Umweltbundesamt (UBA)').trim();
  }

  function routeSourceDate() {
    return formatRouteSourceDate((state.routeZoneCheck && state.routeZoneCheck.dataVersion) || ZONES.dataVersion || '29.09.2025');
  }

  function routeSourceText(key) {
    return tr(key)
      .replace('{source}', escapeHtml(routeSourceName()))
      .replace('{date}', escapeHtml(routeSourceDate()));
  }

  function renderRouteSource() {
    return `<div class="gba__route-source"><strong>${tr('route.source.label')}:</strong> <span>${routeSourceText('route.source.text')}</span></div>`;
  }

  function renderRouteFacts() {
    if (!resultFacts || !state.routeData) return;
    const rows = [
      [tr('route.facts.start'), escapeHtml(state.routeStart)],
      [tr('route.facts.destination'), escapeHtml(state.routeDestination)],
      [tr('route.facts.distance'), escapeHtml(formatRouteDistance(state.routeData.distanceMeters))],
      [tr('route.facts.duration'), escapeHtml(formatRouteDuration(state.routeData.duration))],
      [tr('route.facts.zones'), escapeHtml(state.routeZones.length ? state.routeZones.map(zone => zone.name).join(', ') : '—')],
      [tr('zone.facts.dataVersion'), escapeHtml((state.routeZoneCheck && state.routeZoneCheck.dataVersion) || ZONES.dataVersion || '29.09.2025')]
    ];
    resultFacts.innerHTML = rows.map(([key, value]) => `<li><span>✓</span><strong>${key}:</strong> ${value}</li>`).join('');
  }

  function renderRouteZones() {
    if (!state.routeZones.length) return '';
    const items = state.routeZones.map(zone => {
      const detail = zone.exactPolygon
        ? tr('route.zones.exact')
        : zone.endpointMatch
          ? tr('route.zones.endpoint')
          : tr('route.zones.routeDistance').replace('{km}', String(zone.routeDistanceKm).replace('.', ','));
      return `<li><strong>${escapeHtml(zone.name)}</strong><span>${escapeHtml(zone.state || '')} · ${escapeHtml(detail)}</span></li>`;
    }).join('');
    return `<div class="gba__zone-nearby gba__route-zones"><h4>${tr('route.zones.title')}</h4><p>${tr('route.zones.lead')}</p><ul>${items}</ul></div>`;
  }

  function googleMapsDirectionsUrl() {
    const params = new URLSearchParams({ api: '1', origin: state.routeStart, destination: state.routeDestination, travelmode: 'driving' });
    return 'https://www.google.com/maps/dir/?' + params.toString();
  }


  let greenBadgeGoogleMapsPromise = null;
  function loadGoogleMapsJs(apiKey) {
    if (window.google && window.google.maps) return Promise.resolve(window.google.maps);
    if (greenBadgeGoogleMapsPromise) return greenBadgeGoogleMapsPromise;
    greenBadgeGoogleMapsPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&v=weekly';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        if (window.google && window.google.maps) resolve(window.google.maps);
        else reject(new Error('GOOGLE_MAPS_UNAVAILABLE'));
      };
      script.onerror = () => reject(new Error('GOOGLE_MAPS_UNAVAILABLE'));
      document.head.appendChild(script);
    });
    return greenBadgeGoogleMapsPromise;
  }

  function routePathPoints() {
    const encoded = state.routeData && state.routeData.polyline ? state.routeData.polyline : '';
    return decodeGooglePolyline(encoded).map(point => ({ lat: Number(point.lat), lng: Number(point.lng) })).filter(point => Number.isFinite(point.lat) && Number.isFinite(point.lng));
  }

  function renderInteractiveRouteMap(container, maps) {
    const path = routePathPoints();
    if (!path.length) throw new Error('ROUTE_PATH_EMPTY');
    const map = new maps.Map(container, {
      center: path[0],
      zoom: 7,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      clickableIcons: false,
      gestureHandling: 'greedy'
    });
    const bounds = new maps.LatLngBounds();
    path.forEach(point => bounds.extend(point));

    new maps.Polyline({
      path,
      map,
      strokeColor: '#1a73e8',
      strokeOpacity: 0.92,
      strokeWeight: 5.5
    });

    const infoWindow = new maps.InfoWindow();
    const originMarker = new maps.Marker({ map, position: path[0], label: 'A', title: state.routeStart });
    const destinationMarker = new maps.Marker({ map, position: path[path.length - 1], label: 'B', title: state.routeDestination });
    [originMarker, destinationMarker].forEach(marker => {
      marker.addListener('click', () => infoWindow.close());
    });

    (state.routeZones || []).forEach((zone, index) => {
      const lat = Number(zone.lat);
      const lng = Number(zone.lng);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
      const marker = new maps.Marker({
        map,
        position: { lat, lng },
        title: zone.name,
        icon: {
          path: maps.SymbolPath.CIRCLE,
          fillColor: '#00843d',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          scale: 10
        },
        zIndex: 10 + index
      });
      bounds.extend({ lat, lng });
      marker.addListener('click', () => {
        const subtitle = zone.exactPolygon ? tr('route.zones.polygon') : (zone.endpointMatch ? tr('route.zones.endpoint') : tr('route.zones.routeDistance').replace('{km}', formatKm(zone.routeDistanceKm || 0)));
        infoWindow.setContent('<div class="gba__route-info-window"><strong>' + escapeHtml(zone.name) + '</strong><br><span>' + escapeHtml(zone.state || '') + '</span><br><small>' + escapeHtml(subtitle) + '</small></div>');
        infoWindow.open({ anchor: marker, map, shouldFocus: false });
      });
    });

    map.fitBounds(bounds, 56);
    if (path.length === 1) map.setZoom(10);
    return { map, maps, bounds, infoWindow };
  }

  function zoneGeometryEndpoint(settings) {
    if (settings.zoneGeometryUrl) return settings.zoneGeometryUrl;
    try { return new URL('zone-map.php', settings.endpoint).toString(); }
    catch (error) { return ''; }
  }

  async function loadZoneAreas(context, settings, zones, fitPadding = 56) {
    if (!context || !context.map || !Array.isArray(zones) || !zones.length) return;
    const endpoint = zoneGeometryEndpoint(settings);
    if (!endpoint) return;
    const objectIds = zones.map(zone => Number(zone.objectId || 0)).filter(id => Number.isFinite(id) && id > 0);
    const names = zones.map(zone => String(zone.name || '').trim()).filter(Boolean);
    if (!objectIds.length && !names.length) return;

    const response = await fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/geo+json, application/json' },
      body: JSON.stringify({ objectIds, names })
    });
    if (!response.ok) throw new Error('ZONE_GEOMETRY_UNAVAILABLE');
    const geoJson = await response.json();
    if (!geoJson || geoJson.type !== 'FeatureCollection' || !Array.isArray(geoJson.features) || !geoJson.features.length) return;

    const added = context.map.data.addGeoJson(geoJson);
    context.map.data.setStyle({
      fillColor: '#34a853',
      fillOpacity: 0.20,
      strokeColor: '#00843d',
      strokeOpacity: 0.92,
      strokeWeight: 2,
      clickable: true,
      zIndex: 2
    });
    added.forEach(feature => {
      const geometry = feature.getGeometry();
      if (geometry && typeof geometry.forEachLatLng === 'function') {
        geometry.forEachLatLng(latLng => context.bounds.extend(latLng));
      }
    });
    context.map.data.addListener('mouseover', event => {
      context.map.data.overrideStyle(event.feature, { fillOpacity: 0.32, strokeWeight: 3 });
    });
    context.map.data.addListener('mouseout', event => {
      context.map.data.revertStyle(event.feature);
    });
    context.map.data.addListener('click', event => {
      const name = String(event.feature.getProperty('name') || '');
      const stateName = String(event.feature.getProperty('state') || '');
      context.infoWindow.setContent('<div class="gba__route-info-window"><strong>' + escapeHtml(name) + '</strong><br><span>' + escapeHtml(stateName) + '</span><br><small>' + escapeHtml(tr('route.map.area')) + '</small></div>');
      context.infoWindow.setPosition(event.latLng);
      context.infoWindow.open({ map: context.map, shouldFocus: false });
    });
    context.map.fitBounds(context.bounds, fitPadding);
  }

  async function loadRouteZoneAreas(context, settings) {
    return loadZoneAreas(context, settings, state.routeZones || [], 56);
  }



  function destinationMapPayload() {
    const directZones = Array.isArray(state.zoneMatches) ? state.zoneMatches : [];
    const nearbyZones = directZones.length ? [] : findNearbyZones(state.destinationQuery);
    const zones = directZones.length ? directZones : nearbyZones;
    const place = findPlaceMatch(state.destinationQuery);
    let center = place && hasCoordinates(place) ? { lat: Number(place.lat), lng: Number(place.lng) } : null;
    if (!center && zones.length && hasCoordinates(zones[0])) center = { lat: Number(zones[0].lat), lng: Number(zones[0].lng) };
    return { zones, center, direct: directZones.length > 0 };
  }

  function googleMapsDestinationUrl() {
    const params = new URLSearchParams({ api: '1', query: state.destinationQuery || '' });
    return 'https://www.google.com/maps/search/?' + params.toString();
  }

  function renderInteractiveDestinationMap(container, maps, payload) {
    if (!payload || !payload.center) throw new Error('DESTINATION_MAP_EMPTY');
    const map = new maps.Map(container, {
      center: payload.center,
      zoom: payload.direct ? 11 : 8,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      clickableIcons: false,
      gestureHandling: 'greedy'
    });
    const bounds = new maps.LatLngBounds();
    bounds.extend(payload.center);
    const infoWindow = new maps.InfoWindow();
    const destinationMarker = new maps.Marker({
      map,
      position: payload.center,
      title: state.destinationQuery,
      label: 'Z',
      zIndex: 30
    });
    destinationMarker.addListener('click', () => {
      infoWindow.setContent('<div class="gba__route-info-window"><strong>' + escapeHtml(tr('zone.map.destination')) + '</strong><br><span>' + escapeHtml(state.destinationQuery) + '</span></div>');
      infoWindow.open({ anchor: destinationMarker, map, shouldFocus: false });
    });

    (payload.zones || []).forEach((zone, index) => {
      const lat = Number(zone.lat);
      const lng = Number(zone.lng);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
      const position = { lat, lng };
      bounds.extend(position);
      const marker = new maps.Marker({
        map,
        position,
        title: zone.name,
        icon: {
          path: maps.SymbolPath.CIRCLE,
          fillColor: '#00843d',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          scale: 10
        },
        zIndex: 10 + index
      });
      marker.addListener('click', () => {
        const distance = Number.isFinite(Number(zone.distanceKm)) ? tr('zone.nearby.distance').replace('{km}', String(zone.distanceKm)) : '';
        const details = [zone.state || '', distance].filter(Boolean).join(' · ');
        infoWindow.setContent('<div class="gba__route-info-window"><strong>' + escapeHtml(zone.name) + '</strong><br><span>' + escapeHtml(details) + '</span></div>');
        infoWindow.open({ anchor: marker, map, shouldFocus: false });
      });
    });
    map.fitBounds(bounds, 56);
    return { map, maps, bounds, infoWindow };
  }

  let routeModal = null;
  function ensureRouteModal() {
    if (routeModal) return routeModal;
    routeModal = document.createElement('div');
    routeModal.className = 'gba__route-modal';
    routeModal.hidden = true;
    routeModal.innerHTML = `<div class="gba__route-modal-backdrop" data-route-modal-close></div><div class="gba__route-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="gba-route-modal-title"><div class="gba__route-modal-head"><h2 id="gba-route-modal-title"></h2><button type="button" class="gba__route-modal-close" data-route-modal-close aria-label="">×</button></div><div class="gba__route-map-wrap" data-route-map-wrap></div><div class="gba__route-modal-source" data-route-modal-source></div><div class="gba__route-modal-actions"><a class="gba__button" data-route-google target="_blank" rel="noopener noreferrer"></a><button type="button" class="gba__button gba__button--secondary" data-route-modal-close></button></div></div>`;
    document.body.appendChild(routeModal);
    routeModal.querySelectorAll('[data-route-modal-close]').forEach(button => button.addEventListener('click', closeRouteModal));
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && routeModal && !routeModal.hidden) closeRouteModal(); });
    return routeModal;
  }

  function closeRouteModal() {
    if (!routeModal) return;
    routeModal.hidden = true;
    document.body.classList.remove('gba-route-modal-open');
    const wrap = routeModal.querySelector('[data-route-map-wrap]');
    if (wrap) wrap.innerHTML = '';
  }

  async function openRouteModal() {
    const modal = ensureRouteModal();
    const settings = routeApiSettings();
    modal.querySelector('#gba-route-modal-title').textContent = tr('route.modal.title');
    const closeButton = modal.querySelector('.gba__route-modal-close');
    closeButton.setAttribute('aria-label', tr('route.modal.close'));
    modal.querySelector('.gba__route-modal-actions button').textContent = tr('route.modal.close');
    const external = modal.querySelector('[data-route-google]');
    external.textContent = tr('route.cta.google');
    external.href = googleMapsDirectionsUrl();
    const modalSource = modal.querySelector('[data-route-modal-source]');
    if (modalSource) modalSource.innerHTML = routeSourceText('route.source.map');
    const wrap = modal.querySelector('[data-route-map-wrap]');
    wrap.innerHTML = '';
    modal.hidden = false;
    document.body.classList.add('gba-route-modal-open');
    closeButton.focus();
    try {
      if (settings.jsApiKey) {
        const hint = document.createElement('div');
        hint.className = 'gba__route-map-hint';
        hint.textContent = tr('route.modal.mapHint');
        wrap.appendChild(hint);
        const mapCanvas = document.createElement('div');
        mapCanvas.className = 'gba__route-map-canvas';
        wrap.appendChild(mapCanvas);
        const maps = await loadGoogleMapsJs(settings.jsApiKey);
        const mapContext = renderInteractiveRouteMap(mapCanvas, maps);
        try { await loadRouteZoneAreas(mapContext, settings); } catch (error) { /* Marker bleiben als sicherer Fallback sichtbar. */ }
      } else if (settings.embedKey) {
        const params = new URLSearchParams({ key: settings.embedKey, origin: state.routeStart, destination: state.routeDestination, mode: 'driving', units: 'metric', language: (localeRaw || locale || 'de').slice(0,2) });
        const iframe = document.createElement('iframe');
        iframe.title = tr('route.modal.title');
        iframe.loading = 'lazy';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.src = 'https://www.google.com/maps/embed/v1/directions?' + params.toString();
        wrap.appendChild(iframe);
      } else {
        wrap.innerHTML = `<div class="gba__route-map-empty"><span aria-hidden="true">🗺️</span><p>${tr('route.modal.noKey')}</p></div>`;
      }
    } catch (error) {
      wrap.innerHTML = `<div class="gba__route-map-empty"><span aria-hidden="true">🗺️</span><p>${tr('route.modal.noKey')}</p></div>`;
    }
  }


  async function openDestinationMapModal() {
    const payload = destinationMapPayload();
    if (!payload.zones.length || !payload.center) return;
    const modal = ensureRouteModal();
    const settings = routeApiSettings();
    modal.querySelector('#gba-route-modal-title').textContent = tr(payload.direct ? 'zone.map.title.direct' : 'zone.map.title.nearby');
    const closeButton = modal.querySelector('.gba__route-modal-close');
    closeButton.setAttribute('aria-label', tr('route.modal.close'));
    modal.querySelector('.gba__route-modal-actions button').textContent = tr('route.modal.close');
    const external = modal.querySelector('[data-route-google]');
    external.textContent = tr('zone.map.openGoogle');
    external.href = googleMapsDestinationUrl();
    const modalSource = modal.querySelector('[data-route-modal-source]');
    if (modalSource) modalSource.innerHTML = routeSourceText('route.source.map');
    const wrap = modal.querySelector('[data-route-map-wrap]');
    wrap.innerHTML = '';
    modal.hidden = false;
    document.body.classList.add('gba-route-modal-open');
    closeButton.focus();
    try {
      if (!settings.jsApiKey) throw new Error('GOOGLE_MAPS_UNAVAILABLE');
      const hint = document.createElement('div');
      hint.className = 'gba__route-map-hint';
      hint.textContent = tr(payload.direct ? 'zone.map.hint.direct' : 'zone.map.hint.nearby');
      wrap.appendChild(hint);
      const mapCanvas = document.createElement('div');
      mapCanvas.className = 'gba__route-map-canvas';
      wrap.appendChild(mapCanvas);
      const maps = await loadGoogleMapsJs(settings.jsApiKey);
      const mapContext = renderInteractiveDestinationMap(mapCanvas, maps, payload);
      try { await loadZoneAreas(mapContext, settings, payload.zones, 56); } catch (error) { /* Marker bleiben sichtbar. */ }
      trackAssistantEvent({
        'Assistent Modus': 'Reisezielprüfung',
        'Assistent Kartenansicht': payload.direct ? 'Umweltzone am Ziel' : 'Nahe Umweltzonen',
        'Assistent Reiseziel': state.destinationQuery || ''
      });
    } catch (error) {
      wrap.innerHTML = `<div class="gba__route-map-empty"><span aria-hidden="true">🗺️</span><p>${tr('zone.map.noData')}</p></div>`;
    }
  }

  function bindRouteResultActions() {
    const startVehicle = reason.querySelector('[data-route-start-vehicle]');
    if (startVehicle) startVehicle.addEventListener('click', beginVehicleCheck);
    const another = reason.querySelector('[data-route-another]');
    if (another) another.addEventListener('click', () => { state.step = 'routeInput'; state.routeData = null; state.routeZones = []; state.routeZoneCheck = null; render(); });
    const map = reason.querySelector('[data-route-map]');
    if (map) map.addEventListener('click', openRouteModal);
  }

  function showRouteResult() {
    setPanelView(null);
    state.step = 'routeResult';
    panel.hidden = true;
    result.hidden = false;
    updateSteps(3, 'zone');
    const hasZones = state.routeZones.length > 0;
    if (greenCard) greenCard.hidden = !hasZones;
    if (blueCard) blueCard.hidden = true;
    renderRouteFacts();
    heading.innerHTML = tr('route.result.title');
    setResultView(hasZones ? 'route-found' : 'route-empty');
    setOutcome(hasZones ? '🟢' : '⚪', hasZones ? tr('route.found.status') : tr('route.none.status'), hasZones ? tr('route.found.permission') : tr('route.none.permission'));
    const routeZonesMarkup = renderRouteZones();
    const polygonMode = state.routeZoneCheck && state.routeZoneCheck.mode === 'polygon';
    const checkNote = polygonMode ? tr('route.polygon.note') : tr('route.radius.note');
    reason.innerHTML = `${routeZonesMarkup}<p class="gba__route-beta-note">${checkNote} <strong>${tr('route.authoritative.note')}</strong></p>${renderRouteSource()}<div class="gba__zone-actions"><button type="button" class="gba__button" data-route-map>${tr('route.cta.map')}</button>${hasZones ? `<button type="button" class="gba__button" data-route-start-vehicle>${tr('route.cta.vehicle')}</button>` : ''}<button type="button" class="gba__button gba__button--secondary" data-route-another>${tr('route.cta.another')}</button></div>`;
    trackAssistantEvent({
      'Assistent Modus': 'Routenprüfung',
      'Assistent Startort': state.routeStart,
      'Assistent Zielort': state.routeDestination,
      'Assistent Ergebnis': hasZones ? 'Umweltzonen an Route erkannt' : 'Keine Umweltzone an Route erkannt',
      'Assistent Umweltzone': hasZones ? 'Ja' : 'Nein',
      'Assistent Umweltzone Name': hasZones ? state.routeZones.map(zone => zone.name).join(', ') : '',
      'Assistent Route Entfernung': formatRouteDistance(state.routeData && state.routeData.distanceMeters),
      'Assistent Empfehlung': hasZones ? 'Grüne Umweltplakette' : 'Keine direkte Kaufempfehlung',
      'Assistent Datenstand': (state.routeZoneCheck && state.routeZoneCheck.dataVersion) || ZONES.dataVersion || '',
      'Assistent Prüfverfahren': state.routeZoneCheck && state.routeZoneCheck.mode === 'polygon' ? 'Exakte UBA-Umweltzonenflächen' : 'Radius-Fallback'
    });
    bindRouteResultActions();
    schedulePwaInstallCard();
  }

  function normalizeZone(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ä/g,'a').replace(/ö/g,'o').replace(/ü/g,'u').replace(/ß/g,'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }
  function zoneSearchTerms(zone) {
    return [zone.name].concat(zone.aliases || []).map(normalizeZone).filter(Boolean);
  }
  function findZoneMatches(query) {
    const q = normalizeZone(query);
    if (!q) return [];
    const exact = [];
    const partial = [];
    (ZONES.zones || []).forEach(zone => {
      const terms = zoneSearchTerms(zone);
      if (terms.some(t => t === q)) exact.push(zone);
      else if (q.length >= 4 && terms.some(t => t.includes(q) || q.includes(t))) partial.push(zone);
    });
    const seen = new Set();
    return exact.concat(partial).filter(zone => {
      const key = zone.name + '|' + zone.state + '|' + zone.validFromDisplay;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }
  function uniqueJoined(values) {
    return [...new Set(values.filter(Boolean))].join(', ');
  }
  function renderZoneInput() {
    setPanelView('zone');
    result.hidden = true;
    panel.hidden = false;
    updateSteps(2, 'zone');
    back.hidden = false;
    next.hidden = true;
    title.textContent = tr('zone.title');
    sub.textContent = tr('zone.sub');
    content.innerHTML = `
      <div class="gba__zone-search">
        <label for="gba-zone-input">${tr('zone.input.label')}</label>
        <div class="gba__zone-row">
          <input id="gba-zone-input" class="gba__input" data-zone-input value="${escapeHtml(state.destinationQuery)}" placeholder="${escapeHtml(tr('zone.input.placeholder'))}">
          <button type="button" class="gba__button" data-zone-submit>${tr('zone.button')}</button>
        </div>
        <p class="gba__hint">${tr('zone.examples')}</p>
        <p class="gba__error" data-zone-error hidden></p>
      </div>`;
    const input = content.querySelector('[data-zone-input]');
    const submit = content.querySelector('[data-zone-submit]');
    function runSearch() {
      state.destinationQuery = (input.value || '').trim();
      const err = content.querySelector('[data-zone-error]');
      if (!state.destinationQuery) {
        if (err) { err.textContent = tr('zone.error.empty'); err.hidden = false; }
        input.focus();
        return;
      }
      state.zoneMatches = findZoneMatches(state.destinationQuery);
      showZoneResult();
    }
    submit.addEventListener('click', runSearch);
    input.addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); runSearch(); } });
    input.focus();
  }
  function renderZoneFacts(matches) {
    const rows = [];
    rows.push([tr('zone.facts.destination'), escapeHtml(state.destinationQuery)]);
    if (matches.length) {
      rows.push([tr('zone.facts.zone'), escapeHtml(matches.length > 1 ? matches.map(z => z.name).join(', ') : matches[0].name)]);
      rows.push([tr('zone.facts.state'), escapeHtml(uniqueJoined(matches.map(z => z.state)))]);
      rows.push([tr('zone.facts.badge'), tr('zone.badge.green')]);
      rows.push([tr('zone.facts.validFrom'), escapeHtml(uniqueJoined(matches.map(z => z.validFromDisplay)))]);
    }
    rows.push([tr('zone.facts.dataVersion'), escapeHtml(ZONES.dataVersion || '13.11.2023')]);
    if (!resultFacts) return;
    resultFacts.innerHTML = rows.map(([k,v]) => `<li><span>✓</span><strong>${k}:</strong> ${v}</li>`).join('');
  }
  function bindZoneResultActions() {
    const startVehicle = reason.querySelector('[data-zone-start-vehicle]');
    if (startVehicle) startVehicle.addEventListener('click', beginVehicleCheck);
    const another = reason.querySelector('[data-zone-another]');
    if (another) another.addEventListener('click', () => { state.step = 'zoneInput'; render(); });
    const mapButton = reason.querySelector('[data-zone-map]');
    if (mapButton) mapButton.addEventListener('click', openDestinationMapModal);
  }

  function pwaSettings() {
    const settings = window.GreenBadgeAssistantSettings || {};
    return {
      enabled: settings.pwaEnabled !== false,
      manifestUrl: String(settings.pwaManifestUrl || '').trim(),
      iconUrl: String(settings.pwaIconUrl || '').trim(),
      trackingEnabled: settings.pwaTrackingEnabled !== false,
      trackingUrl: String(settings.pwaTrackingUrl || '').trim()
    };
  }

  function isStandaloneDisplay() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }

  function isMobileOrTabletDevice() {
    const ua = String(navigator.userAgent || '');
    const uaDataMobile = Boolean(navigator.userAgentData && navigator.userAgentData.mobile === true);
    const isIpadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const mobileOrTabletUa = /Android|iPhone|iPad|iPod|Mobile|Tablet|Silk|Kindle|PlayBook/i.test(ua);
    const coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    const noHover = window.matchMedia && window.matchMedia('(hover: none)').matches;
    const screenWidth = Number(window.screen && window.screen.width) || window.innerWidth || 0;
    const screenHeight = Number(window.screen && window.screen.height) || window.innerHeight || 0;
    const shortSide = Math.min(screenWidth || Infinity, screenHeight || Infinity);
    const tabletFallback = navigator.maxTouchPoints > 1 && coarsePointer && noHover && shortSide <= 1100;
    return uaDataMobile || isIpadOs || mobileOrTabletUa || tabletFallback;
  }


  function pwaPlatform() {
    const ua = String(navigator.userAgent || '').toLowerCase();
    if (/iphone|ipad|ipod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ios';
    if (/android/.test(ua)) return 'android';
    return 'other';
  }

  function publishPwaShopifyEvent(eventName, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('greenbadge:pwa_' + eventName, data || {});
      }
    } catch (error) {}
  }

  function sendPwaTrackingEvent(eventName) {
    const settings = pwaSettings();
    const payload = {
      event: eventName,
      platform: pwaPlatform(),
      locale: localeRaw || locale || 'de'
    };
    publishPwaShopifyEvent(eventName, payload);
    if (!settings.trackingEnabled || !settings.trackingUrl || !window.fetch) return Promise.resolve(false);
    return fetch(settings.trackingUrl, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(response => response.ok).catch(() => false);
  }

  function trackStandalonePwaLaunch() {
    if (!isStandaloneDisplay()) return;
    let alreadyTrackedThisSession = false;
    try {
      alreadyTrackedThisSession = window.sessionStorage.getItem('gbaPwaLaunchTracked') === '1';
      if (!alreadyTrackedThisSession) window.sessionStorage.setItem('gbaPwaLaunchTracked', '1');
    } catch (error) {}
    if (alreadyTrackedThisSession) return;

    sendPwaTrackingEvent('standalone_launch');
    let firstLaunch = false;
    try {
      firstLaunch = window.localStorage.getItem('gbaPwaFirstLaunchTracked') !== '1';
      if (firstLaunch) window.localStorage.setItem('gbaPwaFirstLaunchTracked', '1');
    } catch (error) {}
    sendPwaTrackingEvent(firstLaunch ? 'first_standalone_launch' : 'return_standalone_launch');
    persistAssistantAttributes({
      'Assistent Web-App genutzt': 'Ja',
      'Assistent Web-App Start': firstLaunch ? 'Erster Start' : 'Wiederkehrender Start'
    });
  }

  function setupPwaMetadata() {
    const settings = pwaSettings();
    if (!settings.enabled) return;
    if (settings.manifestUrl && !document.head.querySelector('link[rel="manifest"][data-gba-pwa]')) {
      const link = document.createElement('link');
      link.rel = 'manifest';
      link.href = settings.manifestUrl;
      link.crossOrigin = 'anonymous';
      link.setAttribute('data-gba-pwa', '');
      document.head.appendChild(link);
    }
    if (settings.iconUrl && !document.head.querySelector('link[rel="apple-touch-icon"][data-gba-pwa]')) {
      const icon = document.createElement('link');
      icon.rel = 'apple-touch-icon';
      icon.href = settings.iconUrl;
      icon.setAttribute('data-gba-pwa', '');
      document.head.appendChild(icon);
    }
    if (!document.head.querySelector('meta[name="theme-color"][data-gba-pwa]')) {
      const theme = document.createElement('meta');
      theme.name = 'theme-color';
      theme.content = '#00843d';
      theme.setAttribute('data-gba-pwa', '');
      document.head.appendChild(theme);
    }
  }

  function pwaDismissedRecently() {
    try {
      if (window.localStorage.getItem('gbaPwaInstalled') === '1') return true;
      const dismissed = Number(window.localStorage.getItem('gbaPwaDismissedAt') || 0);
      return dismissed > 0 && Date.now() - dismissed < 14 * 24 * 60 * 60 * 1000;
    } catch (error) { return false; }
  }

  function removePwaInstallCard() {
    const card = root.querySelector('[data-pwa-install-card]');
    if (card) card.remove();
  }

  let pwaHelpModal = null;
  function closePwaHelpModal() {
    if (!pwaHelpModal) return;
    pwaHelpModal.hidden = true;
    document.body.classList.remove('gba-pwa-modal-open');
  }

  function openPwaHelpModal() {
    if (!pwaHelpModal) {
      pwaHelpModal = document.createElement('div');
      pwaHelpModal.className = 'gba__pwa-modal';
      pwaHelpModal.hidden = true;
      pwaHelpModal.innerHTML = `<div class="gba__pwa-modal-backdrop" data-pwa-modal-close></div><div class="gba__pwa-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="gba-pwa-title"><button type="button" class="gba__pwa-modal-x" data-pwa-modal-close aria-label="${escapeHtml(tr('route.modal.close'))}">×</button><div class="gba__pwa-modal-icon" aria-hidden="true">↗</div><h2 id="gba-pwa-title"></h2><p data-pwa-help-text></p><button type="button" class="gba__button" data-pwa-modal-close></button></div>`;
      document.body.appendChild(pwaHelpModal);
      pwaHelpModal.querySelectorAll('[data-pwa-modal-close]').forEach(button => button.addEventListener('click', closePwaHelpModal));
    }
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isAndroid = /android/i.test(navigator.userAgent);
    pwaHelpModal.querySelector('#gba-pwa-title').textContent = tr('pwa.modal.title');
    pwaHelpModal.querySelector('[data-pwa-help-text]').textContent = tr(isIos ? 'pwa.modal.ios' : isAndroid ? 'pwa.modal.android' : 'pwa.modal.generic');
    pwaHelpModal.querySelector('.gba__pwa-modal-dialog > .gba__button').textContent = tr('pwa.modal.close');
    pwaHelpModal.hidden = false;
    document.body.classList.add('gba-pwa-modal-open');
  }

  async function handlePwaInstall(button) {
    sendPwaTrackingEvent('install_click');
    if (deferredPwaInstallPrompt) {
      button.disabled = true;
      button.textContent = tr('pwa.installing');
      try {
        deferredPwaInstallPrompt.prompt();
        const choice = await deferredPwaInstallPrompt.userChoice;
        const accepted = choice && choice.outcome === 'accepted';
        sendPwaTrackingEvent(accepted ? 'install_accepted' : 'install_rejected');
        trackAssistantEvent({ 'Assistent Web-App': accepted ? 'Installation akzeptiert' : 'Installation abgelehnt' });
        if (choice && choice.outcome === 'accepted') {
          try { window.localStorage.setItem('gbaPwaInstalled', '1'); } catch (error) {}
          removePwaInstallCard();
        }
      } catch (error) {
        openPwaHelpModal();
      } finally {
        deferredPwaInstallPrompt = null;
        if (button && button.isConnected) { button.disabled = false; button.textContent = tr('pwa.card.button'); }
      }
      return;
    }
    sendPwaTrackingEvent('install_help_opened');
    trackAssistantEvent({ 'Assistent Web-App': 'Installationsanleitung geöffnet' });
    openPwaHelpModal();
  }

  function showPwaInstallCard() {
    const settings = pwaSettings();
    // Der Speichern-Hinweis ist bewusst nur für Smartphones und Tablets gedacht.
    // Desktop-Browser können PWAs ebenfalls installieren, sollen hier aber nicht
    // mit einem mobilen Home-Bildschirm-Hinweis angesprochen werden.
    if (!settings.enabled || !isMobileOrTabletDevice() || isStandaloneDisplay() || pwaDismissedRecently()) return;
    removePwaInstallCard();
    const card = document.createElement('aside');
    card.className = 'gba__pwa-card';
    card.setAttribute('data-pwa-install-card', '');
    sendPwaTrackingEvent('prompt_shown');
    card.innerHTML = `<button type="button" class="gba__pwa-card-close" aria-label="${escapeHtml(tr('pwa.card.close'))}" data-pwa-dismiss>×</button><div class="gba__pwa-card-icon" aria-hidden="true">▣</div><div class="gba__pwa-card-copy"><strong>${escapeHtml(tr('pwa.card.title'))}</strong><p>${escapeHtml(tr('pwa.card.text'))}</p></div><button type="button" class="gba__button gba__pwa-card-button" data-pwa-install>${escapeHtml(tr('pwa.card.button'))}</button>`;
    const resetButton = result.querySelector('[data-reset]');
    if (resetButton) result.insertBefore(card, resetButton);
    else result.appendChild(card);
    card.querySelector('[data-pwa-install]').addEventListener('click', event => handlePwaInstall(event.currentTarget));
    card.querySelector('[data-pwa-dismiss]').addEventListener('click', () => {
      try { window.localStorage.setItem('gbaPwaDismissedAt', String(Date.now())); } catch (error) {}
      sendPwaTrackingEvent('prompt_dismissed');
      card.remove();
    });
  }

  function schedulePwaInstallCard() {
    window.setTimeout(showPwaInstallCard, 180);
  }

  function showZoneResult() {
    setPanelView(null);
    const matches = state.zoneMatches || [];
    state.step = 'zoneResult';
    panel.hidden = true;
    result.hidden = false;
    updateSteps(3, 'zone');
    if (greenCard) greenCard.hidden = !matches.length;
    if (blueCard) blueCard.hidden = true;
    renderZoneFacts(matches);
    heading.innerHTML = tr('zone.result.title');
    const dataVersion = ZONES.dataVersion || '13.11.2023';
    if (matches.length) {
      setResultView('zone-found');
      setOutcome('🟢', tr('zone.found.status'), tr('zone.found.permission'));
      const zoneNames = uniqueJoined(matches.map(z => z.name));
      state.destinationMapZones = matches.slice(); state.destinationMapCenter = destinationMapPayload().center; state.destinationMapDirect = true;
      reason.innerHTML = `<p class="gba__zone-recommendation-text">${tr('zone.recommendation.found')}</p><p class="gba__zone-note-text">${tr('zone.note.found').replace('{date}', escapeHtml(dataVersion))}</p>${renderRouteSource()}<div class="gba__zone-actions"><button type="button" class="gba__button" data-zone-map>${tr('zone.map.button.direct')}</button><button type="button" class="gba__button" data-zone-start-vehicle>${tr('zone.cta.vehicle')}</button><button type="button" class="gba__button gba__button--secondary" data-zone-another>${tr('zone.cta.another')}</button></div>`;
      trackAssistantEvent({
        'Assistent Modus': 'Reisezielprüfung',
        'Assistent Reiseziel': state.destinationQuery || '',
        'Assistent Ergebnis': 'Umweltzone gefunden',
        'Assistent Umweltzone': 'Ja',
        'Assistent Umweltzone Name': zoneNames,
        'Assistent Empfehlung': 'Grüne Umweltplakette',
        'Assistent Datenstand': dataVersion
      });
    } else {
      const isForeignDestination = isForeignDestinationQuery(state.destinationQuery);
      setResultView('zone-empty');
      setOutcome('⚪', isForeignDestination ? tr('zone.foreign.status') : tr('zone.notfound.status'), isForeignDestination ? tr('zone.foreign.permission') : tr('zone.notfound.permission'));
      const noteText = isForeignDestination ? tr('zone.foreign.note') : tr('zone.note.notfound').replace('{date}', escapeHtml(dataVersion));
      const nearbyZones = isForeignDestination ? [] : findNearbyZones(state.destinationQuery);
      const nearbyMarkup = isForeignDestination ? '' : renderNearbyZones(state.destinationQuery);
      state.destinationMapZones = nearbyZones.slice();
      state.destinationMapCenter = destinationMapPayload().center;
      state.destinationMapDirect = false;
      const mapButtonMarkup = nearbyZones.length ? `<button type="button" class="gba__button" data-zone-map>${tr('zone.map.button.nearby')}</button>` : '';
      reason.innerHTML = `<p>${noteText}</p>${nearbyMarkup}${isForeignDestination ? '' : renderRouteSource()}<div class="gba__zone-actions">${mapButtonMarkup}<button type="button" class="gba__button" data-zone-start-vehicle>${tr('zone.cta.vehiclePrecaution')}</button><button type="button" class="gba__button gba__button--secondary" data-zone-another>${tr('zone.cta.another')}</button></div>`;
      const nearbyNames = isForeignDestination ? '' : uniqueJoined(nearbyZones.map(z => z.name));
      trackAssistantEvent({
        'Assistent Modus': 'Reisezielprüfung',
        'Assistent Reiseziel': state.destinationQuery || '',
        'Assistent Ergebnis': isForeignDestination ? 'Ziel außerhalb Deutschland' : 'Keine Umweltzone gefunden',
        'Assistent Umweltzone': 'Nein',
        'Assistent nahe Umweltzonen': nearbyNames,
        'Assistent Empfehlung': 'Fahrzeugprüfung optional',
        'Assistent Datenstand': dataVersion
      });
    }
    bindZoneResultActions();
    schedulePwaInstallCard();
  }
  function isElectricLike(){ return state.fuel === 'electric' || state.fuel === 'hydrogen'; }
  function isForeignHeavyVehicle(){ return ['truck','van','bus','camper'].includes(state.vehicle); }
  function parseDate(value){ if(!value) return null; const d = new Date(value + 'T00:00:00'); return Number.isNaN(d.getTime()) ? null : d; }
  function onOrAfter(dateValue, limit){ const d = parseDate(dateValue); return d ? d >= new Date(limit + 'T00:00:00') : false; }
  function inList(value, list){ return Array.isArray(list) && list.includes(value); }
  function inRange(code, from, to){ return code.length === from.length && code.localeCompare(from) >= 0 && code.localeCompare(to) <= 0; }
  function germanRulePath(){ const prefix = (state.emission||'').toUpperCase().slice(0,2); const p = RULES.germany?.decisionByEmissionPrefix || {}; if(p.passenger?.includes(prefix)) return 'passenger'; if(p.heavy?.includes(prefix)) return 'heavy'; return 'special'; }
  function classifyAlphanumericEmission(full){
    const prefix = (full || '').toUpperCase().slice(0,2);
    if(!['04','06'].includes(prefix)) return 'manual';
    const suffix = (full || '').toUpperCase().slice(-2);
    const rules = RULES.germanEmissionKeys?.alphanumericGreenSuffixes;
    if(!rules || suffix.length !== 2) return 'manual';
    if(rules.singles?.includes(suffix)) return 'green';
    if(inRange(suffix, rules.letterZeroFrom, rules.letterZeroTo)) return 'green';
    if(inRange(suffix, rules.zRangeFrom, rules.zRangeTo)) return 'green';
    return 'manual';
  }
  function resultRank(r){ return {none:0, red:1, yellow:2, green:3, manual:-1}[r] ?? -1; }
  function bestResult(a,b){ return resultRank(b)>resultRank(a) ? b : a; }
  function labelForResult(r){ return tr('label.' + r); }

  function render(){
    if (!state.mode) {
      renderStartChoice();
      return;
    }
    if (state.mode === 'zone') {
      if (state.step === 'zoneChoice') renderZoneChoice();
      else if (state.step === 'routeInput') renderRouteInput();
      else renderZoneInput();
      return;
    }
    if (state.step === 'vehicleChoice') {
      renderVehicleEntryChoice();
      return;
    }
    hideUploadStage();
    next.textContent = tr('buttons.next');
    setPanelView('vehicle');
    result.hidden = true; panel.hidden = false; updateSteps(Math.min(Number(state.step),5), 'vehicle'); back.hidden = false;
    if(state.step===1){ title.textContent=tr('v7.country.first.title'); sub.textContent=tr('v7.country.first.sub'); content.innerHTML=cardGrid(countries,'country'); next.hidden=true; }
    if(state.step===2){ title.textContent=tr('q.vehicle.title'); sub.textContent=tr('q.vehicle.sub'); content.innerHTML=cardGrid(vehicles,'vehicle'); next.hidden=true; }
    if(state.step===3){ title.textContent=tr('q.fuel.title'); sub.textContent=tr('q.fuel.sub'); content.innerHTML=cardGrid(fuels,'fuel'); next.hidden=true; }
    if(state.step===4){ renderDataStep(); next.hidden=false; }
    if(state.step===4.5){ renderPmStep(); next.hidden=false; }
    content.querySelectorAll('[data-pick]').forEach(btn => btn.addEventListener('click', () => {
      state[btn.dataset.pick]=btn.dataset.value;
      if (btn.dataset.pick === 'country') {
        state.plate = '';
        state.uploadProperties = {};
        state.uploadSkipped = false;
        state.vehicleId = '';
        state.vehicleEntryMethod = '';
        state.rdwData = null;
        state.rdwConfirmed = false;
        state.step = 'vehicleChoice';
        trackAssistantEvent({ 'Assistent Fahrzeugland': tr('country.' + state.country) });
        render();
        return;
      }
      if(btn.dataset.pick === 'vehicle') {
        if(state.vehicle==='motorcycle') return showNoBadge(tr('result.motorcycle'));
        if(state.vehicle==='oldtimer') return showNoBadge(tr('result.oldtimer'));
      }
      state.step++;
      render();
    }));
    content.querySelectorAll('[data-select]').forEach(sel => sel.addEventListener('change', () => state[sel.dataset.select]=sel.value));
  }

  function renderDataStep(){
    if(isElectricLike()){
      title.textContent=tr('q.de.title').replace('Emissionsschlüsselnummer', tr('steps.data'));
      sub.textContent=tr('notice.electric.sub');
      content.innerHTML=`<div class="gba__notice">${tr('notice.electric')}</div>`;
      return;
    }
    if(state.country==='DE'){
      title.textContent=tr('q.de.title'); sub.textContent=tr('q.de.sub');
      content.innerHTML=`<input class="gba__input" data-emission placeholder="z. B. 0433, 0460, 04A0 oder 06ZA" value="${state.emission||''}" autocapitalize="characters"><p class="gba__hint">${tr('hint.de')}</p><p class="gba__error" data-error hidden></p>`;
    } else {
      if(!state.euro) state.euro = 'e6';
      title.textContent=tr('q.foreign.title'); sub.textContent=tr('q.foreign.sub');
      content.innerHTML=`<label>${tr('field.euro')}</label>${selectHtml(euroClasses,'euro')}<br><br><label>${tr('field.firstReg')}</label><input class="gba__input" type="date" data-first-reg value="${state.firstReg||''}"><p class="gba__hint">${tr('hint.foreign')}</p><p class="gba__error" data-error hidden></p>`;
    }
    bindDataInputs();
  }
  function renderPmStep(){
    title.textContent=tr('q.pm.title'); sub.textContent=tr('q.pm.sub');
    const summary = `<div class="gba__data-summary"><strong>${tr('summary.input')}:</strong><br>${tr('summary.emission')}: ${state.emission}<br>${tr('summary.base')}: ${labelForResult(state.baseResult)}</div>`;
    content.innerHTML = summary + `<label>${tr('field.pm')}</label>${selectHtml(pmLevels,'pm')}<p class="gba__hint">${tr('hint.pm')}</p><p class="gba__error" data-error hidden></p>`;
    content.querySelectorAll('[data-select]').forEach(sel => sel.addEventListener('change', () => state[sel.dataset.select]=sel.value));
  }
  function bindDataInputs(){
    const emission = content.querySelector('[data-emission]');
    if(emission) emission.addEventListener('input', e => { state.emission=e.target.value.toUpperCase().replace(/[^0-9A-Z]/g,'').slice(0,4); e.target.value = state.emission; });
    const first = content.querySelector('[data-first-reg]'); if(first) first.addEventListener('input', e => state.firstReg=e.target.value);
    content.querySelectorAll('[data-select]').forEach(sel => sel.addEventListener('change', () => state[sel.dataset.select]=sel.value));
  }

  function classifyGermanEmissionWithoutPm(){
    if(isElectricLike()) return 'green';
    if(state.fuel !== 'diesel') return 'green';
    const full = (state.emission||'').toUpperCase();
    if(full.length < 4) return 'manual';
    const path = germanRulePath();
    if(path === 'special') return 'manual';
    const key = full.slice(-2);
    if(/[A-Z]/.test(full)) return classifyAlphanumericEmission(full);
    const rules = path === 'heavy' ? RULES.germanEmissionKeys?.heavyDiesel : RULES.germanEmissionKeys?.passengerDiesel;
    if(inList(key, rules?.green)) return 'green';
    if(inList(key, rules?.yellow)) return 'yellow';
    if(inList(key, rules?.red)) return 'red';
    if(inList(key, rules?.none)) return 'none';
    return 'manual';
  }
  function classifyGermanWithPm(){
    const base = state.baseResult || classifyGermanEmissionWithoutPm();
    if(base === 'green' || state.fuel !== 'diesel') return base;
    const pm = state.pm;
    if(!pm || pm === 'unknown') return 'manual';
    if(pm === 'none') return base;
    const path = germanRulePath();
    if(path !== 'passenger') return 'manual';
    const key = (state.emission||'').toUpperCase().slice(-2);
    const pmRules = RULES.pmPassengerDiesel || {};
    if(pmRules.green?.[pm] === '*' || inList(key, pmRules.green?.[pm])) return 'green';
    if(inList(key, pmRules.yellow?.[pm])) return bestResult(base, 'yellow');
    if(inList(key, pmRules.red?.[pm])) return bestResult(base, 'red');
    return 'manual';
  }
  function classifyForeign(){
    if(isElectricLike()) return 'green';
    if(state.euro && state.euro !== 'unknown'){
      if(state.fuel === 'diesel'){
        if(['e4','e5','e6'].includes(state.euro)) return 'green';
        state.manualReason = tr('result.foreignDieselManual');
        return 'manual';
      }
      return 'green';
    }
    if(state.firstReg){
      if(state.fuel === 'diesel'){
        const dateRules = isForeignHeavyVehicle() ? RULES.foreignFirstRegistration?.dieselHeavy : RULES.foreignFirstRegistration?.dieselPassenger;
        if(onOrAfter(state.firstReg, dateRules.greenFrom)) return 'green';
        state.manualReason = tr('result.foreignDieselManual');
        return 'manual';
      }
      const petrolRules = RULES.foreignFirstRegistration?.petrol;
      return onOrAfter(state.firstReg, petrolRules.greenFrom) ? 'green' : 'none';
    }
    return 'manual';
  }
  function compute(){
    state.manualReason='';
    if (state.vehicleEntryMethod === 'rdw' && state.rdwConfirmed && state.rdwData?.green?.status) {
      const rdwStatus = state.rdwData.green.status;
      return ['green','manual','none'].includes(rdwStatus) ? rdwStatus : 'manual';
    }
    return state.country === 'DE' ? classifyGermanWithPm() : classifyForeign();
  }
  function detailRows(resultValue){
    const rows = [];
    if(state.plate) rows.push([plateFieldLabel(), state.plate]);
    if(hasAssistantUpload()) rows.push([tr('v7.upload.fact'), tr('v7.upload.factReady')]);
    if(state.vehicleEntryMethod === 'rdw' && state.rdwData){
      const rdwName = [state.rdwData.make, state.rdwData.model].filter(Boolean).join(' ');
      if(rdwName) rows.push([tr('v711.rdw.vehicle'), rdwName]);
      if(state.rdwData.electric_range_km != null && state.fuel === 'phev') rows.push([tr('v711.rdw.range'), `${formatRdwNumber(state.rdwData.electric_range_km)} km`]);
      if(state.rdwData.co2_g_km != null && state.fuel === 'phev') rows.push([tr('v711.rdw.co2'), `${formatRdwNumber(state.rdwData.co2_g_km)} g/km`]);
    }
    if(state.country) rows.push([tr('steps.country'), tr('country.' + state.country)]);
    if(state.vehicle) rows.push([tr('steps.vehicle'), tr('vehicle.' + state.vehicle)]);
    if(state.fuel) rows.push([tr('steps.fuel'), tr('fuel.' + state.fuel)]);
    if(state.country === 'DE' && state.emission) rows.push([tr('summary.emission'), state.emission]);
    if(state.country !== 'DE'){
      if(state.euro && state.euro !== 'unknown') rows.push([tr('field.euro'), tr('euro.' + state.euro)]);
      if(state.firstReg) rows.push([tr('field.firstReg'), state.firstReg]);
    }
    if(state.pm && state.pm !== 'unknown') rows.push([tr('field.pm'), tr('pm.' + state.pm)]);
    if(resultValue === 'green') rows.push([tr('result.facts.result'), tr('label.green')]);
    return rows;
  }
  function renderFacts(resultValue){
    if(!resultFacts) return;
    resultFacts.innerHTML = detailRows(resultValue).map(([k,v]) => `<li><span>✓</span><strong>${k}:</strong> ${v}</li>`).join('');
  }
  function setOutcome(icon, statusText, permissionText){
    if(resultIcon) resultIcon.textContent = icon;
    if(resultStatus) resultStatus.textContent = statusText;
    if(resultPermission) resultPermission.textContent = permissionText;
  }
  function showNoBadge(msg){
    state.lastVehicleResult = 'none';
    hideUploadStage();
    setPanelView(null);
    setResultView('vehicle');
    panel.hidden=true; result.hidden=false; updateSteps(5); greenCard.hidden=true; blueCard.hidden=true;
    heading.innerHTML=tr('result.recommendation.title');
    renderFacts('none');
    setOutcome('⚪', tr('result.noBadge.heading'), msg);
    reason.textContent=tr('result.notice.after_order');
    trackAssistantEvent({
      'Assistent Modus': 'Fahrzeugprüfung',
      'Assistent Fahrzeugart': state.vehicle ? tr('vehicle.' + state.vehicle) : '',
      'Assistent Ergebnis': 'Keine Umweltplakette erforderlich',
      'Assistent Empfehlung': 'Keine Bestellung empfohlen'
    });
    schedulePwaInstallCard();
  }
  function showResult(){
    setPanelView(null);
    setResultView('vehicle');
    const r = compute();
    state.lastVehicleResult = r;
    hideUploadStage();
    panel.hidden=true; result.hidden=false; updateSteps(5);
    renderFacts(r);
    trackAssistantEvent({
      'Assistent Modus': 'Fahrzeugprüfung',
      'Assistent Fahrzeugland': state.country ? tr('country.' + state.country) : '',
      'Assistent Fahrzeugart': state.vehicle ? tr('vehicle.' + state.vehicle) : '',
      'Assistent Antrieb': state.fuel ? tr('fuel.' + state.fuel) : '',
      'Assistent Ergebnis': r === 'green' ? 'Grüne Umweltplakette möglich' : (r === 'manual' ? 'Manuelle Prüfung empfohlen' : 'Keine grüne Umweltplakette möglich'),
      'Assistent Empfehlung': r === 'green' ? 'Grüne Umweltplakette' : (r === 'manual' ? 'Manuelle Prüfung' : 'Keine Bestellung empfohlen')
    });
    heading.innerHTML=tr('result.recommendation.title');
    const rdwBlueEligible = state.vehicleEntryMethod === 'rdw' && state.rdwConfirmed
      ? state.rdwData?.blue?.status === 'eligible'
      : null;
    blueCard.hidden = rdwBlueEligible === null
      ? !(state.country!=='DE' && (state.fuel==='electric' || state.fuel==='hydrogen' || state.fuel==='phev'))
      : !rdwBlueEligible;
    if(r==='green') {
      greenCard.hidden=false;
      setOutcome('🟢', tr('result.green.status'), tr('result.green.permission'));
      reason.textContent=tr('result.notice.after_order');
    } else {
      greenCard.hidden=true;
      blueCard.hidden = true;
      const icon = r === 'yellow' ? '🟡' : r === 'red' ? '🔴' : r === 'manual' ? '🟠' : '⚪';
      const statusText = r==='manual' ? tr('result.manual.status') : tr('result.noGreen.status');
      const permissionText = r==='manual' ? (state.manualReason || tr('result.manual.reason')) : tr('result.noGreen.reason').replace('{badge}', labelForResult(r));
      setOutcome(icon, statusText, permissionText);
      reason.textContent = r==='manual' ? tr('result.notice.manual') : tr('result.notice.no_order');
    }
    updateProductButtonModes();
    schedulePwaInstallCard();
  }
  function showStepSelectionError(message) {
    let err = content.querySelector('[data-step-error]');
    if (!err) {
      err = document.createElement('p');
      err.className = 'gba__error';
      err.setAttribute('data-step-error', '');
      content.appendChild(err);
    }
    err.hidden = false;
    err.textContent = message || tr('error.required');
  }
  function blockInvalidNext() {
    if (!state.mode) return true;
    if (state.mode === 'zone') return true;
    if (state.step === 1 && !state.country) { showStepSelectionError(tr('error.required.country')); return true; }
    if (state.step === 2 && !state.vehicle) { showStepSelectionError(tr('error.required.vehicle')); return true; }
    if (state.step === 3 && !state.fuel) { showStepSelectionError(tr('error.required.fuel')); return true; }
    if (Number(state.step) >= 4 && (!state.country || !state.vehicle || !state.fuel)) {
      state.step = !state.country ? 1 : (!state.vehicle ? 2 : 3);
      render();
      return true;
    }
    return false;
  }
  next.addEventListener('click', () => {
        if (blockInvalidNext()) return;
    if(state.step===4){
      const emissionField = content.querySelector('[data-emission]');
      if(emissionField) state.emission = emissionField.value.toUpperCase().replace(/[^0-9A-Z]/g,'').slice(0,4);
      const euroSelect = content.querySelector('[data-select="euro"]');
      if(euroSelect) state.euro = euroSelect.value;
      const firstField = content.querySelector('[data-first-reg]');
      if(firstField) state.firstReg = firstField.value;
      const err=content.querySelector('[data-error]');
      if(state.country==='DE' && !isElectricLike() && (!state.emission || state.emission.length<4)){
        if(err){err.hidden=false;err.textContent=tr('error.emission');}
        return;
      }
      if(state.country!=='DE' && !isElectricLike() && (!state.euro || state.euro==='unknown') && !state.firstReg){
        if(err){err.hidden=false;err.textContent=tr('error.foreign');}
        return;
      }
      if(state.country==='DE' && state.fuel==='diesel'){
        state.baseResult = classifyGermanEmissionWithoutPm();
        if(['none','red','yellow','manual'].includes(state.baseResult)){
          state.step = 4.5;
          render();
          return;
        }
      }
      showResult(); return;
    }
    if(state.step===4.5){
      const pmSelect = content.querySelector('[data-select="pm"]');
      if(pmSelect) state.pm = pmSelect.value;
      showResult(); return;
    }
    state.step++; render();
  });
  back.addEventListener('click', () => {
    if (!state.mode) { resetToStart(); render(); return; }
    if (state.mode === 'zone') {
      if (state.step === 'zoneChoice') { resetToStart(); render(); return; }
      state.step = 'zoneChoice';
      state.zoneMode = null;
      state.routeData = null;
      state.routeZones = [];
      render();
      return;
    }
    if (state.mode === 'vehicle' && state.step === 'vehicleChoice') { state.step = 1; hideUploadStage(); render(); return; }
    if (state.mode === 'vehicle' && Number(state.step) === 1) { resetToStart(); render(); return; }
    if (state.mode === 'vehicle' && Number(state.step) === 2) { state.step = 'vehicleChoice'; render(); return; }
    if(state.step===4.5){ state.step=4; } else { state.step=Math.max(2,state.step-1); }
    render();
  });
  if(reset) reset.addEventListener('click', () => { resetToStart(); render(); });

  if (manualStart) {
    manualStart.addEventListener('click', () => {
      state.plate = '';
      state.uploadProperties = {};
      state.uploadSkipped = true;
      state.vehicleId = '';
      state.vehicleEntryMethod = 'manual';
      state.rdwData = null;
      state.rdwConfirmed = false;
      state.step = 2;
      trackAssistantEvent({
        'Assistent Fahrzeugprüfung Einstieg': 'Manuelle Eingabe',
        'Assistent Dokument': 'Kein Upload im Assistenten'
      });
      render();
    });
  }

  if (uploadStart) {
    uploadStart.addEventListener('click', () => {
      if (window.GreenBadgeAssistantSettings?.assistantUploadEnabled !== true) return;
      if (!captureUploadStage()) return;
      state.vehicleEntryMethod = 'upload';
      state.rdwData = null;
      state.rdwConfirmed = false;
      state.step = 2;
      trackAssistantEvent({ 'Assistent Fahrzeugprüfung Einstieg': 'Fahrzeugschein-Upload' });
      render();
    });
  }

  function formatRdwDate(value) {
    if (!value) return '';
    const parts = String(value).split('-');
    if (parts.length !== 3) return String(value);
    try { return new Intl.DateTimeFormat(localeRaw || locale || 'de-DE').format(new Date(`${value}T00:00:00`)); }
    catch (error) { return `${parts[2]}.${parts[1]}.${parts[0]}`; }
  }
  function formatRdwNumber(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';
    try { return new Intl.NumberFormat(localeRaw || locale || 'de-DE', { maximumFractionDigits: 1 }).format(number); }
    catch (error) { return String(Math.round(number * 10) / 10); }
  }
  function rdwVehicleName(data) {
    return [data?.make, data?.model].filter(Boolean).join(' ').trim() || tr('v711.rdw.vehicle');
  }
  function rdwApiUrl() {
    return String(window.GreenBadgeAssistantSettings?.rdwApiUrl || '').trim();
  }
  function renderRdwLookupResult(data) {
    if (!rdwResultBox || !rdwResultFacts) return;
    const facts = [];
    facts.push([tr('v711.rdw.vehicle'), rdwVehicleName(data)]);
    if (data.vehicle_type && data.vehicle_type !== 'unknown') facts.push([tr('v711.rdw.type'), tr('vehicle.' + data.vehicle_type)]);
    if (data.fuel_type && data.fuel_type !== 'unknown') facts.push([tr('v711.rdw.fuel'), tr('fuel.' + data.fuel_type)]);
    if (data.first_registration) facts.push([tr('v711.rdw.firstReg'), formatRdwDate(data.first_registration)]);
    if (data.euro_class) facts.push([tr('v711.rdw.euro'), data.euro_class]);
    if (data.electric_range_km != null && data.fuel_type === 'phev') facts.push([tr('v711.rdw.range'), `${formatRdwNumber(data.electric_range_km)} km`]);
    if (data.co2_g_km != null && data.fuel_type === 'phev') facts.push([tr('v711.rdw.co2'), `${formatRdwNumber(data.co2_g_km)} g/km`]);
    rdwResultFacts.innerHTML = facts.map(([key, value]) => `<li><strong>${escapeHtml(key)}:</strong> ${escapeHtml(value)}</li>`).join('');
    rdwResultBox.hidden = false;
  }
  function useManualRdwFallback() {
    state.rdwData = null;
    state.rdwConfirmed = false;
    state.vehicleEntryMethod = 'manual';
    state.uploadProperties = {};
    state.uploadSkipped = true;
    state.vehicleId = '';
    state.step = 2;
    trackAssistantEvent({ 'Assistent Fahrzeugprüfung Einstieg': 'RDW-Fallback manuell' });
    render();
  }
  async function lookupRdwVehicle() {
    const plate = cleanPlateInput(rdwPlateInput ? rdwPlateInput.value : state.plate);
    if (!plate) {
      if (rdwError) { rdwError.textContent = tr('v7.rdw.errorPlate'); rdwError.hidden = false; }
      if (rdwPlateInput) rdwPlateInput.focus();
      return;
    }
    const endpoint = rdwApiUrl();
    if (!endpoint) {
      if (rdwError) { rdwError.textContent = tr('v711.rdw.errorNetwork'); rdwError.hidden = false; }
      return;
    }
    if (rdwError) rdwError.hidden = true;
    if (rdwResultBox) rdwResultBox.hidden = true;
    rdwStart.disabled = true;
    rdwStart.classList.add('is-loading');
    const originalText = rdwStart.textContent;
    rdwStart.textContent = tr('v711.rdw.loading');
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ plate, language: localeRaw || locale || 'nl' })
      });
      const payload = await response.json().catch(() => null);
      if (!response.ok || !payload?.ok || !payload?.vehicle) {
        const code = payload?.error?.code || '';
        const message = code === 'NOT_FOUND' || response.status === 404
          ? tr('v711.rdw.errorNotFound')
          : (code === 'INCOMPLETE' ? tr('v711.rdw.errorIncomplete') : tr('v711.rdw.errorNetwork'));
        throw Object.assign(new Error(message), { userMessage: message });
      }
      state.plate = plate;
      state.uploadProperties = {};
      state.uploadSkipped = true;
      state.vehicleEntryMethod = 'rdw_pending';
      state.vehicleId = state.vehicleId || createVehicleId();
      state.rdwData = payload.vehicle;
      state.rdwConfirmed = false;
      renderRdwLookupResult(payload.vehicle);
      trackAssistantEvent({
        'Assistent Fahrzeugprüfung Einstieg': 'RDW-Kennzeichenabfrage',
        'Assistent Kennzeichen erfasst': 'Ja',
        'Assistent Fahrzeugreferenz': state.vehicleId,
        'Assistent Dokument': 'Kein Upload - RDW'
      });
    } catch (error) {
      if (rdwError) { rdwError.textContent = error.userMessage || tr('v711.rdw.errorNetwork'); rdwError.hidden = false; }
    } finally {
      rdwStart.disabled = false;
      rdwStart.classList.remove('is-loading');
      rdwStart.textContent = originalText || tr('v7.rdw.button');
    }
  }
  if (rdwStart) rdwStart.addEventListener('click', lookupRdwVehicle);
  if (rdwConfirm) {
    rdwConfirm.addEventListener('click', () => {
      const data = state.rdwData;
      if (!data) return;
      state.vehicleEntryMethod = 'rdw';
      state.rdwConfirmed = true;
      state.vehicle = data.vehicle_type || 'unknown';
      state.fuel = data.fuel_type || 'unknown';
      state.euro = data.euro_code || 'unknown';
      state.firstReg = data.first_registration || '';
      state.emission = '';
      state.pm = null;
      state.baseResult = null;
      trackAssistantEvent({
        'Assistent Fahrzeugprüfung Einstieg': 'RDW automatisch',
        'Assistent Fahrzeugart': state.vehicle !== 'unknown' ? tr('vehicle.' + state.vehicle) : '',
        'Assistent Antrieb': state.fuel !== 'unknown' ? tr('fuel.' + state.fuel) : ''
      });
      showResult();
    });
  }
  if (rdwManual) rdwManual.addEventListener('click', useManualRdwFallback);


  function rememberBlueEligiblePlate(plate) {
    const cleaned = String(plate || '').replace(/\s+/g, ' ').trim();
    if (!cleaned) return;
    try {
      const key = 'gbBlueEligiblePlates';
      let values = [];
      const raw = window.sessionStorage.getItem(key);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) values = parsed;
      }
      const normalized = cleaned.toUpperCase().replace(/[^A-Z0-9]/g, '');
      values = values.filter((value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '') !== normalized);
      values.push(cleaned);
      window.sessionStorage.setItem(key, JSON.stringify(values.slice(-12)));
    } catch (error) {}
  }

  function cartAddUrlV7() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    const rootPath = window.Shopify?.routes?.root || '/';
    return rootPath.replace(/\/?$/, '/') + 'cart/add.js';
  }
  function cartUrlV7() {
    if (window.routes && window.routes.cart_url) return window.routes.cart_url;
    const rootPath = window.Shopify?.routes?.root || '/';
    return rootPath.replace(/\/?$/, '/') + 'cart';
  }
  function vehiclePayload(resultValue) {
    return {
      version: GB_ASSISTANT_VERSION,
      vehicle_id: state.vehicleId,
      plate: state.plate,
      registration_country: state.country || '',
      vehicle_type: state.vehicle || '',
      fuel: state.fuel || '',
      emission_key: state.emission || '',
      euro_class: state.euro || '',
      first_registration: state.firstReg || '',
      pm_level: state.pm || '',
      result: resultValue || state.lastVehicleResult || '',
      source: 'uploadkit_assistant'
    };
  }
  function rdwOrderVehicleSummary() {
    if (!state.rdwData) return '';
    const parts = [rdwVehicleName(state.rdwData)];
    if (state.fuel && state.fuel !== 'unknown') parts.push(tr('fuel.' + state.fuel));
    if (state.firstReg) parts.push(formatRdwDate(state.firstReg));
    return parts.filter(Boolean).join(' · ');
  }
  function rdwOrderResultSummary() {
    if (!state.rdwData) return '';
    const greenStatus = state.rdwData.green?.status || 'manual';
    const blueStatus = state.rdwData.blue?.status || 'not_eligible';
    const parts = [greenStatus === 'green' ? tr('v711.order.greenYes') : (greenStatus === 'none' ? tr('v711.order.greenNo') : tr('v711.order.greenManual'))];
    if (state.fuel === 'electric' || state.fuel === 'phev') {
      parts.push(blueStatus === 'eligible' ? tr('v711.order.blueYes') : (blueStatus === 'manual' ? tr('v711.order.blueManual') : tr('v711.order.blueNo')));
      if (state.fuel === 'phev') {
        const proof = [];
        if (state.rdwData.electric_range_km != null) proof.push(`${formatRdwNumber(state.rdwData.electric_range_km)} km`);
        if (state.rdwData.co2_g_km != null) proof.push(`${formatRdwNumber(state.rdwData.co2_g_km)} g CO₂/km`);
        if (proof.length) parts.push(proof.join(' / '));
      }
    }
    return parts.join(' · ');
  }
  function hasDirectAssistantData() {
    return hasAssistantUpload() || (state.vehicleEntryMethod === 'rdw' && state.rdwConfirmed && !!state.rdwData && !!state.plate);
  }
  function buildAssistantLineItemProperties(resultValue) {
    const properties = {};
    properties[plateFieldLabel()] = state.plate;
    Object.entries(state.uploadProperties || {}).forEach(([key, value]) => {
      const propertyKey = String(key || '').trim();
      const propertyValue = String(value || '').trim();
      if (!propertyKey || !propertyValue) return;
      if (propertyKey.startsWith('_') || /direct link/i.test(propertyKey)) return;
      if (isUploadKitUrl(propertyValue)) properties[propertyKey] = propertyValue;
    });
    if (state.vehicleEntryMethod === 'rdw' && state.rdwConfirmed && state.rdwData) {
      properties[tr('v711.order.vehicleLabel')] = rdwOrderVehicleSummary();
      if (state.rdwData.euro_class) {
        properties[`RDW ${tr('v711.rdw.euro')}`] = state.rdwData.euro_class;
      }
      properties[tr('v711.order.resultLabel')] = rdwOrderResultSummary();
    }
    return properties;
  }
  function updateProductButtonModes() {
    root.querySelectorAll('[data-gba-product]').forEach(button => {
      if (!button.dataset.gbaDefaultText) button.dataset.gbaDefaultText = button.textContent.trim();
      button.textContent = hasDirectAssistantData() ? tr('v7.order.withData') : button.dataset.gbaDefaultText;
    });
  }
  function showDirectCartError(button, message) {
    const card = button.closest('.gba__product-card') || button.parentElement;
    if (!card) return;
    let error = card.querySelector('[data-gba-direct-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'gba__error gba__direct-cart-error';
      error.setAttribute('data-gba-direct-cart-error', '');
      card.appendChild(error);
    }
    error.textContent = message || tr('v7.order.error');
    error.hidden = false;
  }
  async function addAssistantProductToCart(key, button) {
    const variantId = Number(window.GreenBadgeAssistantSettings?.variantIds?.[key]);
    if (!hasDirectAssistantData()) return false;
    if (!variantId) {
      showDirectCartError(button, tr('v7.order.error'));
      return false;
    }
    const originalText = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = tr('v7.order.adding');
    try {
      if (key === 'green' && blueCard && !blueCard.hidden) {
        try { window.sessionStorage.setItem('gbBlueRecommended', '1'); } catch (error) {}
        rememberBlueEligiblePlate(state.plate);
      }
      const response = await fetch(cartAddUrlV7(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: buildAssistantLineItemProperties(state.lastVehicleResult)
          }]
        })
      });
      if (!response.ok) throw new Error('Cart add failed: ' + response.status);
      const isRdwOrder = state.vehicleEntryMethod === 'rdw' && state.rdwConfirmed;
      await persistAssistantAttributes({
        'Assistent Produkt geklickt': key === 'green' ? 'Grüne Umweltplakette' : 'Blaue E-Plakette',
        'Assistent Fahrzeugprüfung Einstieg': isRdwOrder ? 'RDW automatisch' : 'Fahrzeugschein-Upload',
        'Assistent Dokument': isRdwOrder ? 'Kein Upload - RDW' : 'UploadKit im Assistenten abgeschlossen',
        'Assistent Kaufweg': isRdwOrder ? 'Direkt aus Assistent mit RDW-Daten' : 'Direkt aus Assistent mit UploadKit-Dokument',
        'Assistent Fahrzeugreferenz': state.vehicleId,
        'Assistent Dokumentübergabe': isRdwOrder ? 'Nicht erforderlich - RDW' : 'Ja'
      });
      window.location.href = cartUrlV7();
      return true;
    } catch (error) {
      console.error('V7 direct cart:', error);
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = originalText;
      showDirectCartError(button, tr('v7.order.error'));
      return false;
    }
  }

  const heroBuyButton = root.querySelector('[data-gba-hero-buy]');
  if (heroBuyButton) {
    heroBuyButton.addEventListener('click', async (event) => {
      const targetUrl = heroBuyButton.getAttribute('href') || '/products/feinstaubplakette';
      event.preventDefault();
      await persistAssistantAttributes({
        'Assistent Modus': 'Start-Direktkauf',
        'Assistent Ergebnis': 'Grüne Umweltplakette direkt gewählt',
        'Assistent Produkt geklickt': 'Grüne Umweltplakette',
        'Assistent Klick Ziel': targetUrl
      });
      window.location.href = targetUrl;
    });
  }

  root.querySelectorAll('[data-gba-product]').forEach(button => {
    button.addEventListener('click', async () => {
      const key = button.dataset.gbaProduct;
      const url = window.GreenBadgeAssistantSettings?.urls?.[key];
      if (!url) return;

      if (hasDirectAssistantData()) {
        await addAssistantProductToCart(key, button);
        return;
      }

      let targetUrl = url;

      if (key === 'green') {
        const blueCard = root.querySelector('[data-blue-card]');
        const blueIsRecommended = blueCard && !blueCard.hidden;

        if (blueIsRecommended) {
          try {
            window.sessionStorage.setItem('gbBlueRecommended', '1');
          } catch (error) {}
          rememberBlueEligiblePlate(state.plate);

          try {
            const enrichedUrl = new URL(url, window.location.origin);
            enrichedUrl.searchParams.set('gb_blue_recommended', '1');
            targetUrl = enrichedUrl.toString();
          } catch (error) {
            targetUrl = url + (url.includes('?') ? '&' : '?') + 'gb_blue_recommended=1';
          }
        }
      }

      await persistAssistantAttributes({
        'Assistent Produkt geklickt': key === 'green' ? 'Grüne Umweltplakette' : 'Blaue E-Plakette',
        'Assistent Klick Ziel': targetUrl
      });
      window.location.href = targetUrl;
    });
  });


  setupPwaMetadata();
  trackStandalonePwaLaunch();
  render();
})();
